import {
  COLOURED_FINISH,
  COOL,
  GLOSS_FINISH,
  GREY,
  MATT_FINISH,
  NATURAL_FINISH,
  NEUTRAL,
  WARM,
} from "../constants/constants";

export const configuratorData1 = {
  tokenUrl: "109a2d10-20c7-50bd-98ed-70558cd98dad",
  id: 1,
  name: "Asian Paints Dining",
};

export const layoutData1 = [
  {
    configuratorId: 1,
    id: 1,
    name: "Dining",
    thumb:
      "https://media.imagine.io/media/public/cfg/4327/6863/1025/scene/1507/thumbnail/2c9a6675_assetbundles/thumbnail/diningtable11.jpg?Expires=1711695183&Signature=ODDMM8QvIbFG836Mt86~89xWXXFtqA28g8HnNbJyRz3LQ89wv8dZjnc6dhlYPmarKU0gp1dYtRwUZXbspas8FEkB-6qOjpksnC~~UDAozI1gKr9ZmginFOk44xE4ZJyrw8~PQCJeN6h-md08y41VWnFMbsbUXqhLMhE4VZmv-uWZ3SW-zhVvfb1avuWJLCYw8GCNWsOX4EFiA~N12djq1yuXhOaUnY2H2JogQX7~PRS~B0UwtJW2oYmOSg~0H1g5hIiMfXog6xmTcQIpJgAROk35Kl~DKyOE~ieHzlGANuuHCo-QBvxUfrsjh-8xJ6EhIDooA7AnIZKnKcnkujsM2Q__&Key-Pair-Id=K3MIEF79PIHRTH",
  },
];

export const profileData1 = [
  {
    configuratorId: 1,
    layoutId: 1,
    id: 1,
    name: "Profile",
    thumb:
      "https://media.imagine.io/media/public/cfg/4327/akram%40imagine.io/520/scene/657/thumbnail/bb835e14_product/thumbnail/19345/6/thumbnail_.jpg?Expires=1702100319&Signature=eRVl41ATzLraoGgbLYSw8QrN9uPFxQjvh4qUtQmle4IqaywulZTI1n25SZSUhRf9jxEW-b9f97Qaz7bJGNMuKw9gKbYoGvjuCNAcWcGdf4AAcCVUWMUDxb2WU3qH3jEja9ZEvmVentlK5jvT~0GDzoRDi9mJ44DwjwXI6qwWnDGiFA2hYPMU9xioCKZM5xogHre5XkqBREddSGcKrxFXSrZn-Iph8hU252BcRU0EhNMVHggjinFA9aSx8XKKmXZ89y54xqoMc6hducJpWav1eGnainNakn8DWhJElDAQVwaP8bk~RqwXuA3bnuHsXn1J5RUNyq7An~s2shcUt-MCGQ__&Key-Pair-Id=K3MIEF79PIHRTH",
  },
];

export const sceneData1 = [
  {
    id: 1600,
    name: "Dining Template 1",
    layoutId: 1,
    profileId: 1,
    thumb:
      "https://media.imagine.io/media/public/cfg/4327/mohit%40imagine.io/900/scene/1217/thumbnail/696b3afe_assetbundles/thumbnail/diningtable11.jpg?Expires=1710140506&Signature=cEOMgd~NgEIXhgpczP6wOSmpxTALLFfA3a2kUQRE33ShJXXk44Iz6KyBMK4D-6fvRmMUGhpeUvGY1MCIQAy5o-V~h~a27udrw6PKfaJlQZA8pvlqs~VW8qEhMO5Q0zGIuvHwfqCOM36R3W3rp1newbLclX8wAJSSsvOS3erAItl2TdsANF5yYZPJN9NJXOt5nwx3~UMSmoHzQxMN277-69MIsLDBHV5D9tvAPpQKTK0CKowEwszeeeudKtHGvYuOWa2JRjtEtmpayA8Dcx9vvdvJErFsjugYyutj7vm5D58vX6JwuintWCtmAvtqWtr4bUaXxpzYmKtK2UqXF5ZoQg__&Key-Pair-Id=K3MIEF79PIHRTH",
  },
];

export const hobspotLabel1 = [
  {
    id: "4114",
    name: "Dining Table",
    sceneId: "1600",
    startImage: "0",
    endImage: "4",
    storeId: "1008",
  },
  {
    id: "4113",
    name: "Wall Panel",
    sceneId: "1600",
    startImage: "0",
    endImage: "4",
    storeId: "1008",
  },
];

export const imageHubspotPosition1 = [
  {
    style: [
      { top: "60%", left: "50%" },
      { top: "25%", left: "15%" },
    ],
  },
  {
    style: [
      { top: "20%", left: "50%" },
      { top: "2%", left: "88%" },
    ],
  },
  {
    style: [
      { top: "60%", left: "50%" },
      { top: "25%", left: "15%" },
    ],
  },
  {
    style: [
      { top: "20%", left: "50%" },
      { top: "2%", left: "88%" },
    ],
  },
];

export const colorOptionList1 = [
  {
    name: "BL Wenge",
    code: "",
    render_id: 609470,
    scenetexturerender_id: "10680",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10680/a71df8a9_10680.jpg?Expires=1711702128&Signature=3m0wVDaAd6B8dRP3ShmXxV6bRu5wqnuu~OLMByuX84ydaZTwP7n1bMworZOjyLpU9pT2t72Ih9L8r7Ti3UDl6gkvodcy93GcywzpqL5TzBClwzRqzI7UwVGosHvEibpzNwA~XTZpyTaRV4zdYRsvGVovn8yuoR-jN4NcuYIL5Jkf~4EKyiAhoRJNSoMx7wK3hv2gnJ~n~XrEiX7PKMqI5svrb21uFbXC1HHMhyuDhezUkoXw-t1OfmIJTSsNBXx37A-1SSv-iIWy~PPEO9MwswVCJkhrTQBFonqayHUovYOxjExir7FZFneczExrobo~mYNsCY3wH9Yikm8SSHvCzA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40623,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "BL Wenge",
    code: "",
    render_id: 609483,
    scenetexturerender_id: "10688",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10688/ad58b92c_10688.jpg?Expires=1711702788&Signature=oivRTiB2qjpZIqh5xa0h7LK7M~gyEDaKJSu1SbeuBURZq9cOOTIzPI3U8vBcdw5XtmIP-KEp7lNvVnGSa5OD23ASsWD11r1QAES-scWvwM-lP9ZPZXulDsX9q01KuApZJgEw40ux8VD6iz6gfsXkuLlmfVeAgiNttUVo0WUx6hr9zj-3ptLL7qmaq-ffyUXk7kS11sjU2I8e7SE0VWkKoanIK3JEB0ti9o0Jg2N6fq-FwOJP7SSP-2TDJ86adkegohILdkRl1pQdSV07Bm-1gzYsOo4oJC8Wh3kBMsb0ue7D2ve0XKTsg3JCmlTod9Yb3TvUx0A1D3kFQW4hxBhngg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40530,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "BL Wenge",
    code: "",
    render_id: 609622,
    scenetexturerender_id: "10827",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10827/507d4255_10827.jpg?Expires=1711702375&Signature=n6CZYeB500H~M4dElEmCERzyvmN~47-8PgmDuXIL-ok8rXu2ewvEXtb~4d7rpWOL9D9NFGQ9~bvcTQySGG~aQxGHDRNTzz9YJc0Rpf2XZ-d3DKVXPxRAeDJ~XiLci88-4Ame6a-l-hWEHdCEXJGuciScOdZFqwb3gecCtvP91H-rXbLOABRD2rYxpClwWPuskprt685IhoBTp4oblVtPFC~MDghKCw25zmM7~TwPl-mChh~Jr8Pwk2efW3-YS~WudXU05iZxHnq3ycCjJ0TuQZT7QDRZikwzevEOSlrwxIJ8DdnvdeZiCVHcFaoLs8laqyKw4PjbtOOW1VI2EPmBGg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40690,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "BL Wenge",
    code: "",
    render_id: 609622,
    scenetexturerender_id: "10749",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10827/507d4255_10827.jpg?Expires=1711703024&Signature=lT4vLFEySZ8GD2mtc2wGlJZiiScOzwQgld6SDJxoeoUzoUV-aD2p1ZIKxt0Iy0Yi2kBg~qVyDPQW-C639lWi08TStRkhjIRlSa2mwmcK1zN9sqxNBpXoeyAsj~LXfmwQvVPTZZ0IC1muqo~8OjKzpVE7nYTFMk7lOxqidf2zXc3XnB10mJGkcBZN8SmABuiTDPZv-DZ-QGXtKbh4M4PHS-4QXiMrlga~xsQ~I4qOSw8baOsRIwuEV2tAFM7LvyVFC1iYushVuS7AfIoXSnHVGnUdNYUbDbYDZil2oAauIAJKJj-jz6M4~qb6oBLBudw~ob785bLBxAWWKuXT7eQz4Q__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40690,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "Chestnut",
    code: "",
    render_id: 609539,
    scenetexturerender_id: "10744",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10744/9e6edf8d_10744.jpg?Expires=1711702788&Signature=eUlcCOUeJBHWETE4VsFm5Ie6112lp2lrHRtYr42swdNcVHwBHhaf77KjBY2fcx1dCNa6ax2IADOum9n00wGq7AdWkRln-ssxPL5c7-HXnGA5ScxEsFaLdh3H1UIEmulrt2~tNafTBqFAlu-tChDzyClQYUA-5SyYM7q4ucNiLKU2wApxAnBeONTF127OZnd1ksKyBUsTyeaS7~sifAzQI22KDSbfVrsg6mY3ge0DH5LuHHm8VJGMjzJ1KYMyS3~HwXupd8eiack2NlOEGinctUdtYBI~ZkQ087sQMsfL9oPc3I4xysueMNzYqmuYEmSovyfE7hB9VA9H6Jl9EYuZdw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40587,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "Chestnut",
    code: "",
    render_id: 609617,
    scenetexturerender_id: "10822",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10822/ae84db5a_10822.jpg?Expires=1711702128&Signature=u9f1PXhuuV1svBpm4upuHoZ2IkFvNXe2Vuw0aETCKWvvg9oH92DbcG-~CVlPmkcU7D~~JpqY1hL2UQOekZwvz4-ZHm-6c8G1c6N-OwZMosGLrd2j9MOvHfPZiPWxcSkctmGIG6boMcW6-QzgcpJ0viuEcE6hNzT572N83ZrcnKwZczS-h7uvNFbHl8ddmud-CXY0vvgGaa0iCRBEgjK5fkg2vMOK2olYNn2pqoL0Ejd72eahQ8tkdLWSGJjaLl-lh7Tq3T4C7n--F6eUlozgwxbN1In9ssM~S1PA0wJUuHOmwNnqnan~xRssbnw0GmnTFL78vg1G4KXl4bpmAou2Fw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40685,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "Chestnut",
    code: "",
    render_id: 609621,
    scenetexturerender_id: "10826",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10826/6abf3d2d_10826.jpg?Expires=1711702375&Signature=mi12exbNoawqX0IZnLjjz-4sme0LURyGeGpkhhXr7sL9FJMX1Q8CFwAJp-SaXMeiUu-lCkXVkUeIfrn4bbF2x~~u2poZbV1c1fsrj6jo33UZ3fo4AunWaZ-78PjSD-4eQ6mI7atuYm1pBkn07asdasvgTJnEVO84h4duiQ630aWhXlFPWZcg~wMk7CvDuomLosm~uHMdZ2fdpn-oe9YTCIoIO81yaR69cqlzUAJQjUoeogPT8aWXTF35eqBhWltdtEn9qRuKW1VcMhErs07TD7QhOjQPX~Z3dHOiA0YubGFpFeM86VBFOFnxI7UVsQ6Y8y7E5bmPY4iws7QbdwgabQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40689,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "Chestnut",
    code: "",
    render_id: 609621,
    scenetexturerender_id: "10748",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10826/6abf3d2d_10826.jpg?Expires=1711703024&Signature=fJrnTVvxqnFdl4JYZfwmisw92Ersr1psxaiEE-ocWiqQw6jPGEzerjRqq5IdYRay7Py8Or~4PfPubrtUpuyi-ULBA-5vLXjpCzGlYY6iecPY6rkik7rkwsmaVHUCMe8dpRuVSR3J6ElxTs4E2PhgRTff4kb~Er6TEREFBuTm0JncRNuvdnu0lEnNMGuZ0Ar99~LaoqEeZYLo833RjaqjxSWsZlBtaflVLpgce0LN8BRZ1nnU4QS1XqLjCl8GrOYSwsZS~PsMqQ6EzL9YnEUME4V26-Duq83xI25KpCpYBknERvBfQ39oXY2wT8UomqamixhW~gISoZTadA~sTO~Hrw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40689,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "FID Sycamore",
    code: "",
    render_id: 609620,
    scenetexturerender_id: "10825",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10825/7f5e8428_10825.jpg?Expires=1711702375&Signature=uueCD2fLEwhJMJDHAcw3Qd8wAmaRF96g~CZx7qJAiuGVxjO0JlESXaqiy3jMQQwwtBavL0c-CyKruhve6a-23XUUyhWP~5ooF382KhTJAd9YESl5WxDa6mmn5FjHPiw6OnIzK0QtjnndWO92qCI-xFNublWnm7O2SXm2ZMsbl8JejJAzD8LJzcdgVf4m5qWt4axGf3teixnFAB81tbGRFwaHC7QX7l7gtHZKR94F-6p0VHC2xmxVZSC4hlKcov4ggUHnyVUfmOfmxxzBorSgpEnNwq6LyINQeALXV-2D1HoyBl2RfJq6W29K6OcNByWMFLP0~ukPUVzJ7jGpaXf71A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40688,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "FID Sycamore",
    code: "",
    render_id: 609620,
    scenetexturerender_id: "10747",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10825/7f5e8428_10825.jpg?Expires=1711703024&Signature=z1JuEBa1EyfUULyD9loZRz-7D3e3DQ9t1dJPWoXIzqt9XcWhUOBU57MuK~SXaVR3o57Fry7bowNd~elxSxOP-bJcuoudG~QbHWAaKz57Bmst3NkApm9X6wfPSLl5CUb3BpNUOg~eR4BPo54kGZjUUUbGjxwxD4NZLkrszysszswGUW9oYo1WwZv6KRLY0WB4daAhOk0WBBxAVDbgslO69VUqs3q0GbPwq7Ts4EeCPpzC1uEKDZsIV-AGIEottwuA53S64cyDj97M3xkmVvl6vnzvSHcE21PgDKejncI~WQuopAc0pAOL6zvRtJ7DggjyOMBnKv~sR1GJvHwW65G-Vg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40688,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "FID Sycamore",
    code: "",
    render_id: 609505,
    scenetexturerender_id: "10710",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10710/882ef82c_10710.jpg?Expires=1711702932&Signature=v9adKXyqfF03fysQbGggFPs8J1Xs2zQ9yaBMrhazaSJjHjRvyI4Ye47h6rw8C2WPFG4HjdEtx~vNTdCQ9b5KFh2uHhvRfo5kbWCj8dGbmRjzTlY42~vaBiQ1hObGiOIjiLYIAVaOgUfcUtjYYxefz7cgBfHInxYL06bFbY6xIUtXjIct3s5nldHHAUwMENjlCfwUXgmh~wJEkO00cumnEIk5GZyUxRW-omOT8m3OzIGxwIApfAHgESlqpAtU2ylbprjxpWfoeQZGMUFtWfm7DXpTyArHC-C3~EXNppfZKSqaoCFpKIaBC8wQjelC3sTQhug9yaTqHeNiV~Fj3cWAoQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40552,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "FID Sycamore",
    code: "",
    render_id: 609624,
    scenetexturerender_id: "10829",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10829/1aa77764_10829.jpg?Expires=1711702475&Signature=y4mwSv~WWiyqPIMN~uJGFa7r79CA8OWk8iQKgVDD-2sNkoa4ugMEUw7a8pUvvotYjmjpTAWIapQKjfVdKfyM6PLbyzrxZAETwlaBv5TIKe9ViJjQTEoFFurtANCGJmLDTzTZQZ-FQEUDv9L-KLr~PlkF0vhN30t~GRBZENVdjfYlvLu3jc~DhfIvcEjIiz8MFRO~0a~S4rDuDoCLnp4qEGBcq3-FQo4MeTqkF1MnJO0Bm4J6esdRRTWVsVLRy~46-NUXsZ8SX3pjwSMjtPujz-8W7l9ivGbiw7FRk-3wOCVQKMae7m6KTknUQ~0gdqBZ1UCD9DyKeYzYU1fgVIJX4w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40692,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "Sapeli Crown",
    code: "",
    render_id: 609619,
    scenetexturerender_id: "10824",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10824/d5a2405c_10824.jpg?Expires=1711702375&Signature=epEew2gHn~2J58gNwo2EuDWRGKxu~p~H9Dhx795ipl6Z9LbdWbl-Vt93zyB2Ob-2VBVmBCrDs4~-X145vo1~Y1xLZ20mrDjolzZ7LzpEs6KUN7cmAgft7hyKZKqKK02NvUwoTf3f7asq4bq~VRSY7mVVjqH9QVwhsk5XkeJPEWWF0ydp7d3j5dqhy3ysykCVBVlkKIDknWO-LszVzf4MBApRlQHt9cgB997hAZenP3sQdRQgF2tNsKQGMoO9BNCbYINN-cPSxXKzGS6vmRfmNA6Zxss7go0wONfZ5a4LJsycmmp4HepUwuXOc4DedZMSB-ZEM06Go3~7HbIoSv8E2g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40687,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "Sapeli Crown",
    code: "",
    render_id: 609619,
    scenetexturerender_id: "10746",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10824/d5a2405c_10824.jpg?Expires=1711703024&Signature=vKPwgexIimGJOuUbD7FJ~bzTD1Ir8lmUAhnDeHCtVK2Wmhx9~XnjJqRt8DOf6SCHfarOq2nMhBy8jm5XENKNRAF1~zvplAYl8v-Q5EpkZ0oglSrYyjiz5fCltU2KK1RWLtBOfi8smFM0Bza1hIF96uP8tqZFpNKNG6NZM17zfOI4P3K5UkBmzThqjP16uC5YyrzXNuy5fGK4vWW6FG3l60RXzWAmMvQM2Nn4mlwl138OyxuRx3ZlpjVA-9D69jaiOtfgAX6u-iX7usn5POKbhM~JF1l3dVwkagncgw8Qh5PTzAi5HbGSZFnzM1PAqcg5I-35x1Iu4vq~42Pk~-cLaQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40687,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "Sapeli Crown",
    code: "",
    render_id: 609540,
    scenetexturerender_id: "10745",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10745/3789b30f_10745.jpg?Expires=1711702788&Signature=gfWkWmxMhcejDaCrEY-nG3KwAx6FOnKzWE24vNKVbx~u7vjeHAnpCD~cFsrR8vqucgMgrYnfe~DMYIEJdb3F87chGDiBPp0SOKbAQuQhuCoQ9SEUZPtkqwO-KnMcpgXftobL8buLs2gYYXAmv9VC6LZyjN-I8HqiAtP0gf6jAMDStfGaX7m5Vf5UaBgML0WBQM5ew519u2L7rTjksX~tOdpTHdP4m~Tib-yENisrb-MEppgRkOJwrr4Jcyr~86kUp5mdwgU-z335iwaIFD-I2T~ueDWI~7Ij1DaAoPcjPV1Xto-KJbxH-spbUkvUz7DMNJr3ckyIoo3AVJ9W5wu9ow__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40588,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "Sapeli Crown",
    code: "",
    render_id: 609618,
    scenetexturerender_id: "10823",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10823/4835ae61_10823.jpg?Expires=1711702128&Signature=R6NaFD~8KWmKFuzXom9fKya-qa3kC5ybvwbTNEzlxPTWYqBrZYKZ8o5vq~tA-WGWJWirGo0kDxeR-52j8OPDnYEury0sLxg1V6P0I-OPCPUflE0qO5Gltt3A-8lc5kgezOdNEQucot3EnWySoQ3wgFgDyahGE3ztJX5a79bdMWKQT1AUxqnT3Rt1eITZZfS-xFCKZeGVCtDoaOzzgtF~5Dl69ZrTMUWvO05Ylixqu4zO5liWc-TTJEASXJCUoXU-015GLfaPtmbrZ30dWOIi0-PGA2xn9WmT4QwbMhktotKEVgY~-3iCZgmOkhUXRsUplbbZaYLSpGLZTE3FNVyKiA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40686,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "SM Coreal",
    code: "",
    render_id: 609623,
    scenetexturerender_id: "10828",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10828/41533f7e_10828.jpg?Expires=1711702375&Signature=rzMHns1wlylrnXqMPA~-AcBh8ZiS1z2EtAF2NNLRSiQukUBXYU1uH~tL4WJqcX4zEQsMPS6HTUQLvqhiZS6cL6Owz3XbL0p7Z-MvnLmJNNUNuPD73wBRsXRDB5Q4qkAuKlNBX7XZQB7mAL~~7phMZ9VPHpYkzvz-81eqHXqX7XkUbMvter2RZLFMmNIiVFRRFrIJuDVcMYRPOQmLVmlPNxODxcjWekQ~3GoQW3UdqGWBuhKQV9oFMpf38k9ETxCusWWMIp-1j7hdnPDyEIZA56ue6nn2Gi81vglGAERGcy3rF6~oW22-pg6LuqyovINNJpegmiiSI1HNwTxbDm0Mgw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40691,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "SM Coreal",
    code: "",
    render_id: 609623,
    scenetexturerender_id: "10689",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10828/41533f7e_10828.jpg?Expires=1711703024&Signature=d5tLquN0iTS1qbrSFRotzuHbnmCk4Ge8fQyckaAokTYzFEwLBex9DFJ0MQrFRh~-9G0WyjPVXVgtnFmsVCrLwuvFsr6uATPqtZvDUVeXDfW~W2Jj0vH2yRHD4wdG-c93uFzg6PdtqwweyIIUDO~bXOzR8gW0nv-byWOFZPaPVdOKjQzfy-QxkG0zu0dMDqXM8Nk9JF4Y8viqZ3~mctEX3~LfTc37M7SM1d-grA3uOo7KJP3nVvrWyVmd2P4XkYGs7R5f~SIMnFDwqq6jFu0nYm06MZww~voejnS6N8Yb0c9qdgzxW2h0HxLitKQ08j3k2-yvwe6clt1ZOimcSbeE6Q__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40691,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "SM Coreal",
    code: "",
    render_id: 609587,
    scenetexturerender_id: "10792",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10792/bf78f8f8_10792.jpg?Expires=1711702375&Signature=Yi1XZDDO-AdB4yWEUDCYegcj--dBuWl0D8974BPkrgiQb8cJ3~2n7wc~KyP4we7tZXORX2qn~7h9KIRV4O7wmG35XDtQ4nrX~eNSkVqOeyYw~4pkEVB8mNvWk8gPvQhfXJnrMDTezfIvLZSL3DnwDJMKb~z9i6hem~MK3PqpPApFYnTFMqoQK230DE1V2u41QFKaVe3HU-ngBI-5mPCAb~Qzfxwm2PLGXItXA3y2veZIXLB2vpad5sBMSX81MJ1C-7nXtTOlLbztgpuj37s7xQIgONW8WZbX88RdYyuK31afWSajdTJT~0-cPqdVKbspqWTtQ0CJ8n48cE6X6dyJ1g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40655,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "SM Coreal",
    code: "",
    render_id: 609587,
    scenetexturerender_id: "10655",
    colorCode: null,
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10792/bf78f8f8_10792.jpg?Expires=1711703024&Signature=1EHDHf5OOdFkKlONH6gLy5Hmi1vJv9zSg4AqqDkuzO3LT8ao0IEKOkxeMflpcDzddUHBj1z5PYOQ1H2zfp-nCHJypBXIbbu14wns2bxZhMVwqpVLFOUUWZMepEfgUxmiRfeAg46ceQNkiJnIMXZ3Zn97Bwqq9aLneHlpACKvY9s8WvbtZgBXieWnTAx76Uf4HBtMTIH7teoud~xm9432wFkPkV0PcwFLkNTX78BXuXyj3FGtuVAg6rAY74nTZH-z6vZ0gzJZrn1wriUWQlIJEEK79BYHGSWcGWfcMCsss1UJ2ldiaD88CrU~7ixED02DEstyHldmUF1vrq-oLuA8gw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40655,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: NATURAL_FINISH,
    shadeType: null,
  },
  {
    name: "Alpha Azure",
    code: "5089",
    render_id: 609535,
    scenetexturerender_id: "10740",
    colorCode: "#B8E0DC",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10740/1b815f5e_10740.jpg?Expires=1711702844&Signature=BfOWwabljklzUuokdAesdeq6uL~uuIJ0Mzsg2vECMf2wiK3oyTI8IYzMWwDsenucW7hQc5EVGv21X6PwXJzk2TzqPTHUwPkc6~bH~IPzD6WkSNAaduBAkQ9sH7kx4jbBn9T31AIV4~072vH82icyZO3hP8xPvqln20Kb1tnshnWStYjVFPoHZCt2a~vZcrySoh~AD4kBcjGHpt9ufqsMa4tVK2y4Qzgbh9GCphdQwzdV6kG0rpXClbJGfNlFUs7hExTb1NENk7Y0E4nBG~h-c2CwT20hkcE4Ym~gJ9vyVKkHY1mRQBwpSM99cGtW7-NtBDl1Qlh4qSpGlwMYxtLR-w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40583,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Alpha Azure",
    code: "5089",
    render_id: 609611,
    scenetexturerender_id: "10816",
    colorCode: "#B8E0DC",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10816/6ed5a150_10816.jpg?Expires=1711702271&Signature=Mjrtz5FOguaIsTNnutpbNuRKofkwtUp4tpuaSZzFxukJlhSDeTpolq93HcYChFoTyLRaCwKLTZOPLSz2hzvDhUu16zQMJB0vVQyq0uZydIRCAmA8p6~W3isrrwX4zs4yvKXHExhBk~p6f~-kYhqmLu9cUy-RkxY1PV8DKRi4zxUg-ugbtSwdtGIhcJR-9Awcx9MDS0RKzahyO4xYgy7ljB0H7wQjZuGWefGAOCD0IJAssaDp6Ed4xoZBEncxuW1TFgitLPBN46K--33Pivag~sFJGi6abjwckQBQRbmN1qUjIahRr0SYBW2aPLwn~hAcRpObnlWtA4pKHRzNsB678w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40679,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Alpha Azure",
    code: "5089",
    render_id: 609639,
    scenetexturerender_id: "10844",
    colorCode: "#B8E0DC",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10844/3f828034_10844.jpg?Expires=1711702375&Signature=5ESdJG-wXaqZwmTIaUbJEtMAWRXsATpo2QTXvOUXZKiVf5iAcu7-l4y0jM4ne5bOBiALIfBQWthQIvE8S~WhhDPkAwJfCjgrsczOwOHgNXAoX2ZsA59h1GRHHmyIw8LweBC0sZEAo-0YQUSNXjOPmmK6jUG7A3-Nj4aJfruTl3R464cSPltDe2fxXd~zvGwbkVUnqJ~-dCcXiIIdoVa3FgC8MtmqHCcEU3QXyX~~2yO9XbIuRH8juDX5Xm7qezintK-UJKs96a1lNk8DV-X5TJ06fUr4EkJXZPthyYy7N6HKffgC0jOK0zlGSXhRDD~bCJPiofHM3SyRIHt8H90IZg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40707,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Alpha Azure",
    code: "5089",
    render_id: 609639,
    scenetexturerender_id: "10763",
    colorCode: "#B8E0DC",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10844/3f828034_10844.jpg?Expires=1711703024&Signature=E0iYVX9SXak1ZMzrTv14fRgk~rpV5~6V036hBEd5JFRebdRTZivyXH~eUasuukjLMiBbilXd1sPOQpMVWH0IOr-XluQm6C2zf-mMkmOY~yn1wTGh3q4fct5Ka34yrBJQaQt-bq2tu6VaxFzCq0cej~yxI5lVBFvSM1ypNsvljfsMGabb4blCMT1VW1dG44xIUkY2Ag23rmqwFlUjpacBFScFLoo7tEFJsAWftaJLOw46x78yyyIoMaX1yZ6~SiSGgLytfRnok1PHJ2acvnBEsNBQUm73U4YyJoJ46ysrh88Zdrdrq2fzxxLpj~CSB2JJa~z8lt~Y1kVt5wzAOYe9DQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40707,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Arctic Blue",
    code: "5069",
    render_id: 609518,
    scenetexturerender_id: "10723",
    colorCode: "#8FAFD4",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10723/faf5b417_10723.jpg?Expires=1711702789&Signature=JvG-idhr4qOz8dJj0uX4ONiw-SQak1KtP0h36N2SsKKKL2VuUOI7cxMuqML8Z9MWvuaxhHS7nzn2c30BLvRxK5qEPgWz9PFGQRXzcR76vfweVx7PwTIcBtllcQbaSDEoD9Zl1dAS-GHEWO1xAFxfOXVR5x~SQbqjPE9GNPTAUM6wcpJDq1~mW2u2DMNpTZno-itZPeHnnXIoP91~A2fZU-WDgywOe0kO~BovU~o3MuuCAohY5Q1ZicSTDgWFXkAevAstHA2rQSoXnDCzAvM-x1nXVXmzDfpRmstTEh2ph3cUB8hHMaJtwN9uDBLpFFY7fjXLu4enx5LjHD6BYqtxBQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40566,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Arctic Blue",
    code: "5069",
    render_id: 609575,
    scenetexturerender_id: "10780",
    colorCode: "#8FAFD4",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10780/0d5e2599_10780.jpg?Expires=1711702128&Signature=3q96NDYU9xnDjki5zrzYGhkKatR5r3s1GIHjj22Z~HNX2W-ablPO0oDe3smkusXdbEckN3ZGV7wWu8BLfOV~ic6X0FMZtB9SUYUNdCgtocjdmbUJKUaNKMnu6G8aEhjGJpNagkegLwKDGE56-xyiRoTDIrFoat1Bo~o3xfue4Xxga5fwJqqZF0VA92Md4SrQbhxftKhaGwtwqIEQ96eLCp7HCYA9Q63epZXq3RkfdwJPDPOZazJf4fMXTAgqhKFaGW~rLPmHwKt40Vqb6GrZRBxsrYdzWCsB2rqI0goKypog25KIR1Xzblx6Sm5NTJY7iDraGp63dRZoIxt9s7YrvQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40643,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Arctic Blue",
    code: "5069",
    render_id: 609447,
    scenetexturerender_id: "10657",
    colorCode: "#8FAFD4",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10657/d58e2db0_10657.jpg?Expires=1711702789&Signature=JyeVKMtJIuGfVpSukmlIYVvf0q~H-wCHTA3EMY~ug5vyVBKpVHdqOxRUs2TyyL9Fc7OEubX9WfpSY8l6ESOrqYs-XAQgVCEA~gqgPVnNSEZQ8oWP30DUW-4Eiey8sCsmcCShMmv4ZDSeUIwbTWYVH1ui6flRChkIWxiSX1LhwcYChiEDmP5jJLSu0Alo357AoI8Uho~bruwfFF3okJ64hIGqIaWNLZJiHoI8vS8wrkSHbpPztAzvorcxrOanU0qbsSDEzEuS64jZGHDN1VEXgDvglzmpYMNql8s7NW8MdIN8~~oGZ~~oqnbmSBPOBIUy1XQzOXs29knULaywIc4u-w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40519,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Arctic Blue",
    code: "5069",
    render_id: 609462,
    scenetexturerender_id: "10672",
    colorCode: "#8FAFD4",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10672/2860d3c4_10672.jpg?Expires=1711702129&Signature=xQrK3ce2Q0zlh9zVQVE5~t5s5prXp1E2robdDzPCerCEiMJclY5cc~qMhP8ShqTpvF1rCZMqRPRWFCgZRBzCgXbvFkzjLGrDk37pTPsftAVquraNlkpTwGT5bX-dpdv4JUSOxes6xtKSlv3VyjjomuDTnOrffQPaWdFeD66ssljoanMiloxHOCDZyTdrtWIzzLBPHNEGq9pg1eI91PY66GiX3cCaQClPaPlweoqheDhTTxWuLyWHFOE~TF72F3lXYQLW-0NTlVGZ3gufSPtHBXMOWx21ufwYLtZ2pdjsZIO3N-J9aAI7F~l4YL1bLBWCrkgm9YeU-ZbsTzAAl6P5ow__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40615,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Ash",
    code: "5007",
    render_id: 609526,
    scenetexturerender_id: "10731",
    colorCode: "#F4E5C8",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10731/3ccd5547_10731.jpg?Expires=1711702788&Signature=Vm26Z5Q0UlUFuo3cc0ZMpveLVcokvjZQ93gw86LYSpEbEsN4AjMjQK~D6xe5k-DCyrQUHLH8LGCgoVdsNAygwYzL0a2k4b0MwzPiNmhMWIcZQ2BbMwmBjai6tqUzCly~t3h9jCJ~Qw474wDNMczXJo2pmXpYsZCN4ls3aRkza7kVR6l1ldszJp9tx0FGm57q-ABr4tTyBR3HRbo-E83SwYP2Oq9pP-uDMpfPqeWORZv~G6E04pvCeQHyZrb~3WhUD8ZZiD4QfdG6Jq6xMsEnmS~C8wXzyq31~E5fZuTPhwglX~BIMhfGXhx~W3Z4SrBEac-wfa5irfcru9P8t0Ey4Q__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40574,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Ash",
    code: "5007",
    render_id: 609591,
    scenetexturerender_id: "10796",
    colorCode: "#F4E5C8",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10796/152a41b7_10796.jpg?Expires=1711702128&Signature=iFIe6u5i1Y2GyyNTpRdiFIJmEf7a5TmaUj6d16YTUsKBcO~njidmlyLYQJdjNPB5TQLNJKleGcVgRXiZrNhaWDyftclXTcWU13iaKUfVVp7aMVdyZiKSJcZxfOu3R5jJizcaBGtB2cPT9nH9uZKRN8Y8XX9G39tNoE3dw4s071~OV3WNQjhf35RvZLM3PQ3FXOuSShv0ehvV2vLxNHhJJIfaHBMsz-HfhA94C7sO7flkkUdWLEajnK13OLBuL6FW3SFvDGPeF90lUzfW-FiJFZ3mctbHdD2V4dxsIUYWkmzXlvSLS-HteLq8DwBwf4l4G2LcBDJzrfJ6kLOPpzse2A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40659,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Ash",
    code: "5007",
    render_id: 609453,
    scenetexturerender_id: "10663",
    colorCode: "#F4E5C8",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10663/51227764_10663.jpg?Expires=1711702676&Signature=Efao4C55hZI4KkXyhstEfO9DI4UztIqzQi~re6YAH-CKvDjKCqs8jZ7ZgftUT6pE4gtBGTxs4u4Z6~o-IFyv233itrnrAMGvbDMikwWgTJgoZZNqRHVLgaEyywDn22rjiDg9rLI9QnPIVzt4PVinFJk5kc8EsnC7MeARnaiPl55X-u930bfeiPYsEWAmKgDSExAE7~eKbCInB70s2Z7U4vCijjqyi2awb9YgpdjVoGUCElllD01bXHlQESoX~bE800q3ZW3IAFHpiM-OE~J36ErESdVAWiUEgNFBzgpoG7F9HqUQHK4Uj6OtIs4ezmWBh8V~XFI9kAtMboV6UdJDsQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40525,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Ash",
    code: "5007",
    render_id: 609603,
    scenetexturerender_id: "10808",
    colorCode: "#F4E5C8",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10808/5e3e2502_10808.jpg?Expires=1711695574&Signature=OIsFBkjKkNjkOV77kvshu2xm34W6u90plSi58N3X~LJwL9YzO8V6PbZLv6LadyFyS0nhjDTL~n2xe8zg~dWOCT-B35hO7KSc-ayqqm1EQ9RfDbSRxS0vkG-l-xCgifgEcxjLLiH5DUP3I7iNS1VYIiA~aWlDlmx2idnYavbE506q3F48DCiwsqGOEpwEAu5p09neUtE3TRZDKoMsS9EIw6LKUij9CUbHFC1SA5qEvuIS6uA72tzyZAv8cXjrP1~zZ0IUUjvq6r9uk~Rl5vhwXBg~iV3cnJVcxFgTVaFVmqOHn8Jt9XTPxUoCc4befZ3NqqmOd5w8HLq86RcvUcsAFg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40671,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Beach",
    code: "5117",
    render_id: 609436,
    scenetexturerender_id: "10646",
    colorCode: "#E6D6BA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10646/62943023_10646.jpg?Expires=1711702271&Signature=yCJQXbQu6R6-O798vZjP5~qQ-WQez10jWScwGxWpf4SGB2QxT68Jr2XymlqFo5ijIt74OBHXKRhvPlNDICHpZy-JR-9nkdaoEP-yty4hANO9dMH7KTJVHEWnPgJQojzu8nPeLTTJRxDFnO4uUSYZELqM5CwNIAWZABeV5T76iTHoNM2DGvsfo4AImNkMp69~-nWldpJnaP0EhEj04uKxvy1JDP-oSuYNPzsFS1yKSJFolJ7spOpDwGXxROlkdlfT4pcnCvslvw1~VzV78TPaM-BOj93C3MTEZfZbJS9txU0AvVzWnpp2PRvYYOIR7iL2FN-ekw60iTMRlUIpdvdRSw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40609,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Beach",
    code: "5117",
    render_id: 609519,
    scenetexturerender_id: "10724",
    colorCode: "#E6D6BA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10724/7fb0559c_10724.jpg?Expires=1711702843&Signature=w3QYq-VdPGzZVAcb3R8oK4z7kVRjJDAuEdd008jWb3Q5qbAnQ8uBwuDZOF-KnUTQWuk6BSPzWG07hR5sx0Y8~vZIKGumtpQLZyWvZdxx6wuuPonN2q35WPCOJzizZmBFKX281ZrYboyNRjW0CEBvfrj9hvs4rO5jldWbb3Lh3wA7K~nJxvJ9CnOT3hCwE3PWrDYkqF2jGbk60qPZEEwzRHfwHHR1AcgzZj3kUfe~DrepoX-UB6OE80Zys-fC2SmZBQdUx1bedrrG4SU3g6V39gzQ5AdKBi5mnlcNTXFESCXbTUKpfieNshcYO81T2WTBrn5AUIH7GaUnL-IUSQvmxg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40567,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Beach",
    code: "5117",
    render_id: 609485,
    scenetexturerender_id: "10690",
    colorCode: "#E6D6BA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10690/b322aebc_10690.jpg?Expires=1711702676&Signature=KWiuXo48GEei9Sw~j0Ud1A8X2gkYOePQQY5D767y52SoWn3Tzn6hdK26ktHbJlVyu1Dn4EeYGn1eLDDw0SG6sYAjfbjmfD2YiDV-fG-k~9CYcm1hKQTClgn6F6v3BtavLWmx-UvOVnvy-wNu0iWuhzbueedliehH2LUtRBDgoyflgxfFUK7Y3nMTRbPFnmhqYsMtDGknlNafZ3g1wVoBppg3EBJcgxy9e4hO8q0qLYjiwA7C5Yp1UxwZ-hgzVJE3NPYCxlJlQg8YlUyzDvjKfaX43Ak9GttHdbzZl46NQERV8qjhA2X0aq2nJdxkrHgJucsq1WLGOtfClUIxdyRu0w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40532,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Beach",
    code: "5117",
    render_id: 609626,
    scenetexturerender_id: "10831",
    colorCode: "#E6D6BA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10831/a991956d_10831.jpg?Expires=1711695574&Signature=Bh6XFIWCu04xs6hYL47HylNs6RZ9N3Cj6mdsav9h9KmwT7HGnfAVSBF4frV1fsNG5wt4faYfk9x2-OFVLohQK34Sbuzimi0M9aiD~3okh7B6k5WPYD~mhw48G7VSHbsXVYzeQWyltNVsyrSbofXUt9OxWCzvEKqo9KrexswpQeieFYiqS5HhbiWCAsrDufUiUWNEg1I90WexUXxtFUPPRHzO7~J~Vko9y4sbBB3EmwfO0wP~UTUbj--ZQSC~cJRVEFZWkHBPEDbk8-knEY9hjZw1WZQXHuYDYkBsIOCd2zw5ZZrbrEb-ZIBu5u1UuoYci-fOFJERy05xxzhkppuN9g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40694,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Bianco",
    code: "0346",
    render_id: 609455,
    scenetexturerender_id: "10665",
    colorCode: "#E8E3CD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10665/54cbf5e2_10665.jpg?Expires=1711702676&Signature=zXDyG1p5X8c0ODWc0F5JPvyGEbMJWKJcPSYhALqIonICzawqGbL60xSw3fgS1VeqFnSGmC9Yi7i~yocH7qi1KIVa98KHWjvb3oQvB201ayQpljEhLgqJJmtbDEkhPFVHvwzxXsVoheMwWqo239jW6F0l8SM8mn~xop6g6Cex8m6pzFgNIlwaamxqX6qpOrdJpmfx5ICVpj8NNPV6Lv-0nfP5JAemFY5j29IaRpByDlRlUO0uIx8A3-7fCfLS5yREp9zoScesGd0oMB0NShnnWPPx3aX1gfLV2eJ4bI7~dD8FniN6RfLVsN6F4wiRj86ME2~HtODry46ctPT~duv9Dw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40527,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Bianco",
    code: "0346",
    render_id: 609607,
    scenetexturerender_id: "10812",
    colorCode: "#E8E3CD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10812/77b58b43_10812.jpg?Expires=1711695574&Signature=wcpjAnKghUz77vpOvlimcuze9z9T7wQCCdLR~xrwQ7X8FeR2zqIyMCjDPWvU1FSM9Z2ujOvbSLHgvS46e5c~D9lUIwS8tV9aock2RKqbTPJ3VynKC~bRg2BBMMw7zdkpiWPkHrYz3W5nbRO4NkK8qXPu7Sy52k-Fzld6tEtTyH93AwOqQyyC-5A39Kd9CUSSYn1KnhUp4eQEV440sFy6~SQ-AQKDkxchH98f-rkWQmKQd4ZzoTA6fLVi~i3lHnKzlOTyvmVpvoJwagP-uTghZphs0OrTL6M2bUKdzI~bZVoMI4hSHrqL2dxKPd62OM9H--lx6dp1Mb2uZmvQSSGAiw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40675,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Bianco",
    code: "0346",
    render_id: 609509,
    scenetexturerender_id: "10714",
    colorCode: "#E8E3CD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10714/479f8222_10714.jpg?Expires=1711702844&Signature=lfh8RiNK7wENWCap-Zqa7n0EoEXbB0RzTKIT5zP1tN4qBdkjcEsZAxnJT-Sbg5joSPcjA36eUhE3WDoMWlDNi4B2edKcOb2bnXbeYY0uVzXmnMIZLhIqvRs~zxXyhAOA~yGee~eng0PUX55qSDeF~fmE8gjso~Fwz0zDYLdAyD2xfTXqNhxJnmnLddkyMQCpCu0GiG9dlEFAT6Orwh96IieP13UxeATXPhvUbxyRfsTEqi1edvdkbQFlYBoNWAh6az5EHnI-4nReXZ6V1sxM~0wPgvnG9a1tXUgPBBvNhlFMNYXwa9Guus2SBFnDwkZ3inLV0u2Ln8Ow82bKGHNFZw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40556,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Bianco",
    code: "0346",
    render_id: 609595,
    scenetexturerender_id: "10800",
    colorCode: "#E8E3CD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10800/efb93f4d_10800.jpg?Expires=1711702271&Signature=wiU5AjpKwGzERXthL-SBAFmT6mSiuDHVfNffXD~-KWJUpS1Kw0g6S9DcyhoGWZKUloJC7Jf8CWnZYqTPFE98gH0TG5cNQUOAakHjEMlfJKXwsZYotA6N8Cly1hW1Faggj1CmSEreVLdFnAHKmgo5acdcTEz4WfCdDgtdWaKJE2PRHQ~NlV4M~WRtBoC7bS8gM~YmRfjAURiBgLT6cOYvlyCRURUoaz6wgUmfDj~ITWI0YXgxO1xYMUb4Q7mdS2jgGTUrGGA9kayVk2hXaeFDz7SAWruNbDv80R0DgTNrbLgpcNasFSQtra1Fs3CEeY8zC172~B7F7h0v-SQ6sT7L0g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40663,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Burnt Custard",
    code: "0341",
    render_id: 609514,
    scenetexturerender_id: "10719",
    colorCode: "#ECE4D0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10719/f0ded20b_10719.jpg?Expires=1711702788&Signature=rBvRbS8NYNJHpkt3XY6NahAxrAl2aojuh7AgPuQmY-lGW~ITcf3QUzwRESjyHViIX7JNMqAiqcrokLAQ1SaGvHdLuflNG4RNntHpohYjQSdpr9IwzO9yuYKZJFVBlwse-14Z1MXkwbBAdMYdEj6MMj17y2aWzLeEWOZKeBfgpV8TJOOd0P5MzHt-pkkvy-h7BZQ4mtz0SGB474F7UxRe2PC0blnWKs4pLxwUqH1vq05mbLe8jquEAIsAKqUB-XcO~i5UzbcR-478yTFUIocUmr7ohdMw~oMfu7B1CNrnEqBqVRPXftoRewmdKOVKzFdPlSECEIr6xw44b~uYCLdNOQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40562,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Burnt Custard",
    code: "0341",
    render_id: 609570,
    scenetexturerender_id: "10775",
    colorCode: "#ECE4D0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10775/8db63738_10775.jpg?Expires=1711702128&Signature=ymMeRnQaPyn0ZrfGO5tEQhtKSKvg1~5MSytyQr8OPfzPEEpwWI3Hx2v9s~Lp-yHjtd4kTnladzKdk~nP3Rj5iKs1kUx0YDJLMRBae3ad3AgVFp~kO-W4Nh2TBKYVmF~bRChQJydLPVR8Tpv-b9q-GAgYA6dMyf3TFHx-KdenSgStwqc511c21VmwTTnhkBxzEhZH0N6XoumMUo3oxRyUJDpfjXIYIKfFnDxB56yjsyAI68Ybssj0Yp7FbAskUGksH2BugTNqTG7LmcIc2fojXM09uwgv1oGKFkXiEvB8HKC~~bWko-De4~e1QFhaJH7dLuKaZQpi82RKXmKISwUSow__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40638,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Burnt Custard",
    code: "0341",
    render_id: 609506,
    scenetexturerender_id: "10711",
    colorCode: "#ECE4D0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10711/f46f3717_10711.jpg?Expires=1711702676&Signature=cI9wL2OJBmAgCY8Jt-yxZCwvhx~k1UnT4vHucvvExTWAYgGu61ptWpC1qtMqWwpBh30ZSGm3giQoy4g-tsqssJ16V-MF9qeadfojq9tHj9ZFXY~7fmod1bR9aF-BbfjYOJLYmqj~C6lMNMQKBFeOngn66j7RHXjsXTrXvuop1Xj7qRtCgwXsdklODr6IrFCC3Lw3S9OatV0zT90hManP7dlpoUolk9fek32VA4pkWhnDabml9D5uaALRkCEa6PcsZKigYhA0phQld3zxYYgMd~i53U55MJ5njtdj4NlEafwkyHlyraxxhaYPp9VfpxrrYSGlmXYfg39pYEBPXYaAow__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40553,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Burnt Custard",
    code: "0341",
    render_id: 609625,
    scenetexturerender_id: "10830",
    colorCode: "#ECE4D0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10830/b8567731_10830.jpg?Expires=1711695574&Signature=vExxSnKuufIPItPKA7dUglRQNfz4vYe53EkBpiXcBLSgeDUirtnA~5DSgv70bxdBwMzpDIE9eSzyeSbKS7NSJxUsk06R~VRg2jIMpxjPU2E2vu3qz40P50j11pZSfxUq82EHlE2XjjeKiTxaiVwIPbIRxUULVCt65oatsgsZklAcsx0o0IERc3HnWGqww04xreINXy-qD0k8pXIHu14ZI2qkpR20XPzF5aCD8Mg1KnzO3-IxH~xGrHjNuCw8xnF~Lsf7o1w14J7xYnxwpGGoKrgQBbzafXlx-NXIQbjTUksktrIE-FxNBkb-vEcC8HfIfICKP2K1kEuzXE31LcpfTg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40693,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Chocolate Softie",
    code: "0450",
    render_id: 609481,
    scenetexturerender_id: "10686",
    colorCode: "#B3A992",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10686/833b1f80_10686.jpg?Expires=1711702843&Signature=t5HbY0LJQOXZ2FmW-AlB7zjkQ9yuZ~5olVRtmF15scByhrwdQGceI4jW5xZkGKISKsf45tRBFj0H4wgqbYhcqjm7y8bzFaQZ19~QdudwKuiiUiPCn8Hl315eK~LXSao~DENj4~BPqgYW2pbc~uvj~GlSSxoK6uBO419Jg9EDLN7uDa-YeECZvcF-w9~NaJEsuh5DYeFvQKI-aVzJS7J7Rq3JsI2g1ma-Sx0DROyIulaGm5NJ9zzEIS2eAFkAIYuNMRWR8RtOtm1JlFB-zd1676cs3W5BsdzJ1TC3o4XeobnAsdn2xBAsx6AHoFtTM1X4uO79WUuoVwcfRYuYQnPDDg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40528,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Chocolate Softie",
    code: "0450",
    render_id: 609609,
    scenetexturerender_id: "10814",
    colorCode: "#B3A992",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10814/0e756e0c_10814.jpg?Expires=1711702271&Signature=GLM3cLNZPGIz9pTJbt6v-e31S5bHKvWp285glf-JpfS6XMUlEfRNUxT8ih1oGdKRESjuDgWVpX72wc2xI3neAIoJDYxM5MxT-vMfdD1glr79ai71BkLYUQA0112ITbHi9FVL7HckIFKsG0sbIwxbV9NYVQIhB9G28jrGILMMfwLxuYrdyQJ11V9SJioWCCrlm0Da~ygVgbFWC0sY6zrtvGGsgwi0IK4tPzaZgen2MeUGH1KWDsxKjzfvbCRQcFwiOpAzUzWJ93lp7CXQySRowxchBZu82v3g1FK8ftPGuPOuj-PMwYhVLUIDtHxkhz-l~DMB~6jE5Akxy7jyXcezyg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40677,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Chocolate Softie",
    code: "0450",
    render_id: 609452,
    scenetexturerender_id: "10662",
    colorCode: "#B3A992",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10662/d0cc2d95_10662.jpg?Expires=1711702932&Signature=ZHEEi2SDkpLkLE-rFDZ2KhvO-UEkhcEJ38AoWI8awqfTVuhg9uU6s4gbyru6dCSgEbEgwBL9R2ZG8HP5JLYWeLnNx~y7P-Rvz35~f8GchoyBOL5dNa0LE5S0VnH2~YMTkrvEkzTPsoVIUCJMFqsQl1zOEqVxuypSR8hoHwiuGBpkdp7gbWWTJFySoEhE64GfFtBYCarxDPfJ4UUuTxv5jvNdq5IL6k7Y8fkExsiH7xxgf5oWNGf-aeOguAXyTZ5wNr59ERKramfewq7CQ-UlnNEIDE0xGB9vVXQxJCEM5uR8A6lbLjf1Oi51KCycVMGRcYwQYumrt~bCcD25~-Dxyg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40524,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Chocolate Softie",
    code: "0450",
    render_id: 609601,
    scenetexturerender_id: "10806",
    colorCode: "#B3A992",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10806/0af436f0_10806.jpg?Expires=1711702475&Signature=J0wAqdIQjNyv7FWcrY-CuQhnYEdCUnb0AtObk9FAjAwYUOWElgcFJqsSQiOFAFRiduDXPRKm9eyrWrXHlzww0yzFt-ZwTIqys9RNX0SDx6Woh8LpDy-BWcH9sA~3dwOuScBIL~235mp1miBxwKA~2zMptwK8SeLz3ArMbPCX7IiO0WXM0fEdOrSZKu0zlhEEpS1Bd97Th-So0zeLcfZdq7ghjc-NEIZx8Ca4tGZ3tbJLX7~NnuoZxHhqxQhKbZqIHv8wDMXT~SZ4WPwUH3QD4Q-1L2OEBZ2vDwep6OR7iYBQSGoDqKUPlRkNF412E7jqW47H~e1sAzvLIxiO0w5L5g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40669,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Dreamy White",
    code: "0333",
    render_id: 609512,
    scenetexturerender_id: "10717",
    colorCode: "#E7E6DC",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10717/2bfba6f9_10717.jpg?Expires=1711702676&Signature=DeFAi1GojGxZtAh576so4QBhhviyXNvkfNVFqRvB15yr~iLhyA0N~gVVuUrJABZzCnCBjGGqulaZY1JWz43OmtYdySGWravlh1oJYFicQjtjDmd4SdHpu2yyRWHDPHzKsFCv4ukwlDLwi4OGolS04IsZgYC9iO3PSRUvq0xikoor6GQfMkuIIlRnNz4xT-xP~RSBr0Xfd60~GdJlEnpOMe5C5ujIR2SkFvq~n5xDzEMg2jesdZ2AVH~Eo0QmbuBO~C0~MKEms~7rE-mzMrupPJXwColyv4mwFxkUcrqb-j0xYI9LFimYv~PQecNEyelCEzCQGrmFwjYNZ7Yn-jZC2g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40560,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Dreamy White",
    code: "0333",
    render_id: 609590,
    scenetexturerender_id: "10795",
    colorCode: "#E7E6DC",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10795/669b63da_10795.jpg?Expires=1711695574&Signature=rzdKGPK06sqpe-TDcrdnZm8sMeAIcItBIQi72cWhbsmIOiSNKW5ZmcY-YIb6s~xeRyLWEfEecm9qo3BU0YGLJtcY1ImR9opXcdDNzEozvdi5lwip83vEw95S-RQHcDA1-XWc4QYYNXlsfBRi8CFVBAXk0UI6JFdKgvngr728vFtKrn9F~jtpbCfEI2HB~df1A1dru7rWZEnsKSxHG3kehpDxRcZY0-icbgWFlZfKpGjwga4u0ZrQUEV9EQB3rVZgLnu3EXldkxLbZ26-V7vCjUL656CWOYJY3x4iyMxOlNGVXa8ViAW6KU~nFQJPL67yxlyUk7rFNuAgfIks7AzR2g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40658,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Dreamy White",
    code: "0333",
    render_id: 609439,
    scenetexturerender_id: "10649",
    colorCode: "#E7E6DC",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10649/9d68c70e_10649.jpg?Expires=1711702844&Signature=VGiQ9z0bJKKCyHJZFyA4qQrRnnZgwZOWTjQHLsJfnL6hfh2ODqtzPeSnX9fVi4VMmFRmYJhhTsMLZR-ph~biWRAxUBdM~NoAjJP2Pi~Z16cHfDmSx94~onULmEIANayIwqkoZx4QC7ElN1MmE6nvl5TpBbAVhmJnkfn5gSclHfArbyl5lXOO1gznL3BdvHUH43g~BvqO31RRZbsl2w2gS~Yrg9XSBg7M~~koQ5KGrgFu2PMWhbhPttFpxF2U5aak4OdkfqRhl1EovkcMYi~GzL~z~5DJxllxWA8U0-TtxM9DF-Km~SFuqVQX-8412TDp9yv5Eh-l4Nb5~jErAHO-ig__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40511,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Dreamy White",
    code: "0333",
    render_id: 609457,
    scenetexturerender_id: "10667",
    colorCode: "#E7E6DC",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10667/f2262394_10667.jpg?Expires=1711702271&Signature=urGKd0sRevFwoN-KSg5ZM-YjzB5bCh7oXVuI00pc3sPYT5nLa2w~8vD7KDmVVhjgXQyQZ3o9hCmcdcLFQzVyKBDB6jPQEhjmBZvjytIIkz8lThCCMWRc7ks9sGSDd-LfNh9dZ5QYgAFQ7Qefb4pPv2f5J5Eq0IVfsy~b6F7MGJVN5kawG74nCAeEJaGpiIuzU~lvn2L-x66JKo2pwV3MoW-iM5nUu4kzvMEe62n2HCxfy5H8YN2a3x34ggmRhNgBV-tal1zDUOiJ4UhEJDtfajfjhSW7nXc9SRg~oyFgc4mEbFxUv9tFwNI6R4L-wndpA~oc6BvbQCIKvC6pOaaTtQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40610,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Floral Violet",
    code: "5048",
    render_id: 609525,
    scenetexturerender_id: "10730",
    colorCode: "#EFCEE2",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10730/96ea9a7c_10730.jpg?Expires=1711702676&Signature=sBlLFIBzvEb60-JIh4--Epv26WM786B-lAqN0KqouxLkW5lcEUJ3RSCDou5OAjQf2mnbJLfR8BGpvZuRbhhHRBKIY8PCx7ToESfHy5RQxkEe2NlBLxOLzhpw2gi0D76b0qQXSQ5NBj68RDLxq6mauuO0WbZgZ~iOmecpySClBmpfftaFtdvV-FgZaGa3g6VNP-ijhIn31CSb11HZ-YTlouAOzarXfEhi5fNnH3kbdlMMaO~4LP4lcl7fXrxUEkJVt6SmflDexHUsrdmyeSZN6OCNWOWIhR316KMLx8TDpS1U7qnjTD~6XlJChAzuw5omWS-xKhSGVXLa4ZCTDX8YBg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40573,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Floral Violet",
    code: "5048",
    render_id: 609588,
    scenetexturerender_id: "10793",
    colorCode: "#EFCEE2",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10793/43110d33_10793.jpg?Expires=1711695574&Signature=Z5Sf0dlfzMbsPh3hlh-4DXQ9ckQNcoNP7gCavGkbowjch7O0gceG296Pgvq6rWXrffDqmelF9d7vvqYMyEr7hqD1SXz45F-lQvJSQUGbiNmutt4F9lSMR8rltYuE5yWcZDWL1pnKdmDfQqX1uqghOOcV8PjZv71jy0qm~b48OgtTgOucFwRXMTz53FkRNsifAxGcRcdvBgyZxQTRe-CvxLoPwcMsj9oIfsyeRUBv~eTWr7UXkqWD3is9ygpRyzoI8XwyItEUUa37GExWRZEqZU8Uru1keBC7BPmgcF7xdhhf3ZQF~p4jXWZxQuwQyYTTnzRAzahrymm56MKuB0PFew__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40656,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Floral Violet",
    code: "5048",
    render_id: 609548,
    scenetexturerender_id: "10753",
    colorCode: "#EFCEE2",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10753/21edbfcc_10753.jpg?Expires=1711702788&Signature=HaAnfNUaoZPYpUrh05uR9wL22myRpdplfTjDHljjK3qLokvjPuzZwO85vmTvPhBUl~h~wKalP9uRPaqBSHgBWLhQ--MYg77HwXTeWxKeWPacpNyB-G7k-de40dN-2FJV1jIna~sk7X8wDOG8dYUKNIsD1exK8itRu98qbErvrNwizHPEQNTPW1SNcd8BSS5y~-BJhU~G8f7PzFsNfy4ewTy7MgLKUra4lxKOwFIpkLUaz5TjJibnpqRA0MeFzb8b0CMBDuFpNdzHtVplr5dB3SsDaOa9DIeJW20S5Q5S-DZEBUHcp-MYNuliOpp5t6R1697dLKgBaE1jlbAMqH1O-w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40596,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Floral Violet",
    code: "5048",
    render_id: 609631,
    scenetexturerender_id: "10836",
    colorCode: "#EFCEE2",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10836/78939993_10836.jpg?Expires=1711702128&Signature=x45ZtWUShbUXEy882iHA3F8pDxxoDfebmkLLb~WS7jT6b2ELj0TZHYkSMsulcygEQhvGVns0WMCbzvNQFCJHmkupUYKUasKxrgxZ2ryzBSc8E2mVSoJymnS4UyS-NtYsfwJzeXb8ggi6o3BK3DjrPbx4K0W1UQ3ehOyUMvXYfmJteLDcChV3xGnHxQAh38RKATu7OLU-FYemGpevQxsVpJVnYLpvyZhdmiuWCPQJZT-ZZKm5JiXCV4njyI6gWPipGctO3QbdAtsd37gqQiqbCzSj-6aSQcc2AdaORE9GIGs5KSMYxyJPM4lXPBI1UxzVNPWBFev-ypP5L-PWZB2Erg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40699,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Foggy Sky",
    code: "0404",
    render_id: 609527,
    scenetexturerender_id: "10732",
    colorCode: "#A5CACB",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10732/18c76d01_10732.jpg?Expires=1711702789&Signature=kXETm95zUBPznsJmzLP0X6GBaWreNxku1nEP21hJ8UxMbQj7-z7DMUEGqbzZRhEggcDs64azBay3WuKoczehPtZLWFDAdhs3WstI3aJPmt6974cJq5dcqHdb5NKbJjjjwuQVIms4GP44aqlRjtHiXWOb6r6qilwWN3WYFaK-O~uOJro27tDrS3TLGOn4uo16Nkny16-pRuCV8H2I6LjNbg8jcm-TJGwAWgrZhpHIwnqCGakYH80Pte9wScN3MwazKfYNfCtny5o27rulBXNjxkUQqXkOLBDEBxlSZe4m34pw8t98f-fVDqjSWEwwZhehdKYMzaJnyME1ZAHKYFwuVg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40575,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Foggy Sky",
    code: "0404",
    render_id: 609594,
    scenetexturerender_id: "10799",
    colorCode: "#A5CACB",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10799/f93c669f_10799.jpg?Expires=1711702129&Signature=fWUufVEFW1QKK6WY0sX~Djx25Q563tihA93EJokGx4pDztFEuv5qvo1uMW3uQ~Pykp52SPnHixeCrA6RwfdezEWPwCc1~KQBSXcKaTzXKyqAG6VwZt-ncTmCOhyo95H-7uzI31B9XcgDool6zEoVZeJZoUC8oFJOFjSGVDaqOGaQ~708vGA3vJhbdJ14u42Wt7cI-UKYAX28tCDl2ew0Z9c9kBNYIByopz~NdDb9Ey5LdEgt7wpUWvj9cGLIhpCZTfoidjIL5Ag693eNiNvBfCCd15KIjibX75-OqQzNX4AGqpUMw9NBAt4HNH1ZhPrQFE~9t8VRdFXXJMu48PaQtQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40662,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Foggy Sky",
    code: "0404",
    render_id: 609507,
    scenetexturerender_id: "10712",
    colorCode: "#A5CACB",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10712/06985758_10712.jpg?Expires=1711702676&Signature=26VkkdEWjfSrSJ9476TNOsHTUXDTyCmoQKAKiZB6HH4AWPs1J~6f5-heG~2V7somA-jbobVQf~7ukDvBA0N4KNCm50KAZvU8kvXPColOYcwjeXNjh0qphnW5bWp8PMtP05AgdHOZDry3J5~oHZ3gVZKJl5tUwLps8MZwqESlsqB4wOBblmxpuqMGWZRSWZfsiSR2Pu7LxzAeG5cYVl9ENHBrdFHVJKvZdR7rB7w-bYscHTR-f13d7L-i8DXHC6LOnQCBKxCOuU55myzyCQ6ghZw8f5oINSIWNKv4cR-1JnwR3ryVXWDvpwH0bJc4WvRqiUDbPlPrS9-I5u1wqRwepA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40554,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Foggy Sky",
    code: "0404",
    render_id: 609627,
    scenetexturerender_id: "10832",
    colorCode: "#A5CACB",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10832/30278239_10832.jpg?Expires=1711695574&Signature=j0M22qRGQyNDxgHSuSliTgv2vqX5TsS1LHphEOw-r7xZJQpx4PZVhmGM6~ZZyFc~MGitF2sn647KCSV6WwU6z-wIdvIyVWz0aRlioR3KMddU888MWAnykVyYJz-nV8AzlDn5nA7beAWr6LRA-5HxCYrIqFad~yjYMBuSO8Ta1L~t5ci-LXSbKB9IgUiYyjGcA-Y79DBg7vJuK~oMGmWZjNVx2CRuIecsjIx7gKdVj1SSVD1m-lBLsidvtvg5e9i-9Qx0Q80socxLoM3ULgfXbkpk4QbHy7WhKR~i26LIJD3C7sxj0zJg9G1XNbmWtz85CGVvrGznsNdfXUY5omiuLA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40695,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Garden Fence",
    code: "0429",
    render_id: 609538,
    scenetexturerender_id: "10743",
    colorCode: "#BFC1B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10743/2664ed65_10743.jpg?Expires=1711702932&Signature=yum2DxLpHqmcpONCFBlWApRnzlm05zIthe1C1j8SLlksuQm4VawwjushDXPpfyK~v1AYfvU0-odYjvXeORPnM3P3S-ok9Z7tXU09JhHLYm9XtP-x4Mu1SmVDd3SerLB8pAaEo2TSvFeVAyfGnJ52OayUH0C6OC1o0a724m-u5z-vsYNnZvvU4KKUDEpBlyZnjbMqRXjh6TI4etXuRiGE5TJqNE-YmIcDBVylq99n6c~hi2JP~s~FJ6W8lh3fN3XinigvTq9oV1gn5CTRuHoMjPhKf9VHYWUPWRd0HqAl0~59Zl6APHIJ9tq4VgWpcVGOnx2bduiQDbIsrlfvXIiE~g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40586,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Garden Fence",
    code: "0429",
    render_id: 609616,
    scenetexturerender_id: "10821",
    colorCode: "#BFC1B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10821/9ac50ce4_10821.jpg?Expires=1711702475&Signature=YFBGnjGWuxborpFNXti6fR~c6FDr8Vj4XdoHj7O1oNkYNB3LNp-aqCMjYXhi6TO7MSakJZbKlZPEHM45oXxIeYV7gtGawHNjHbhGk~aTiD5w5dza64sJGw3uakybffXGUqH-iAQvNKGUJwsvmUtTdOucfV-AUcAaD8tsS1qvJ1E~6za9RRppXCAXpy~2M9vWc4IqwWMpe65ydIDpQZxDZkRIWAxNf4N7fzWE3UJpvUUD3e1t5t~WZLPEpH9cZ2YVLNtm7JFBV5B5yPfE4GW-CSfIP5WnXvwVR8auO8zKyvzQzV6ks~83n3AKgjW3ehGJAZHNE~oB31-EzKZWifJlLg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40684,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Garden Fence",
    code: "0429",
    render_id: 609435,
    scenetexturerender_id: "10645",
    colorCode: "#BFC1B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10645/69627c8e_10645.jpg?Expires=1711702676&Signature=g8xNK3vca~-mbWK25-Skc9gkdWN3Rnn9Ru1yGsC~vpqw4d36JA~-ifNm8Mft~w7IqG5vkvr8CL8kwY8q7wRO3ncdYljDuARW4LxZ-wjxgVq8yKIn6bdPdORy~Wz-vC1n7xchI4uIAcClrKw-qKiMDBtAQL1Pax0XnzEWrH3H-IxaPsxuByodOe65yv1wN2AXNJ2Ab9XU7OT4zEh~QUEptaOX5IDAcBJToXWJ7sN7twAXXiZ9~C5jpbjHuVXD3VMaj~q797a3eZM6k5JdRFsHX9YqZ8Xcug0SB3nDOgkkanz1AobtRvB7PhxKi3YrdynV49FZjcEE09Pcf1IxJTFHsA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40508,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Garden Fence",
    code: "0429",
    render_id: 609569,
    scenetexturerender_id: "10774",
    colorCode: "#BFC1B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10774/cb167ded_10774.jpg?Expires=1711695574&Signature=QaL-t~Qksnht~7ivvTuypgudA7pWhAzPli5bolal8ROlaYTVnH3Rc3RntkV~VpnfN3ZspYJpxMW4GtYXAoY6MVLrlXOzlChOECkB8cC5eff5AGx2jLHSLlD5qX2RAmW8nbVRU3FHOiqxy6j9Qon6YiA2gpFeyacOlfTM8AYKwnI00dmxr3Z~a-CC2e2svQ5wbzuuuSDr-ySyZj4f1v0P~iX0G~sGe66A2tIDgs-XGlehLfUSekivvI4j3-ZuvA2weGxyTfnm4xbvtuhCJmduOc2fjX6DCUKzw71JjEAlUqGwXf-Izq-VTanoRHoqgXllL4n9BBrE-A6VqDg0Cs3ssg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40637,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Grey Moss",
    code: "8116",
    render_id: 609529,
    scenetexturerender_id: "10734",
    colorCode: "#A3AEAF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10734/23d3007f_10734.jpg?Expires=1711702932&Signature=yqWn~XvwqOXDeKJ3RE-hVwNzUibGuktSew-w2idcbb0awIAd-iSXP-lf5pQiWjwXinBJ3y0gfLj9HU0sM2B3ryVjP7uYvFwabAMDF1xOlnNou3cRRrufue3aYMpSki5BiFw2xOu5mpP~DWw-gOIuYQBWtgOdOZA4OqEqKNBxfLFrMFdM20pjNF1pQVBk5~PE6No9dCa6Jv8PY9EkxOTgkionzi8o8eG850G9y56~FLLCNg-MWX40rnLWfsr-qgOZaUjogU01~sEjAsF4x7~dqhj9Zs3WUDF7g~EcO6ZnNeb5SzL4gSWl~yFhyyrN3Q-MNPOmIk2BbbOMtRpleaxUTA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40577,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Grey Moss",
    code: "8116",
    render_id: 609600,
    scenetexturerender_id: "10805",
    colorCode: "#A3AEAF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10805/30fc7775_10805.jpg?Expires=1711702475&Signature=XzMmpwgjzkxjzCDmud8rWP~BTl5vmkRNpQOn8KnX35q5zbknTinNf05n-0epjb5GYATHOCDPuEIBS1q6FRG0z94QT7K6XIIqZ0nXsRQaWe9P4PGNJcdhuAcucpIwcyBOE31KVqjfplrXRC61JbRJfgxpx0eRVKUhYJUcfJPUArVSfqyJA1-WZXP8OhjcaNivYtrmML1P2~HxmhojqyrdEbpn~fzciMlYNCSuTk63QU8AwJUhzFoJDilnAEVlIYWHWcm-GTa2IL2Mj7OilPsCBEKpKjGwUX9PiGvHL9e54jRjfljTDLZ1hksVffxGzJeZUa7pturbmmtHZGcYEmPhHA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40668,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Lavender",
    code: "5051",
    render_id: 609523,
    scenetexturerender_id: "10728",
    colorCode: "#D8CBCB",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10728/9c928e3a_10728.jpg?Expires=1711702788&Signature=3GXnlXs6zjF1C4GHL88ZaHZMiQZyzRNbZ8S5J6h3HFPRC~OPrYw9bjgkpRCcW7j8bokohMHUHV2wh2QzSBw-1C6eO6zUwqICT-D164n2uQVTMHf-OA2oH1X20u56pFsTQBYwD3mvvIqjv2uHNUPz4r5drcLUSP1Y-G08bxJldJWOzBBx18468-hHSKDXcSfjY-5YQrK7US38MaNf4FYmwrR4dus5w4juPOed8xSCwKAu~w0Lwz0wAT7lgUlDq2YuYVHqzCI6JkuHl9Y6-ItMHeGi99qpmQEjYHXgGDRTwOoVzrBHFHOPHnukT8ygtNyRemmbPurMBxUvxMvYBJsFIw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40571,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lavender",
    code: "5051",
    render_id: 609630,
    scenetexturerender_id: "10835",
    colorCode: "#D8CBCB",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10835/f7decbcd_10835.jpg?Expires=1711702128&Signature=FrrM8nQ8AdmBQyZAv1cIOSImuOz4DXIeIW6j1XRKdeyEB3BKRWWWjKZuYGJz24L3zREOOrNBrSbNe8~I0zqo3~mSkQLCmKGlWxwbMsuwlPloKIfD0D~Ld880nDr8WJ8vHZDsPdKN5~jhYPEBHwB~pNHAkzToFGsniEFHGtbWmdapijHU2q8W8ToM3vcvhQtWAgrDNABm6QAP2gY3m4HelTXYKHwtXhK1IxC1C54FBEriocoXqRWeyEMetMPLukPl3R8lvW~7rV3xcNGDKP0PE4X1Zi2Pa1SMfKFMq0eecP-H9eTaRwzk2Ec6uuinkNPKWUnuLEfuabecXWv17WSPWw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40698,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lavender",
    code: "5051",
    render_id: 609473,
    scenetexturerender_id: "10683",
    colorCode: "#D8CBCB",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10683/0c47b334_10683.jpg?Expires=1711702128&Signature=LArJU~Jov-Qq5HXtbFjOzPg6atx-hlvxXy7pwaOQYH5oYiPIF-bHNqunHKnn2-WQEekEPkJv1G8FvXQQ3hEuaobhEUngLwII94tD1ciKi~jHhpEeZC7Zaf5lfSmLz8ht1wJwsqTCB3ySSa0litGs5dSMmxbAJTQAy5ghXrcbZLLrNNZRWEVodXeSRdd6aOteFhV3LyXa1SXvhe0dU4A7p3VF6mX0pOh-hnIes9W-jd2EjB4mRbIDy~AUPMUCLfevkTOH1fZh7s3-MvkI1IpbHwuP~Zm8kYQiW0IU9VQtvo6WPGszBFL6z2xRCX40i8iWJ6H6kxIuDpWSGd9K~0Hwgg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40626,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lavender",
    code: "5051",
    render_id: 609487,
    scenetexturerender_id: "10692",
    colorCode: "#D8CBCB",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10692/b0f20edd_10692.jpg?Expires=1711702788&Signature=STwHRUPtyqTsmLuv3S-nNv7d208wDVQ9DoPsFpg4-YZrKRBAHBzoF7ds2X6vfPXuTdV8Z78piXF5G5cw2osNXnIlMylM~q2CQ4lwEVte3uMogofbx05sa6k4LUdilmd-RtXFlTUjQS11I7fTRDkKlSNzWU31baecAJq6AuL9lsmC0i5vy7AwzeHlKsmQ0FB4pPXditt9vmS99y0h5agqAIFC6ggHR00nHXOlFtjHo4t1cVYjWsco5towgyt-aUVZN4hWfQOHxFuB9r0Vnica73TSzgsG0rn4pRlr~Yn2N2Fm9w~ysdtWoVvAPwHDVNdeBiW81qLtxlty-I64DoF7EQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40534,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lavender Burst",
    code: "0310",
    render_id: 609615,
    scenetexturerender_id: "10820",
    colorCode: "#D9A5C0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10820/773d8e68_10820.jpg?Expires=1711702375&Signature=tCdSfAVZRza~oiBukQ0UUkh30XAIcfHiSvwgegcZ3qwFx4ihGDMCjywH50uodicINviRKHLiW2bHviybeRh5TKdFcT068ghrZGRwX2-NSB-snDYBRI0cC7gNJNH2kJWco3YKqC4ub54JQYxnTWEn4J4HC1RhnNeGThCDQo3oaVMq8if~eXCKiHBgmnQmT1zZu8vnEKHvCHC1zZatshsSUqFTYGJDlZISK3pDhVrQCLDJqt2JgMEg3ikESsd0GJdPUZaTfm7GOb5o6MZgJalNLR6CERCMq1rE-07CMzQMbySloyfombQKEFoBa~Wt-murXV6R4Ca1U3jHZgERtikb3Q__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40683,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lavender Burst",
    code: "0310",
    render_id: 609615,
    scenetexturerender_id: "10687",
    colorCode: "#D9A5C0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10820/773d8e68_10820.jpg?Expires=1711703024&Signature=mmsbbjPs6GIc7IrKDakLHzwMqZMENQw4B1BiqtiupHSDLNyeRt0rSXYJ9GYD4zTmQkvIBJ3byVonwAaw2zaLqMx1JT6FbN6R8lRf1eXJ-OuB6NcX5H1fgoEov8SuBBvp9YKLTXr9vUoIehmwFehE69Z-WGQ0ZydRyXdDbHBOTzTVXyFzGqr1AzVyLXzbTSRKqaGNRreTIJDxJxSYOnxfEjr0GlgnKiMFUofbs-4mumxgaI1fRFS4N9ph9DFqrV33TZt3XBTFTI7MelJRQnDjFIk61esKTEqXSue8qwTRIlVnKb0TIzxPqJhFZTj~oLfakE2u4m38AQHYMWXuxIaO6Q__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40683,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lavender Burst",
    code: "0310",
    render_id: 609561,
    scenetexturerender_id: "10766",
    colorCode: "#D9A5C0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10766/b01b4df4_10766.jpg?Expires=1711702375&Signature=n7ZLLNNmhlYZVWPfZe10FyBogJVX3VbcFF6gbfL20pcqsZfgqMhzpJfFFjdHsiJAGF0KY5d7dVok0Lv9~b6MJqFIL36FKByPW~r7Rejh2Hf6gJ~h6AfgvVPUcAtqCYIsv7F~jTouJk6~fPZDVAorDZRu3kKzBPHnRS5Dg141Oure-KIVBtSTWOB2IlNuLjxuwIz5TbodF109xMFlJYhbZ3ny3DGjqRJ0puBsIhXEHOYXTdyLG5~kZwQM2OgDVAjnsWWtK6OTyveysbUDGLwfqhfwBxXHsVrypFyRAogIxoPclWuNKdyHkCNZXZaxEowE-Gnd0nLAs17bCo4aKvmWOg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40629,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lavender Burst",
    code: "0310",
    render_id: 609561,
    scenetexturerender_id: "10695",
    colorCode: "#D9A5C0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10766/b01b4df4_10766.jpg?Expires=1711703024&Signature=Z-TLRintMyDcrOzMRfmmXSxRbkWHgWc8EsUYHE6T2B6yyqbTleMxs12efVfmv811U2fTBEhS~TeqONXnnsa-W2lrIuU6OldsO2Cbw1gUbsT8gRRh78SC~3X~Yxpfc2NO8zIDysCaE~rPXPkb2DRutcNEbvvgzEGAs-rYv-bGhsUtCG1VmdMfZcq~gk4zZxdX0rjVK-pusWayuAahaMSDfYKNvr7XcYTYVPrQq4j4iGX5ab8qOpsd5bHWWluPkbozAP~oWHzVKfBBARE~E22JESAOnobU6nWBtEQ~bKYgvhYAagBVyhG4BI9hdP7-zcTYMuIE8VEyCHS9AuNpv2TwFw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40629,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lavender Scent",
    code: "4032",
    render_id: 609480,
    scenetexturerender_id: "10685",
    colorCode: "#CCB4D1",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10685/1afb7e36_10685.jpg?Expires=1711702676&Signature=IV-84wrB7sH-GsCrRWkWibf4swprx0COOV7mx7fPG1074nVIfRxG2AFnK-GKS~P3CDiVKO~cFvUEnryxpyGzs8B3UzgdWKv~4tGJ2G44wHSraNfsvvrO1M4TdR0HT41qrkFYpWiM67gJ26WrYsjn68bM4G6BTOSssN2sSt5Z37VahV0XPqVQJW-Y6bG6jmICtftAA-3i9lFDDiQP3UetY9T0HRUUbho2xd5ptaoayLNdvM73VqRdieFvtGfX7NGUrcP5j9gkTLuxjAUOKMKvEIy8Ak2rbOR15ErXtKiV3rbufI3EIwtjhkJxKKh749RSFgQThtUu~YXRw2vY4FRtKQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40559,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lavender Scent",
    code: "4032",
    render_id: 609568,
    scenetexturerender_id: "10773",
    colorCode: "#CCB4D1",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10773/3d890dfc_10773.jpg?Expires=1711695574&Signature=WClvLlLlyvQHul18puzOqlLJqf76opwkfI0zatiKAyBa7wlaeFPKklh0CixwtJK5JkInYkN1ZuwjpqPpOBKQwdcmjnx1Sc5p2jKO-Evw2LzFIrMbW5shGeyLIHxNe~eoGCBxS~~fPIh4DagT3TiLu5use5kS0P5syPaJmXA0fonWCpN8983Hrszod2A-2AnncObxtQ1r5l6s5U~uzN0Ay6cjGsscX-qMkENj93ssAoqCQgdMKUb4-TQO3ld946sgy3IpU~slWklntx2gIkX57v9hYacW4e~ht50ccdWf3wSl1~1oRS4or4JH8qt2yvBMdoQ6vRVnO7eWdj9NF1VEfw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40636,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lavender Scent",
    code: "4032",
    render_id: 609517,
    scenetexturerender_id: "10722",
    colorCode: "#CCB4D1",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10722/3a23240b_10722.jpg?Expires=1711702788&Signature=PSYi8IoLuNauFsYr3522RjtC-H9A8Z4A0kmeM~P971MKZfqplXnbANRGwim~jQNhhegYAM1~UKHIKAR49ilQK2PZc9UN1X3DpSGAvX80iyy7NjReG5zI4pEsRsGRRg1xlcqQTjM4Dqh5gojNSRsAuoxxnmhpKZBW52OMtmIUcNcJDz6JlZkPTDjK6ma1-zfymRtiz~NaMjs3jcRmeNTXf6lgs4xtOaviNzOlwLKtwmitRn7SAeZWmFk9jXKUwo5A~PbsmaZIRdMDwviMZ3nC5rqvz3TpVSoGqc7KO3gLla84VVla4Tw1RGM501xOG2QCEOX-Y1AkxI2yqIqMtfDsgA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40565,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lavender Scent",
    code: "4032",
    render_id: 609574,
    scenetexturerender_id: "10779",
    colorCode: "#CCB4D1",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10779/729c4004_10779.jpg?Expires=1711702128&Signature=GxX~7GAYp2r67EJRyvjfDMH1KkvKFjXYByRGvs~lcHKZHHHDIVtuMwL2VuuM4EAKhMCC3IQJpcxDYekbWUgJ~wQtBIkQwpldi3yJQiha0lE1BXWMp2Lq8K0JbT~hHF1qSH6LUffww0ZwK9-xx7gP6vZnYDnbZYKblx6gxoydIKZYpy2PQw9wriLMPzrMIbWakxOJFZ9B4srf06EJlKnyHVSzXgwj8xWY3BO6OKzUDCA8n0ugYOBjmH2AM2dK9iSDACtZjCH1SVxBj215EiJqFEbbi48dDY7ASPSeACaGoJJg9hr6VjBRsXxQNvyfUqNGao31vglDepsZ2kw8L-CdOA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40642,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Lemon Butter",
    code: "8092",
    render_id: 609489,
    scenetexturerender_id: "10694",
    colorCode: "#EEE9C7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10694/ef5f05f9_10694.jpg?Expires=1711702844&Signature=kcLlitp~qbBWtfqm9czy9TdOzqn3CJe0Aomc-RvgmIlbipCdBEj8MnRn5HAPs9A9f3FcnjSKUllrCc-gqeUGvAwbmWn4c8qxpeBOYXTF~As4GN6jozYvEUO4TiJA8exmdsRjClqsltGUjduPOwvIJ2-7CyJZkTV3d-FxuJctomk9jEb0znzHFfESDrhuwWOPskyxy9stBG27wEAHwyQtoOJ8hjIvNOjEl6xvjSdi5HMPGluPJF91-vruHVhQJuLn0tvoQ2v6jbOHb1BNwbHkiaXaHIfFZIF0khJsoMCC1Fzb2FCUnD9j28CXT6SO7TbKm2ktuxVHCbLrpVLlGGlMoA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40536,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Lemon Butter",
    code: "8092",
    render_id: 609638,
    scenetexturerender_id: "10843",
    colorCode: "#EEE9C7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10843/6b665b84_10843.jpg?Expires=1711702271&Signature=BuAP32x1rvAgFET6rkuPTyuLRsOoLDgWyio8lvq38YQV86IBB2~-jtLjysP6t0F0meQUyliYSe6vuK9A5Dc7Tn65zGdJRiQN1FoLAQuVbzu~HnexSSn7nqot6sWvmnEU5FYi9GbyZDcnt7hcM614zXATb8eAv13tHxlku0Sazc2eWDS6ZSzF0exNHs~KYbgIqLIO4UiHviQGgY7o~XNfVtXw8yn6WT8cwrgoaSr1-MdbH-~JtpU7dkUMGvYRRRJAAaWjWQ-eNo5Ji4~TI8hpTaziYJNj-u70bIx7f92tDhNQ31qjML3aqbjKVrOOBp-7OKPQL3L7q312wMBg5E6rng__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40706,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Lemon Butter",
    code: "8092",
    render_id: 609472,
    scenetexturerender_id: "10682",
    colorCode: "#EEE9C7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10682/98170b3c_10682.jpg?Expires=1711695574&Signature=hYQ7bscdL07ioHlBL8IAbaKUZkHP5OoGKWr7Zq6qXJVzneh3A47219Ndln4h2du1Er~O3L3V3okxmxXN2SoIN6WzUR2~xlV1PH6ga5KFVlrzmsouZr-FTueXJ-0OMTvHCzMYqhyahYuMOdKWEX0FRN9LBh4Ra5fkbB15fOHVBifCRPJ5cgaSOo74FIPfZ68KZ33oG5ParzLD4e4q3uh9HTDu3cbPn2XQtRh3vQcBvfo~B4soOOdgKeZxNMZhBf74u3p4Ahd2CFNkbzoEre5kF9YfSFF1FYsHWCPjAf-DppZKwEVrqGt~R0TLubW2~lCdhzD8jXLlJsX29N-zOVYSGQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40625,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Lemon Butter",
    code: "8092",
    render_id: 609486,
    scenetexturerender_id: "10691",
    colorCode: "#EEE9C7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10691/428eb163_10691.jpg?Expires=1711702676&Signature=XXE-Lwx1-L8K-Z~I4hAFLIHsAih-~uhKv3lYS8Um7eT8gfhoimrnwv6~Krc0NhsTPpjfc5sjPIYHixHpnOtcR623OtOFg7j0P23bfBwtqEtjCy0UsBZ0ebxTvzUGZ2KCmFZu7FDcoVMCQXLtnMxTH41PbJDOZTBhX6spEu1aKR9aYCE69WtEtHxn7qCzCh6ykKei0Zk2OS6Hl0psXnIPidW6wPGTJfVAIRGCc~MZluKFVmZ5ywFJsvrIp~rjYD0GLCFNbOit5JsLcpxLLbRn1cJzmb5AQZOmqpsChXFaU96mWyio-8hpoyjawKF9uA455BGRb2ISzAt6v-f2SVE9Hg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40533,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Light Grey",
    code: "RAL 7035",
    render_id: 609511,
    scenetexturerender_id: "10716",
    colorCode: "#C4C8C3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10716/e8e2fb57_10716.jpg?Expires=1711702932&Signature=tPhzmKUMzmhL3Y~GRoYlcu9TxJr-vg7HBbRJmbiZaptK~zFeaBCwMs1n-59oXnvoV3K-baEx4Ab46PSyizyNJ~kPQl6Fj7jPtXgIadGko7MazsRjhMX7tGSWz~-YltAd-1ZdfqxOojEiX1c1r6456~7XxxA~ZRkx6LZ7jjihgRw036qwbE7j6LLHc51iWiaTqw6n-cngmeamuowHgdddOVpJ2aFhy25fnWCaoN2v6PN63njgHDSz0453p49NfhbYAqFUpkKp-R2eJRgmOENpdZQXw8M~nM9VdNFd5v52S~U8RiZwYoUCIyumAzwh4uHGMSQGvWQ5jNEkiWzSNe7~AA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40558,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Light Grey",
    code: "RAL 7035",
    render_id: 609599,
    scenetexturerender_id: "10804",
    colorCode: "#C4C8C3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10804/9bee5376_10804.jpg?Expires=1711702475&Signature=Z4PAzE8ImPAG-FW8yiAQ0jD-o81jBQdI2q8BEVDLXkH-0NooCNCTv3JcrbksIcjfYgMnPY-mlNgFxzkdAHtsVZOqYm-MK6oNwvyvMSVN45HcOLmAdIbzrNukl-gfyD2CJ3MYWK3N~YRypoqdCa6hnkCJQ8FwjIgOTRd-~5ya7~1bFv0nlSUndVFYRcUQY7H8YTD-fuQa2HI4f8IcFVhSVzQDJ~ehDiRSrAKLAK7zqBDBWjFdLaDJt-qIORJkoMkxTm8RNrwCY0hsYfyaJ77QsweJ4Tlu0J-EiOkIsGAu7D4fS4Z5wX3FXAE1XWHDnxHMT4lmRccZVslKiN6bPo0QZQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40667,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Light Grey",
    code: "RAL 7035",
    render_id: 609559,
    scenetexturerender_id: "10764",
    colorCode: "#C4C8C3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10764/164438d5_10764.jpg?Expires=1711702932&Signature=x740cKYyTn~rCEryZdJaU9tAOW69SxG2UWHJSYJEqkO2AgJtgxza1IlwlLgtB7pHpisRI72KPvSnUr-PsrfWwXkGrnRYLrC6uKiOHYqUbGo8tiETSEDeNZ0YA3CRGt65Dbh3Z5~HNCPWyKQTWZ0MWVfpzVwr581sIKpDGpjwf-CvHk9JH0udTHZjIhYJT18wi5ObyPfPMJ6skCBADwmGg20Bf8CkaT8TGSRckv8e9jvZ74C~zX7kOumyADwZDRBsr3cAo64m3~vrb2FCh9sHllMl9OF~vQFfLI-RznITy4RuGazu7FFL7uAb235QoXylLvmdzGB2I-hU58hxomQo0Q__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40607,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Light Grey",
    code: "RAL 7035",
    render_id: 609562,
    scenetexturerender_id: "10767",
    colorCode: "#C4C8C3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10767/609841a1_10767.jpg?Expires=1711702475&Signature=355x0fPX5oXuXZnxXF3xkj4a7LKTldwjiTrUoGR4sIKz67uPoASY84my26EPW61xEsj79Hpg9eudMgnc3ItiNdwfqe1Epuzccd13Rp7gaeAp9MPThSJF-1wTScLAcnVuoLmVtjZT7XdIMWxdmER51bMtr-GH04jMIDKj7EHFn4aIBnfBy0iy66IkTMn~07E-LvQDHA-YDf5trmUDhQ~YMaNJC-3MBByINVHGL6iDVP3lh3Ij9Ug8JjI0D-R75un2e55Dm83rgO2X3g8Aykz~BfhAxQUFzFDRddb4VjXZVqn5-QHEvojOFrMkVjeXYGThtRAgXa8DfrfdXfWcniu3oA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40630,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Light Pink",
    code: "RAL 3015",
    render_id: 609614,
    scenetexturerender_id: "10819",
    colorCode: "#DEA1A9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10819/ae8f5ac5_10819.jpg?Expires=1711702375&Signature=Nl8dqUY9f7L-mAkhwJjACcqOlumyIlJljCz7Iayie4WDhwm8oyhH7wgUqiNLkZg1kwUUGlsSZLlugdaYuRx5VxyZvjUbuy3iPMB6PXxtlhQxXGXF~K0Bbbm9z6TmNo0RRONWjem42g3kGNn9mmvgPzio8RPhJUR-KeXARiNTLaeRVAdv2M5UCMtXk8IlYzcFuroQWJ1vLX3vZBhX03T7qVIa3~KfuE4Yfg~s9F6GTx5e4wlkuF37bU8KuWdCNKiyjB75gydvXjRfYYzm4qmKNvRrAFmXAq7XOau24PJ-0FQRMFN8vkhuT6tj-vZU-rpaKVZmYZMv1B2sVtxxU9gLdw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40682,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Light Pink",
    code: "RAL 3015",
    render_id: 609614,
    scenetexturerender_id: "10742",
    colorCode: "#DEA1A9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10819/ae8f5ac5_10819.jpg?Expires=1711703024&Signature=09Nll0FzAFt3d2Ebm8iqNqvm6JH-hRArI902WbP5icTdRKF~31WaiBWRitdDdse5XEc~zRh~4ZHglbjBCZS6I5dBfZUFc~xefDNEpSVAqL8nwQGPemN2a3HcT2xMey-JBQ5ASIb3uUPffz~a42exGWpSereDMIBR0wRDJ5p0UY5SuglUk8Zo8YbOsoAEv2armz6HSlYTuHdk06NB1fY1iTDMUDq8PDzj0WcMvMVZJ9Nt12hIuymQ6FF2R3ubYykk3RQxND4~ccU7MgMoN2meTDzYwrLS~lV~-~gtMgagWtkMFlSOemsm-K7jkFozockYEEE1qE5pFyAQKhH2dOjqqg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40682,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Light Pink",
    code: "RAL 3015",
    render_id: 609516,
    scenetexturerender_id: "10721",
    colorCode: "#DEA1A9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10721/840c37a8_10721.jpg?Expires=1711702788&Signature=wTUsPa70z3ZO3IDF8cCQxWEM4uDjnBSVC8hC6ASVNqyj27OufA1ZZTQc392GvkfUKw9au2W5vKAHnUPYu39bc2St9uFYxDFmEZ2JiYTjsQTIQg5IjoEtyjdGODk4RHo9KtWmNGzmU3qMbixRPNpSKGPz79jaCW7EPezpCW0OSzyJuQaWSLSiPfTqQBzC~DgHQL9WZAmnODBx5tC7XIqdqj05mSy7v-GqXNZeaBvFE2t4pETWJm0Q3etL4wPhPqHSddAaykS8fugI4sAt-gkhP6QDSx28zNTOYGEuTSLoCLiJT56FF2WJzjyPCLaqPRf1rdQK7PBK8K2a~7FYUfvH9A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40564,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Light Pink",
    code: "RAL 3015",
    render_id: 609573,
    scenetexturerender_id: "10778",
    colorCode: "#DEA1A9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10778/f576a8bc_10778.jpg?Expires=1711702128&Signature=mnddkip7zvitGIr5ugONdYmNysHm9STUiWCd2MvdsLZ9wOjOhlIko31sLGokbtSyurH4xMvIbjH1JyRbVOleV8uaJw76KsUmIVuceDG8SygGNRPmHede6uWSIutAXKrANFTBucU6vxc-I13FLNUpe3Jc1h~hYBDzVaqo8KMTP0qpI6UR1C-u8aP50F3vS4guLM2w7ID9xgE5hMdRNo5NGnPpGwNT~hKNoU01i8NDCgqrOj1VRu4S7mC0zFEj2VPNqWBiKhcJVqXKt-FnySM8-e~UwkPRzBFlDFxSLWj6mccVJCWoLl2WLLN~vPzAdGRxWvuccoEHUxAc7dJSBCoxWw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40641,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Maple Cream",
    code: "8078",
    render_id: 609521,
    scenetexturerender_id: "10726",
    colorCode: "#EDEADF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10726/92debde2_10726.jpg?Expires=1711702844&Signature=KVAkJ~ulER9SzPxxAnfTNF5l~tPtULVZRuoL9hzJeLEQEnubb3Rb3j7Z0FxnYMfqq8y5zmnZCnkn7B3T45MP-C0zomuhyhwCYfvevnzVdRFDd9ybl8to9Wb4cDFcIdJyagp2VBGZLH7kDRbw7zWg-tJZgDZyH2ZjM5iL9403Cj41wwxayJSghCd9MwCwsqPN53k2LxfmucMM~ZkxzQkNGRmo6o6UXnufmO3WGR6F1j0SiBLD8lbCG6YwNzjh~5yY2bbM8mC-iZcJcE2r1ujgaOvNBiQZ7uvfISipQKd0D-PXJ4Psf-ntspwnRvsLoZCKgJqKNMUtoCLUBuMaK~W3ig__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40568,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Maple Cream",
    code: "8078",
    render_id: 609577,
    scenetexturerender_id: "10782",
    colorCode: "#EDEADF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10782/6a6ccc22_10782.jpg?Expires=1711702271&Signature=mYoE4eggrk3papK9uv1kWRn9SFi1Z6PVTa3if0lnuX1a0NowHB1sLQ0hTwfzqqPZs5usuthEsid0tcZ3Zl8ux-2eTl2YwoAhnOFitfd~0uLnzuhsL5RtMTuR3HnZqgm6VAk1I32uwgXeLvnL8IMOoAQNZSSsD~ZZ8ZOUtHs-Lx5ZqkSwsdCtvchp2y405A5ByvOj~jjkoDWLHQqsixEtYPBzYGXZa88zEYJqDClL0YbS9IVYAEfSgxtusCQXQebA9q~ClsT~r~OjRIK41-0ipvQk-aRsct6edVpZPRhNtU2UREXaCAVmT1kmuTnxXEehxpiRPvc8xwpWMbwoMI0flA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40645,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Maple Cream",
    code: "8078",
    render_id: 609474,
    scenetexturerender_id: "10684",
    colorCode: "#EDEADF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10684/2118d88c_10684.jpg?Expires=1711702271&Signature=MCs-HkafQyOCLg0duZ4euIstoOUgRrGhLXCl0uUMM4fnmI7vYF6onoMHr1~anGuxFFFmZPYt4LW8VcNfq2wP~RPz4S~xzFJp3ff6PaeYZp2pxJ65eybBDT9zNeLNZNww5U4zxVSnX-OOtjvTaG1Kob~5EVvi8dyya9WwKg4iaT2b9t1Kd0XPJc9jQhrWK5cgzAaoVWKQpYXdQI0K6FL2XBJqZKK2JLw9IKPQ1zHTHdpaq8bDenUgbrn~x8xMNoV4D6h19IxzDxBZq0gza1hd44wm8Ll37X4CcxIRF7gBpLuGGEFWJjAUGzhA8ujtXZKEQZFJIEJSkJ2QlgOxwO1mrw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40627,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Maple Cream",
    code: "8078",
    render_id: 609553,
    scenetexturerender_id: "10758",
    colorCode: "#EDEADF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10758/448a07c2_10758.jpg?Expires=1711702844&Signature=UAJK79kkC-a5DuzrejrColvq6egUClyqiqJEOwJULdZftiGBla-zl64Pkt4ftcHBwHy2-0AxFmAV1ACiHjbebfh9D6OlOPM8tk1VrpfW3Uv8F3N~ZIBbO4HP3-5zlq5FqFYIAiJQg3GyCXMrFJGf4CirxzHjzaox14Hyh3C26loP5iHvOLUhr7GTAx54AWnd98CWEmUjQ7pUkRJlroislx2AD7M3YcduOMCuk20DvnSN80-Qx0Py6ElnMLQIfeQpeCSAxoerbTGdfNFUAnXev-~Cok2a4MWBsnM09427ovk0zI7Ym9nIAdk2fDkiFZuaYCVAV43v8yxJ2zGHVPR8~A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40601,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Milky White",
    code: "0453",
    render_id: 609463,
    scenetexturerender_id: "10673",
    colorCode: "#DDD7BE",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10673/583e9988_10673.jpg?Expires=1711702271&Signature=Quyy1YAPWTPlpsngqY3a9~mXBvZEArVy2zE7REOD2JSjIpoHFQnVkBUJm6~jWGeK8dPV0U3L8VinFDBvKPb5m9By1tOHCcH9J6b~vfWeLsIn2xyRIt6J0ICkoZ~2UulpMreszjGKfy94BmF3b9ofzazGGI~IXgAHEzFFcnNGSordIkuMwpRmfKNzfWma63BnbXZb-LP7848PBl4-VsxPY41~tE-EpveY9KZYi4aSGbU5W5gFjDUyj2TKv66JkfjwXv17ZMrLvNOy-aWwhfrzxJUZ96DOkuJTn7FEwS~Zy8MIwYPH~OUk88f47tacd992iC7zd~ljN07SPUMUfMMzJg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40616,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Milky White",
    code: "0453",
    render_id: 609528,
    scenetexturerender_id: "10733",
    colorCode: "#DDD7BE",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10733/47fd656b_10733.jpg?Expires=1711702844&Signature=TT6o~f9-lf3uCuMFspW-t2ZzTILitSVVJO1ChQCygK0-7KJbC2S~Z-vviEgHnVlDCNScH9TmhneamFzZGGkEVuPVZBgwW2Wuf~Svnzq3HjOwXbYNGlma-W~2oRCGdV6TnvpwhhOQyAy9Hr0N8VkuYP5sQ0MvWvE2lFg2qtOd09~P9bq3vrdfoRGc2JbyK09KP00lQ6HFv~SvwtaXpTTv01oIQorrN2c3I8N76AOaAFxTBV9N7wVrO4XM~ggl0KdbICYHRQdR6BWGwyLFrIQ75GLR51SSctQ1OUAh1hMM-t7t~UbhLlIjtOT2vdfNiVugyB9YqvD7VIk0QFqptnIW-w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40576,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Milky White",
    code: "0453",
    render_id: 609492,
    scenetexturerender_id: "10697",
    colorCode: "#DDD7BE",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10697/72b9681a_10697.jpg?Expires=1711702932&Signature=RCiyJ8vIoEQ1qBSlRTdAdCx4~MH-zi9eciKTdCkoUUojq0ILVPhclYKVn3wqbavW9cT~K8I-rsYuSZhbKu3HbAO~Odq~WCk-VlqmKRFHJxBs3MmQIAVxZbktV6D1XxhcXND3CwAKKJYbqXY-aEZNKl3sojhqn06nIRlQS0EQ5X6THgfzS5DhKpvL4TMyaH6~M-altHQLq4K6Tg83NUIy2nGCXxun01Y2Oxqac6xSuRt9ubLGeGhyAOdVBbx77Mf5Zu0IT-9rvteNhqfWe5OSLpkRbfrZ0dVeNhypr7M8gfe~9LKL~LU~2ZuZEwcmNvmBUPvbzQfsxeiUHq3YpSVW2A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40539,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Milky White",
    code: "0453",
    render_id: 609584,
    scenetexturerender_id: "10789",
    colorCode: "#DDD7BE",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10789/9c9318c0_10789.jpg?Expires=1711702475&Signature=2erjtCnaO3~PDuSxplcB~WnAp1AVD4lMMyf1byOkUVa5FDTNifBVPNjpicvUk3WFuEW~qG0Tl9Knl-dN~RzrnEdqtYUEli1fQfCN~Pw244vmjD7zLmxVyI9LS-nycgw31g0KZzrfykCy~3l7h~HKsnVaVrTis9wnDrF8eWGST~8Qh8gi3AeuX3pdQ1rilejS0FLy1TAR3bKJJValdtdB88Pd5qRoCGoe6tnOeSJGulYb3FofbWHMrNChdc4A7-iRW9Us-ZHcUrYWoKDLIvw7VZFAFjDcNh2lIsmVtb4GM-U5Sb2hmOB-Mlb6gF2Cu6UcIWpj9uZr9QT73BdLo6r9Aw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40652,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Misty Green",
    code: "8085",
    render_id: 609494,
    scenetexturerender_id: "10699",
    colorCode: "#C5DBC2",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10699/af917d47_10699.jpg?Expires=1711702844&Signature=jnFvsBmb05Y9pEOzPFjpXYWGqXIccWi0V~14Enf-9QC1TJiFUI4~wQagju-GQQN7DMqZ0S0HHS~sSjSZKsX7TXgfVDN6xS9tUjCESO-I3RjulcEYyK-7KGVOHLuNR-g9LGh6B5uUEfVPRBqw2i7AEv4Wxg92RFt-jkXtFQ3bWua3oszCHcAJYDMyXYtBEmMOfqO4tFSkqcufJ~9-i6LW1uG4BqNks8Fwjc-tSH3NJ146YFaBUx5yCIYGKlvFyAvPS8WvS1Ya-kyOpx34fzm5zpTIsf1A45DAfxkPMuAUmNB0WjBZU01RujMb0CUW5kC0YtSKPPqdw5jaUtqIJtzFpQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40541,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Misty Green",
    code: "8085",
    render_id: 609612,
    scenetexturerender_id: "10817",
    colorCode: "#C5DBC2",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10817/1af0662d_10817.jpg?Expires=1711702271&Signature=GlDma87ukg5WZI9apXEhLi5XZoB64rHHp6zkZ8WDvr78zN7gMeN~V~xC2PDmDpQSasT4Dd4h~-wsVAwF-aHSyHZ8oo08VQB71Z7CfQ6CD67NfYEb5iKsW3F1CquP7Nsn~5To4UpIRxP77seysMeJYTB6kuwJvpZsANBvmOJU1YMOUdxiGsWleqJoGwLUhNcOIBGKwxCxIbAzgranp0A4BEViq1haxGMezVac8L9d0RQ5YTDx1t08Zg5EYojxkuAaImiMwsuVqHnau3DcE97wI--WSNrXQroG2kQb6aX17JUk1JU0VO8pslRm2V-RMnmmff7X6sZQXS0lTkReEtBDtg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40680,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Misty Green",
    code: "8085",
    render_id: 609552,
    scenetexturerender_id: "10757",
    colorCode: "#C5DBC2",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10757/24d3051d_10757.jpg?Expires=1711702844&Signature=wedvJ01biCFPOJkH7g5NgLVzqG8CX1YhvJBJZJ4k--Z~spOKjY4WeVwZYjTS2O2SCVcLUFuLUBH~BdLK-hfUk9fD7YLW9WkUZlDyf~a-A0O~EHxVT5zjYUnBdrqdmTYaX08zFJWUwPZqRRRzxArtTIos4O3YW1-Yg3xjCr-i2~OehdHoqI7splz~CCkDLmnbkQkWqUFDE77pvVDNOc6enbSXpp~Tk1wNm73hmHSGbpyADVTTT0lVmE7PYRD-yuf0~G4mO3PS5gotRU7c~VqnJ3FLzH0wePK7m1P2oW6uN9h-OYjXSkveUDfXgcmdn2OPTqZym1zcqX5H89IAlaGzLg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40600,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Misty Green",
    code: "8085",
    render_id: 609637,
    scenetexturerender_id: "10842",
    colorCode: "#C5DBC2",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10842/0f473f11_10842.jpg?Expires=1711702271&Signature=qHRKYydYq~lepo2x6Il8kkId~TSrKExlYMUJCcK8aDsTfzqaQjRV18THQ5kNHLJMPOJrIGkoikRGMXpw1gR3mR5-txItudTiPFh4xkSACQVUK15aX6D~nWEOtKZ82xcg6C1mSTLeJrHxe1UjcBZVJYKj6Y~WVGJA31DugawH19cMmMn3oGFjKjRwRWvsPgv1wdEfZIlcPDIiqcXwBX1CeQwwsf6YTh0~Hf6hreOYuLBzC9vCwX-aqXwJpsuAggxNr5w2hzE3hM9gKkveCI2GYWonJfpGYwXUKccUR2fCkJttK7vsjJ5V0542C~0x7bpaaQVibWPUiki44eiNC9lswg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40705,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Morning Mist",
    code: "0473",
    render_id: 609567,
    scenetexturerender_id: "10772",
    colorCode: "#C6D8CF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10772/d3a88c5b_10772.jpg?Expires=1711702375&Signature=o~l8SBKyd6~2c6lv8DX-qZg4uBBepEzBbr0KzaroSGvcWTpNCtUbx1AJk~cup3cI---2mUTSGOGpADCi6l1PZJKkOWNpnqcUL-9Z2CFw51HvDAj36XCXy2VTMJkcfY2vWf~LWJ1kcxmHcJI-j5Hcr75L4LIeE0UJ6QY-ZUetilyjXTzJwIzy2gs0C-QaB04hxsEN7-qZi6ngQ-IaUAYdOHsyUW-1lrWqHFBwQgM0VRgLglcuqt8xT4KUIOveBszitkhQkpeOUnIMneu5BxUhM2uW6qx3HZ4l-AD6Dpx3~7lwG9wM6b8Uh2J6rX5nIYo3-fV5iCgQKTIBkoPKeI16~w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40635,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Morning Mist",
    code: "0473",
    render_id: 609567,
    scenetexturerender_id: "10762",
    colorCode: "#C6D8CF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10772/d3a88c5b_10772.jpg?Expires=1711703024&Signature=MFuACUGDYA2fkFBGOx35b9Q3xI4hY-FvTLMivDgrKO21WSUMxxo0vrAKl7PQgja6p6z5IByIJODxce7N7J8np4E4R1Ucst~SO7gUA-QGwyy-ldT1q0jhL~q17CRjSlDA9pIAYo7r73oSkM6hPsKkPLdxfULmRy74XNGEmX~m1fLusRT-z~~8-GyFPwFRhFKtiVU4pUgreURC8tJtD4~HF6vEiEFRCKSJ~oboZVMoVTTYY8ampBAe23FIRzlgo1BVWhke5fj8-PvgwlTtaxNNjo067K9uu1oP8NHxvoIkg-q8rf5gF0nzbITxzZoP1CY10QxchB3nMsqKaPbumag2wA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40635,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Morning Mist",
    code: "0473",
    render_id: 609448,
    scenetexturerender_id: "10658",
    colorCode: "#C6D8CF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10658/e35da98d_10658.jpg?Expires=1711702789&Signature=HMhhIgEXMFgfGZyVUd09yd0a9ALLd6Ve9hs3eoa~aiYWCf4bkr0Wqs5A3GYL11OK4dYh2T8Bujl~DYZsyQupEUHAsmGYPmJMNy2zXyh~r31EkFLq9IhmTtzfh27ZCj7rscZDtFtm10cR1t2rXuZXfwkRU7ecSH3TJpMBeUFThFkCqsPZ23K1WoSkq5Fi~c3SNhO-NqdJZ70IJD-6AhbUD0RdRJCDi6JVYYgSAA2HbM~86QE5ndMc82AoO~HBCxOvvGykpUPC3yg7F0LWX~mfF-0wF4QT8BSVkqadLrY7FKskQ0b0s78VLnqQn0V8HplWpQ3Cte4syTBcg1rRUAdiWg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40520,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Morning Mist",
    code: "0473",
    render_id: 609593,
    scenetexturerender_id: "10798",
    colorCode: "#C6D8CF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10798/07f2201f_10798.jpg?Expires=1711702129&Signature=LAR8ax3rb6n24dJgk3stHTQEt~2m~1Dmd1aIFA1p57FAH61vup388rl02ht1n8ZuJqNIYe1Z2qfqWjzEYkeI~ff59OAVXe6cJwVaj8qhq9vCwtegwr1C7Hh4V9i14IWgp8xEI9Kez2~aS0C0Y88ezYHMfPPQ6KjXxfOh~nwMChSRYQCTZte2HkH77qnacLrwFyQbDHory4I5Pp2pmY3uPrJgnzau39WL4yHho6N9FP3tXR2qLpclAC8tGgXbgu~rXUn8qyu8iUZUqnxMnEo5-0~oxHoSHitVrRZ4S92hEh6Oh744T0DJCU3nVopO-1RUss7TQwpEfqvwuBkpR~NA5g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40661,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Moss Grey Moss",
    code: "8116",
    render_id: 609564,
    scenetexturerender_id: "10769",
    colorCode: "#A3AEAF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10769/1fbbd010_10769.jpg?Expires=1711702375&Signature=ycB217qL61GCBDc48lchDzslMyKvtEMzE9HEa5d-OnkyjEm697xlifq8S06xicb~hMvo2r2uDlSCYAUaz695p8J0nzVZGmRA9y9kUuSpwD0EqJCLyMwCvBsl2Gq3I94bxDFba1GO7HFMiTRHYcl207d~47PdXLbFNoyj-f91DGICb1XXwkMo5eey2WE4jg5zcdEWCtQm9XmwdwyILTeg6N7pQhQfLVFYX5wTCIf5suD4jexevEWVpJYbblid1mYr1ZEqdTZtfP07KrcEKy54NsbiEToFn8xCYNKL6-V88dR405C4QuN633dqQYjhC4oqQw4kYMNXsv0AslqSCP1HxA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40632,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Moss Grey Moss",
    code: "8116",
    render_id: 609564,
    scenetexturerender_id: "10761",
    colorCode: "#A3AEAF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10769/1fbbd010_10769.jpg?Expires=1711703024&Signature=nQHEoCWtpdSJo~NkKJR56yelGNLxkFm3u~QhYhyJQ2QbRrInKGVJ4COF5HDDp9mCzqhem9p-BOemU-XKLFXcVtxoiOYKYuIzisiGkp12m9~Q7dqhwKnVIJ7e6fHNlpL~mg3ii1Ut5bP~TnoEV1ibG0eAS8XbnYoFhFmUHRSGAJpAw7y5Lv3DjH9P~mNXHu9edVUx5i9xc7yMopJsD~RzQtgLOtaoJ3VEw15ioW42XY55nUNBHS8WCBPqZAPCQqLdxQW~dAzT0MJqR2JxhIiRn7cSGM-Ue52p~SzXkYoTimnzecWeF51~YixXS5iBMNsQomJebr6Am3eK8RhOyQndsg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40632,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Nirvana Blue",
    code: "5082",
    render_id: 609451,
    scenetexturerender_id: "10661",
    colorCode: "#75BBD3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10661/21d0a304_10661.jpg?Expires=1711702932&Signature=3YY7Nmu0WrH7c7aFB97Aim6VKtNi0YCcO1tYQ74BhDIxkjl-YjQq-XWLqEBI2KPaD8-2xjbpCv0YsemtYcXuUgasqjr5~gpSB3cf36izssMY69Uc39J3krSDYls9PkFKLB~1VYthtAmn0wEY-pliol0wAfzY~av3VK99-4ver--CVZHMf13ln519ZKl29lQcJ49G0fMBYcYSWIlb3331tMkHTV3H8wqBc7946brKPXKaT7-5OoyAunPOFbq2Pht94svAMnSnMSIj4UaCSbX96evJN6cr4e8FgtxPr2TpsPRlRggUFu2TjAaGsrNqWZNJgcMMeUg3lWmbdQ-Bq2xRcw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40523,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Nirvana Blue",
    code: "5082",
    render_id: 609598,
    scenetexturerender_id: "10803",
    colorCode: "#75BBD3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10803/54835bd0_10803.jpg?Expires=1711702474&Signature=VFHRZbdQ~aolOi3NpXoGJTX0E9y3nLyQNuoM8feYabWmybgOe5vlWAAiadXxiZCpwMB6s9RPZbmsD9afyzeiFt2xJU~~fLOMmp8wTf2W7vwkwzMx7zB0ihxb0MdTn15Qljt2vSUB4Na8JNzJsbpVo-rporabAS2ujjElsQI9fGhWrmtyyDlemdnyyr0tzvOdaIUqz88ceGMDTv~idf5wuMq68Avpnzmt-tvNrDgOu9DWESHwXtRfkzzL~rQ3o-fVU4VniBGRpiyFjjpLN6HlpxZMiF0GS50o57-vpHAlBEFMVTrVoYWvdHK4rB-Z79bA3BjWmXE2DltLnE5OQxQkog__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40666,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Nirvana Blue",
    code: "5082",
    render_id: 609491,
    scenetexturerender_id: "10696",
    colorCode: "#75BBD3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10696/933d197c_10696.jpg?Expires=1711702932&Signature=s5iw2DbJjdIrTW0sdbXtPYWFbD3DQ5JD3SOZNKLULwaWMymKK01TLdctsHrOBB4cyGY~N1pt7y8kG73j-QorVBAoZH8-tPNlYnrRLF5ZXr5fhHdMj96kPsMi6gr0XakSpctUUu~hTNpj7I~LmCW9myH1tHmf0rv~U4zVu7vbUm6ylHDwRWH3H2lesWw0m7SV6mAnX5gk2I98THW1~V-T9L4T~hcOh6-5pHDoXdpYurE~CmLO5Cm5TatfmA4pMEvo24ie61~zvx60BADVHO4h6Umt8XUmQzR24NLUG7mrmSdgnmSU~2TupGsStkhm-5~Sj76mPX~uxs9EKLpusKel1g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40538,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Nirvana Blue",
    code: "5082",
    render_id: 609583,
    scenetexturerender_id: "10788",
    colorCode: "#75BBD3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10788/ece09c08_10788.jpg?Expires=1711702474&Signature=hQoWj2YvTBtG1cV49zawWNGj1mf8~b35Oyg1tZNV9QdaEAIvf-P5DLfBW~fiDjtZT22DN-pBSknx2kFsCNY74oJNCJ-EY71T1NEAD5FZ3P5BmA9j36mZ4FHeChZZkRaXC3wqHpuJ19~fuVoa2Ln2lv7dUmPVa8JR4jLMXphmQqnNclsG6MWmzENBpy8Rhgl24k9maQrp65LVmEU8L~vYJPX-L--0Yuy3ZMVlNAWp47TH2EzTW-vaDXjDkkixYrFEOChewiUZ-InlIuNntzzVN1T4VFOLWXYgS5DfLK-0WRqAu-bFj9kT4rtYeZ61OAqblJy7Q2pq-9y2aTiAHE~CKQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40651,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Oyster White",
    code: "RAL 1013",
    render_id: 609465,
    scenetexturerender_id: "10675",
    colorCode: "#E4DDCA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10675/e7c900e3_10675.jpg?Expires=1711702475&Signature=OI5HjfaeNBII7nuoYLSM-ywnh7FDIGuZitsm1w4u5dhz1rVtCx2AYkP6Xs2OX5KmyUPFnoICBd9S1qftP3C36~fafO4bOduFnsAQgB9MQ0HbBvMT0G7pJTZfgVWyDzitqIEnmija9~D195HjDtLWWVYp1L06hmCkzeSzM1qGD-RzusfdY3cmLYgFYtxrbgmQFV1h0fJj6LJfKsPCZ2UATaiHOkd63ubNXTQefmrAazJe09bXyCVfk9RZJB~Pkp3DwH2PS~nhS3JEud23uHwBeCMDIVCHSY5xpFaUlltpyk7q6-4MiFqQua1vE6wtS8JlDGeXdSkAWt~gGuog-MOunw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40618,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Oyster White",
    code: "RAL 1013",
    render_id: 609502,
    scenetexturerender_id: "10707",
    colorCode: "#E4DDCA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10707/5d0de74d_10707.jpg?Expires=1711702932&Signature=4uNKl690jBoJW~~JDh6Y6gdcI56meiLVXzdR0QIdFWoP3p7oDi-XWqIozigtoRyqVbIykPWjKyIxdoVRqWLO6OKzDLZLXhoMgYMJ0vKmxVVSOgqm81kczZMAILtdi73pz6dkYgLQ0VjOEYkk5llq8W4WQC0Wwl5FrYxUdQzrHVj4-W4z~H2pR0tVE82DhJ7E8PkWYEuZVKWkuZJ95MpHmsWKyIk00gmjvbAH8mcCXbREAMCtd-tfb~Cf2sC8bJxdVPsQrlT6edX9nu0C6Dl1e7vUkFwx4qv-BduiXab5UeLcbL8MmwM5ZkiZX2UEuh3dtaKL0sxDjUfQcYtwQX25Gw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40549,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Oyster White",
    code: "RAL 1013",
    render_id: 609547,
    scenetexturerender_id: "10752",
    colorCode: "#E4DDCA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10752/eed06730_10752.jpg?Expires=1711702676&Signature=amJP1V9HEUNaTVzfDKyJvOBWUCzTH2-FhGd-Nm-CPtozYZS1DhWmsgqntvfQXg~J1gXwageyWtlY9g9VDHE15kljZ~y-A1w4JLPCi5OSm6QbvcEepC1AT50K0~UTv2gocz7AlNX3zeTgAsZ253nnkatlE1gsaH0AWRJZRRAj-DwwnZl82-bu0-IO5FcKIZZWQYUpPKXL9~RRCgWT9BfDxQEHStI4Gj6eMyYVagsZ3nBFXqERHFwD7U~n5-sQOwEg2LmcwS1kZpe1JQrbjvEVFLMlAJx5bUgwfihP5KxDswnh8n1hrrlGL1OXH2~9MetZ7qxAdjS6lNrqfBSvdXJJhA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40595,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Oyster White",
    code: "RAL 1013",
    render_id: 609629,
    scenetexturerender_id: "10834",
    colorCode: "#E4DDCA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10834/9081c0fc_10834.jpg?Expires=1711695574&Signature=3B9UAmJzJJ~Z3lq9iUwhplfuoSKxNMR~FrwLr3DVkvf2OTuRtnqw5yFOwLorvKPYYFR4fjOwephpsXI5B3NxSzc~km5ErOvHlTV4TovN-P38KKY7FtHrBJerG4UquuT0TZZ5ryMx5IKHB-9c3uS~2b-kQVKrx5kki1u-fzVCtXTFrQqBl58NHsK9xh0w4CdtrP-i7rMyn~Xu3Tlp13wZaJa0hOKfDJP2PIHBI6Uuvf~KkoqJWInqNcJFIkj1m6zPZDqt6M-4IUPmXpA7D17n1~fL~kzldjs1SXrXTOndxV3Dnb9RukKKdMeDoNprgBgfCPq7MIwL73P3gMPBeWNoeQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40697,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Palatial",
    code: "0461",
    render_id: 609554,
    scenetexturerender_id: "10759",
    colorCode: "#F3EAD4",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10759/e631244a_10759.jpg?Expires=1711702844&Signature=ePS6e~1GHRxu43RLoR~wAXFTa0YEKwEx6T4C5VIj0NtpaA2TtWWC5NRhJCYjnVWo1wDpvACbR5XiwWv8X1TCknhd7b1g0BhDd4KMlvd9T44GyWuvG4cKuIazvaqrSCC74moavQUqSCNbJBR6rteTLI60wCVy1RjkbnNwPS51qY6dnA~FgtmNCV0y6eK865hsH0H3Py1RGX0dmbU3mHTzVnUZGSaiCvXpyu3WeLVh8dW7n~muQVwk~eEEj6WhqO70uXztjJ3sI715BL8CUt4a2LNiW6xk2zMAbZORXGml4jg~HmlQZZMiP7DstAvth1LkozXoqE3Hj16U37cVUR5RlA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40602,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Palatial",
    code: "0461",
    render_id: 609560,
    scenetexturerender_id: "10765",
    colorCode: "#F3EAD4",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10765/af01ac08_10765.jpg?Expires=1711702271&Signature=krCpyYGe1Apwd8JqDPVrUkuBiVlZ1IufnYyINWYWqzlezxXFIsfA5A2~kHzgBJVnsX~Ilasw9aQvV35PVbH44fOpK49MCu9nrgtDhGgui8A9p1uL2pUMiQmPn-QMA3mTrN71JMZ8~PqBumXIDB0C03F1qslsAUgAVyksSMGDLYz93CbE5Ysu22p343vvEeHNPJomSYn-zdhWn9n31cS5XlMyJVgblwWTgCS112~RjYCxuPNGWp5B~eyW5gTUPw~S-sfV7IqLi7OvuB8ohCsMEgZBrvIHeCmx8DkbqEeLL7-kbYxhipoaFtz-PqmMf14~IdItsvbG1U9xFnzP7YPEyQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40628,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Palatial",
    code: "0461",
    render_id: 609495,
    scenetexturerender_id: "10700",
    colorCode: "#F3EAD4",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10700/f08daf79_10700.jpg?Expires=1711702844&Signature=X20N-wtIyjS6rmZ-K0SE-FipTK8kNB2eO~2GuImMSAiRsZ7tKB4OLOXoPC5VQ3RpdLQnK~28edq5ovFsiVhhDMiN2kAY3Ai0DetyjuFQH0V4LnYfMp8G1S57~id9FZ7sDbRPcVhg9gYc3cTnPKkmAyFbtA1H~DLxpmFfYH9DGac~rBFVuJKT1tSRYpedqm26C1Wi5~we-JEkQVftjFfYn8G55EpDqbufKn8cRiucGxiaD99jyoRNjyC8QxmgOaYxiDkgbX1vV9DvryJLENktZxCozpjhHkzAzrFfY0J9EIL8kFQkW6rJlzblb0cA3A1pbJA7sXbtPJUVkg7lROK8ew__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40542,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Palatial",
    code: "0461",
    render_id: 609578,
    scenetexturerender_id: "10783",
    colorCode: "#F3EAD4",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10783/71f02136_10783.jpg?Expires=1711702271&Signature=tYF1D3P6TbjBerHSU6JBMcK2-~oN6vEq7VfcWyFR9AMDExAY~4yRY3wBOAi4oHqyTpIIUBPVyT3r3cYxW-kGIKgEk1eczGwvV6AR8vJSzLV86tpT8dRa0rLpEsCxIrzZKQyXP1FHsFkT~vJLE9zmQxqQBP4evPdbA4OqRqv-fPpQoFr2sMm7RH5pInsLfuEi1IrJf77SsMdDltWQOkg~V7sZl4~40R3LfWlV8FYGr6m6q~-lnakYSKn3A7AcHEuTRCaxGVCljJ6CRWHE2cvB~W9novP7jvS6Titl~r8pjps-P67mBlDX-MPeb76UaHI-UgDStTKpjXBp6nwL5ZJjqw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40646,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Pale Ash",
    code: "8083",
    render_id: 609446,
    scenetexturerender_id: "10656",
    colorCode: "#A7AEA6",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10656/303dc3d6_10656.jpg?Expires=1711702676&Signature=gGgBI2tAK1CPAiZ9pw5SKp-jd4cvowXWBXI-GJcmnEGwkFbF2HWDsMFkGyqPfs1itveOucVeyZMJBzFOY6BQeeRb8Uyzf0ymJy9fzcjIQ~qX35v6E5b6YCrwuKC91RcNeayNDnlRlaEcmfgirl5nE96mRGKJTUQdQ41Nzj9wVfsGs-OQenxl-LBeYZ5X7yN5UANcJ-bReFq4GPVFTcX5-T6GjOIbuwi39Gm1NZhr3sOm2wdU4I05f9R8O3qJt-4uj4GycdkKfbnuubxZjL1Hq~Eq0smYdy1P0IdV5ha8z321MuLj1fBTIxaCHkUVPUUD6GM1DCmfSB5R~n9n1-Dymg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40518,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Pale Ash",
    code: "8083",
    render_id: 609589,
    scenetexturerender_id: "10794",
    colorCode: "#A7AEA6",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10794/eb404877_10794.jpg?Expires=1711695574&Signature=1tX22Bhyy-bY4tA3RB~WgkO62ppXilP0N9Uss9VNuOhNYyVn8ccAVcpWUes33J0yTKaZqVdFLtxaCce96LJ~4Qauex5C-P00PQPPcb7NcO4Xn4Vo7QQDXaXs~BJsc33yYGxmHZ7k5Ughlk94mt7PTQXUZ0K5YiJLbdPUqFhFrf6j2oRK2lFzic2WQAFY6TDQ2tXuFNlNZJRF-iYEbOOUER12zYDgNMGkDOYRDpaF3kIc~Eei76J6gJYcr~xcFb0IAwrlV6bW7U9IauAcUQ13oNm4iz23i1hCclwZ0dLTwVxFtmfRdI4RvHBP3xZzBcokcXwIJCKTeFBDcUvZQEpcUQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40657,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Pale Ash",
    code: "8083",
    render_id: 609550,
    scenetexturerender_id: "10755",
    colorCode: "#A7AEA6",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10755/c1683130_10755.jpg?Expires=1711702843&Signature=3mgQthlm-5UZceW7SzpRnGV9trSWbo5l8hyiOdOpe1OFojZQnNdq5QEzvzn0rGCxdswTHKJjIC6GkGSQk3WHWWKfM-~dgoJI0cGapqNY-d1mWRqeEzA93H6I6bkKGjJIROEapLZeMDIefXQnzlrt9WtLmKRdTNtDBy3VEpyZVJ9WkUU30FAqBI8VnFEdAaWNoUp7sjgXX~1U9hwuUa~SGU2rTsg0tAOHBgK8pwJicoote62S-9xqgkrmH-6X5wxrSIhRbqPbU7pXOFAaMnP4Brt2lRs0RH7lfdMl9BwBQ3UKWwQqbPQH0p3s9XU4bxT1tpd7hlWD8X1LD7N72S0JlA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40598,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Pale Ash",
    code: "8083",
    render_id: 609635,
    scenetexturerender_id: "10840",
    colorCode: "#A7AEA6",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10840/8bfb38b7_10840.jpg?Expires=1711702271&Signature=BqKnx9AYxkfNYkS1UFF0ZXBACKoTCC5pg1DzF4s9kJD5F5uW4av9p20lk8QqCtSQ95SrL4J6Tq8GpiTjE0Z04m~hk8lazRQgsfxe5AHgjljW4W8rtwTaeo54atUu1C1q1gMc4y8s5fWoFMMWnmMzl6pjuWXRCFfLiVSrXBNdoAKqUpe3iYuXd8fsQTOK9nCNAU~AjTd~57ug6NJNBQZTY0W1JnmgxDn0bRGD06TrQmlMwmO235pKae5pAicy8FQpbQUvtfYf0UKvpNl4akdUQuM1MthdA6u3P4Mna5RoojMfgZNLfbri03T5M2pytAQKP9yO62MiPkgdN3g93T9R5g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40703,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Papyrus",
    code: "5131",
    render_id: 609468,
    scenetexturerender_id: "10678",
    colorCode: "#DFD0A9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10678/cd1ed967_10678.jpg?Expires=1711695574&Signature=L3wTv~Kv5QDEa3~BPo-kPZXfKK82PIbteF-Ibqb93UcixA9FJu~URnFhaGj-d0ZEs04hMMYisiOVc7UpBAbuB1L4CDPB6hpyNzdSSlcvuZDd5i2aSvj0~r9jKPgiaZTxQAKN708WalIdCCz7j7HbXZCricuRZnnEfoM3euPwKK~y7-WdGTws9bvxGTpTnSACgDPM5keEpjsQYdIaL99-yYWmIXjQ58BTENShRFUFa0YiteBxfPzeVLG6s38Q1F5hdQimxBDKyXKP3za0O29HyL1Krl0wYZEj1zqzQjG5QSw37lyifv77jsX~R9~S8l-C66dcZPPvcf6JmolHPvqrGQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40621,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Papyrus",
    code: "5131",
    render_id: 609533,
    scenetexturerender_id: "10738",
    colorCode: "#DFD0A9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10738/5cac7367_10738.jpg?Expires=1711702676&Signature=RGprYrpdYiIXsBwIGAFShaV2U6jnYC7Q-~nmyF~4oVVVOncbqDFOXCQcjtkFBZgFf7K-LqDg5BFPYNhVI3NkbVJVXsNKh05Ecm5g3ghgP6cGkfwR~upeCOCQ1oiYPSrO~KwiHmxCMITGAiAJroEftjrOZ4T0wvCFgEn~NRH4f2BSA-FSyMtqawdj11AJ8Fb5uW20ZG-DzD-ILm7r6ZKNEvwUsV7HBZ8fN4eymySF9TABqi6hbNwxHxJ85LK4GuVgd9iaMKhuQ5HDzKZF5Lt4RqunM5TvtCIZ1rRBY46AyUDQPls0MezGspWtjmK4Pi8cI--wqKYWU2GWEqv4SAVbRg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40581,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Papyrus",
    code: "5131",
    render_id: 609613,
    scenetexturerender_id: "10818",
    colorCode: "#DFD0A9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10818/bfabf18d_10818.jpg?Expires=1711702375&Signature=qocP5UL1EZdGEcCd9Bfmn66N97bLdFl8KliRDlHNRSPwvCQ7i8B1MMMOvQU-hVnMAAHPulIYyj-H9YwvCOOLfnUClStaRCGpS6CJVPTFSEeB~RFJlbDNPCpS2nWHlas-t1sAGDar0V-pGd7t4hWOFw3lbQvny5GeHPE~yc9qLdTuYFLOZ8KpJLuTfFz1fAwyUemriF1fwSJmlsLjZUDwxFPHJVGDfAPo6McXSvRwfzrBV96CKtpX4gqH5K~RQi9N-7mLpsJTqFXq7iJaIepjhUiTIZxatBNbXkqavY26XyKWAg323rCGjaH3GHfI4iY9JVc6J6Y5AChIx0SJTFVrbQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40681,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Papyrus",
    code: "5131",
    render_id: 609613,
    scenetexturerender_id: "10741",
    colorCode: "#DFD0A9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10818/bfabf18d_10818.jpg?Expires=1711703024&Signature=v96s3clBFU2ISwCKLbHtnVR-Um-pVYp-RjTrYtMVXW2QfItbytGGbaGdj1JN2PQMAUfkicXE2OCO2RWynqdvbGxCQSBaQULor9piskDJG8XUVT7KUmsYWua1DfBdtph6PNeFXAJ9F4LpHCwQpR4Hw19QEfh5yw51DOhvUnu528Rd~cQ4-wSve0928-N7gtEMU7U83QNeOCrgF2xeLE29invy57uKgfS-S3i59abq~GXfxYYWHFP53X8C4nHimp5AiHjAqFMIUoACx4Te8ItmTIxoKOM1PaCH-Xm2NE17r5COM-dmi~EGjZDO6GmYL0uT6arBnMisxazFk~XD0Ut84g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40681,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Para View",
    code: "0464",
    render_id: 609456,
    scenetexturerender_id: "10666",
    colorCode: "#B5B2B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10666/4e1ec55a_10666.jpg?Expires=1711702128&Signature=ET-7oyDRpkdnx8hv~zQhw2JdHMnEWbVHshqPyJiM09HAgtnRPALWtrCjEGzP8ogx844VCQH4b13XjKVd9y3du6oQ3AbnOZMO6tH~iMlyYjt0U8Scp26waqH-S8hJZP5Dc0zkzXFEsCIhKP~9xwhFeXz3a1Ud23fQUvrAJ9idMHF4i6xaAN7XV-QQXj59h34flXsQ9SORZijsr~3xDILMsDLA-QAyG2MNBxYfQ8J4fYObQuOgDY22w9fAp0fnqg1LvEA012NQmBrYXfaF6QXZuSPLuR9NGk1fv4ydcshpsoU5f5QhOzmI8fu5s9XMY2SnVyGejokiajBUbpGRxjxRdQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40608,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Para View",
    code: "0464",
    render_id: 609501,
    scenetexturerender_id: "10706",
    colorCode: "#B5B2B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10706/8e83c6ed_10706.jpg?Expires=1711702788&Signature=1ncrm8xtLZPSZW2eoZoUvqOR6H~PEdzBpCX8AGuCXG1kg4f7~zptFY6twg2dhqFBM6Jx6cyG1toHJLLGAUiO~MhzYrtHrzOnqpmghlazvBkaHANKb6Cvf1-Y6LcX4sccH8HFkOAAzly91USm99k3gxzDsSCy5GY5ilhBQUJJy6wmFqnx-wn7cSgur7pgHk3DqlmYgWXRPcceerkdnnsKk2nKqMq~vcoIFG1Pa0HOftaP0t-nSig71HjcIw-LKi3kpT5B5rLR807WIQSAKHX79fIRDTBJkIu-RHSLry6rVpeNXMAtOxzhhupRFiQAln-9xwZaALEJCkNf1kTG--VMMw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40548,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Para View",
    code: "0464",
    render_id: 609551,
    scenetexturerender_id: "10756",
    colorCode: "#B5B2B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10756/80f92e5b_10756.jpg?Expires=1711702843&Signature=cnJqDl0b0rnb-1xxQPm0R~7HRFv3SxW7yPvzxfn04XqviQG5RrOrvXS38P~gOkUYlt8f~Aco0JIHSYIVdGu2WBC~Osgrn4irnlODL0avZqEqx-JWCdAH967h54FSfby-FQxX5VJQcMLWtS2sKkHc-OxTTN7Cs--bLjYVI1vzVVbzGQ~qluwyL82DV8rUnuriwF20D663ARqNoZHsh0zSSw9temSJTWKFQpCVyNtslECzErfYoabIBPCJECQrQZab3~0onOH-RTKnaj6-yl9dbjyz22yhtaLlOHcd~i3hTKeUCxdhdUJ7j2rXwTQk68CRlh-IV6VKkoSfKU-J442cug__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40599,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Para View",
    code: "0464",
    render_id: 609636,
    scenetexturerender_id: "10841",
    colorCode: "#B5B2B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10841/c477c703_10841.jpg?Expires=1711702271&Signature=W8~1XxDNZSmlzIdfhhKYsES8HTE6WHiPO5NHGE0dn7msPHqxwuWoJaELVd3Zr2x8~2jf8x7XC6P0sg6H9~UEBGYCy4jN05f-rNsBzEM0blK5qVM2FHMwiTJZQVb9uR8wM6FpBXzaKzaX9yepQNMSJgyzjvLtzCyXvOKOpPzjYvhak5qIA8RqrzOeixRazAbAloGRANQRav651gWmq672fY20osT349ud7ImbIm8uudiKDEJWPqnCEo4sk5gnDllfg~-P9c2HUrRq~iqpwddYxsYVPRTQd8k3xlPRz89eCHN~gpyHEqDxJeb-H~P4bHVD3-aIQWNzGSB4qvX4YIeg5w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40704,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Pastel Rose",
    code: "5043",
    render_id: 609499,
    scenetexturerender_id: "10704",
    colorCode: "#F3B1B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10704/4c7debb2_10704.jpg?Expires=1711702788&Signature=RyzM4vb5qL2GKFDrPtSg2RU089fFzdBcZY15iK7RHzuFpgyLCiNtlXk-Mlgkj9Tu8G0VPTqimUBrwuzf4uMjVIGpjo~SVXRDxCtaKlDO~ajCG9pBU7a4zaa2XIntgn82adsWn8lxnZYY7US442ifTA4aTxJO4sctvfncQHOc2b3HPRGOlGF-rnRzsf2sr8BkJHIb-vmHV2UQgvFBWPtvc1fxqpJvYNRb9aWmYv3XiD4p5rWCQofnjKgUQePm6kjgOaLKAZNWRg5uL36ct5QSH23V~WHZa6PLNlWBmLqf1CfgAGPoY9mR15C7Bxb188n0MGQ7Z~Txh4tGAQ23Ab5y2g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40546,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Pastel Rose",
    code: "5043",
    render_id: 609592,
    scenetexturerender_id: "10797",
    colorCode: "#F3B1B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10797/291ebeb2_10797.jpg?Expires=1711702128&Signature=1K1Z3-k9C0Zd0HeTEqSicnh3dqntsNA34m1ean4U1CVTWhv5~1fqKGbSAtxi3K~zFHbdMumWbOyBvNfqZJtvDf26d9X~MFvc0HAuE8fwpR81z1-AZcEEHOODENg2rLg8SWrffHxFXejk7~P2GPvajDYsAIUdLdaCdGxsdRt3PNXDvCO5FKvtaNOcLI9eSKxOXN7QWdepj0rbfM1pQ7vXqu27E4bp5sLjtzWdcESML1ya0TnorjzIpZ-WJO-23GRI2kRw7ikeoXTJpJJlo4WSio~dvKMmWp9jcB7eZz0P9wTkioreYHGzgEN4QMBWE2h1-DW6J9H0Dr09vUsCtTwCMw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40660,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Pastel Rose",
    code: "5043",
    render_id: 609500,
    scenetexturerender_id: "10705",
    colorCode: "#F3B1B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10705/47fbad22_10705.jpg?Expires=1711702676&Signature=2b~dd25g53CDmWly-KggfwDSdsjc1FAuw6L~41dkxKzfOznah39m37DmrxGUCygtS1zeK-pMQOtexcP9W5QosenxwMk3ZaKD~OFxcSWbvCVhmnS5t~NnZTiML4GoQLRjOG4Ly8YeYZzubM7zOMLdHBEHHo~01xC1zq41EqzjB6JSY5keFS8FY6lTsMOuidLKNcA9tES0PUzctgVjAb53gbBPCaiGL12RZRCmzx~~cgZTd79m-dH2I5-BPoOjn1jCRVCzhnSUq9n66VhXPWZv1jyXyMfhP~rdJPFn04AG~emm79TWEcglx0mGAFzhLPBcE~D-~k5GC~uWumz2xrZFlQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40547,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Pastel Rose",
    code: "5043",
    render_id: 609563,
    scenetexturerender_id: "10768",
    colorCode: "#F3B1B3",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10768/b7a0766d_10768.jpg?Expires=1711695574&Signature=B7Pt08W62wILDmW6gGZDIk6IwmliL0fGgQpBAJ8iGOOLaHb5BeQC7rNklVVNNutJQHVFGJ~Bi1b4~hG1Adx8uedTg457zF1NPBNH18IXn4qiGYFC39APGj1xaLBdQPBEcZrGuIzPYH5qar40MOXZDSFBr7qdoW7UDHwWB6CX-hNV6GD-GFW8n4BLcWkW1A5VbfzmS~RcFKxQI-d3sP31girPF58lS2IRlgihK-i~KXoM6L~ODHZyvTTwLMHG38LEv7HMYgFRtSvTBEpP4dARxw2y72bTeSmznLwR~Qc90s2P6OrUvT-TX6AwScA~2ARuVcg6pQercDnX73c9N17R6Q__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40631,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Patridge White",
    code: "5120",
    render_id: 609459,
    scenetexturerender_id: "10669",
    colorCode: "#DCDCD0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10669/ddf40a42_10669.jpg?Expires=1711702475&Signature=mAO0s~OIZrpFcR3y9DhVRDW1Ra6fX9CSEFr~V3JQEjJLisgysSlEWjwKMGjCn0~Scq2s9j1BwEXRhB8ykkRndG5zG~6SJAfI~nXOz6aZgtgmuQAiCHNcfgZp-dogNxZyx3lNw0InNtO~A93Z7sFPN3gG~1SqZCLlMECEiAmGK~B1jI3Aw9UK5e4Tg8UjiHOW7FN8dpWVyi2O3UO8ueRMh-2rV6mJev2MCNmkCbkfNO5sIR4K1Tj8VGe4y-nzt17AMUTtijTQaokRGXK6XPS9gk1pOpQ~zXFyyoiE2LdZqwVdNI0Q1eXpXnpyTvbUaNvr0PMg9OYHNkDTG-L5Rty9~g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40612,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Patridge White",
    code: "5120",
    render_id: 609496,
    scenetexturerender_id: "10701",
    colorCode: "#DCDCD0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10701/c9dfbe86_10701.jpg?Expires=1711702932&Signature=MrFKAbNsd5rBxWi9GsBbmmtDnVc-wlXVi8bHsFF1m9RhvkSVMyilcI1yWaQk21vIlYFVyuIzuuwzcB~VngJMObEPoqU3T7hi9c2WlBZF09Twm5LU-8Gn-KfiDZ78MbTAPFz1ik8SEhDyJDzCdZaBZG4fOgOR-oqdrRngTK9uwa6ZFmEIkL7WAAmVSUoG6S~3RK4~sqJ4SIityIyMIAjKrpG-lR67545~-R-otnU3RPbAgXT5FGfJdSudNRL6wJbRH4i-LXoSSkS73OQAjCnhuQuAeKEskJYzi9-QEsKWqARNfUMUV8wvQT7FLH8Rrlu5a-fMaV~tQOn-FCWkWsQvnw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40543,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Patridge White",
    code: "5120",
    render_id: 609513,
    scenetexturerender_id: "10718",
    colorCode: "#DCDCD0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10718/01da13ba_10718.jpg?Expires=1711702932&Signature=ErxNKr2j1PnIUgTpZCwkVQEQzQ~VCoQCtiaes97JyLI2L2u8b-kDiK5wL6VX0bZeZD9UuE9Tn-qj2aMMr4X~aJwRg61dg~Uunf73bT5Blyn7~kZyTymMf6QXY0tyuyEtHgDJTZ34snoShYQuaYCzl0uGCwWg5zS08nyRqy2y3mjKxlnDQeIGLpxWU5-dmby-rL0Q~CH4jM1HXX0EGawCk2eErofwlRbREmZn~zYoWVTsgyUuaXL7xxaJkvt1bJIdTQsAWLF~p-6Cx3pEDQ79Pw9v-RVhRIfpxLVIOTViYhDnkNLDXElfG6Tl3jbCgK0aLtckDqetN9FWiekdJTFPDQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40561,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Patridge White",
    code: "5120",
    render_id: 609604,
    scenetexturerender_id: "10809",
    colorCode: "#DCDCD0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10809/64a75542_10809.jpg?Expires=1711702475&Signature=UDjFOudHPf7RHLh8jQ-dpwoSI0EV5OV4BmyJ8sKIBObOmcXQlVm7LKpsDs73PzbvMN1yp7-5fGW2qroX4WFwLT2JhOBTo8WgpLFzd1ug43yJIbxMT83XlRAsfCpUTFC5BZuvdYg54dgv0Dfdy4jvdZ5DUO61lhfJhRtjw~tm30A2Tg0Yauhyix6CRNWZYN~njzdbcNRcSQOFom6PN9etxG4V~ZU3rDNNVErfd8joGg~r8Q1~u6NH7kOEMhs1alIZ~XfWgHtc47Zjujb0T4Ot6rAg6lh5qz~p-zcSDCi0uJHJTBFcTPMxqLs~PYWxApjV5oNVGluiyWTm-lwvEL9M-Q__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40672,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Peanut Cream",
    code: "8010",
    render_id: 609471,
    scenetexturerender_id: "10681",
    colorCode: "#F7CDAD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10681/88119f53_10681.jpg?Expires=1711695574&Signature=N6r07BVQy2CSTSpnQnupnZ5aMuC63Dhor1EvYrJX2vl~kCvJPglMB-lzUJ19jFU5Et~wGKdEOqbQocm8~78qOKyOK7z3pgpRgbUVPpkmGsTNmqlPUyvZi80JhCBZxTOzTryOzGhSUL5OrjSHOsedmgNwbINQmQXNCHl8Em~8dzPBLs1EptF4hdwfLmzy1T77G4Vo9WBEoKDWv42pJKyuzpGYPBbOsWlaFIPUmUQW4~Wx1-Lx3fIDX6v3Ava-ssvWYZ6KL76et-wUXG46qpBHiX-3-bO32937RR-0z0l07Rd3EvkuMwexhVlUvn4IPAp~1ODTNj53OrJnRYjBnASfRg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40624,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Peanut Cream",
    code: "8010",
    render_id: 609545,
    scenetexturerender_id: "10750",
    colorCode: "#F7CDAD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10750/d9474666_10750.jpg?Expires=1711702676&Signature=IV3e2KRWv9jxm0I9GAEyJLnjPvhU8cWQO~bVZXzIhZn~QYolUHLArNr9huAoLRi4abcfWCv7A42qlj1rpI~FueunzBm8UKqG-jZuZrDuZslYxEhGnRmPb2BsaByURebTp85QfgBv8zgF7th3yKbrV7QHjdT9tuc5-Bw1dHvC8tHlegtZ0ObpbFJh9EOeu2LoXYUwmbKl48MXBQahI~yiDB19zGHo~kFmXX3hRVgiANk2Fe89Km6pxe1EAIBap4RZzhEhRXAjN~R3uPQs7MIOaPyYaifqqINvD2utmvE1UatBXiLSLOvcOS74VZOO4Pa6BnqJxwIHaKDj2OwDslnmqw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40593,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Peanut Cream",
    code: "8010",
    render_id: 609515,
    scenetexturerender_id: "10720",
    colorCode: "#F7CDAD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10720/90347cc3_10720.jpg?Expires=1711702788&Signature=Dly-8bl4odYFj3l2aK36n-PCvBJzCaifiM3Slqx3sgym1YEcWAeh8lpLavUTmuQvon-NQ6x98JGNFylXyxoZndCBpaAgdYwD0xGSJ3CdydRBKq6tSjg1yCutitOmTQB9hMj2yNy8~Ks2M1FgKFUE8YEVAOLzMurhBskecT2mpJVWSRo1Y49vnOmCTlqOZCc0XCLLq7i6BfEngal48rhk~YOicJhFELWS9EPPzxocijzFedI89fXce7TCcyEVLT3uE5E5t4ZHoym6g8rWdD~tDM0K9Gl4Qjzs64DeBvBcPTzfF4fPMbRTqAEKN8wzQB1TbEpvf5intUQr4thBnzUz8A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40563,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Peanut Cream",
    code: "8010",
    render_id: 609572,
    scenetexturerender_id: "10777",
    colorCode: "#F7CDAD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10777/e140fa4b_10777.jpg?Expires=1711702128&Signature=k3X1r4NJmPN19H7NYHlG2SXGA-ZXct5zButiCjJXxDBOZGZU~w5Gj6JPo-JJY-lDHnVVUOx1nolgeAsle6thSNjLDuoTmXi7j0ibF0DrOpuMRlluP30TU-DMmcDx57v5SsL8tc-~yoG8yylJlRsUuJFJXLKFC4e9lzuC0AlsqWkv3bHYkfitqHEq9fcuXoEUSRvO~DxsgIjV80nQBNG~Tq1ru-jtS9n4a5FJdkVEc8soNIF3Q6j6XQDy5lBvyivaruro83nXk8vIJw7aa1Z6lgTQmywlOHz-KTLoa-Wh8j-5Ywmon62-F6c5MBnR3OQGSbSTY7hAwlZgUIyOcOGj-w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40640,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Pearl Grey",
    code: "8114",
    render_id: 609458,
    scenetexturerender_id: "10668",
    colorCode: "#CBD0D0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10668/04397c3f_10668.jpg?Expires=1711702375&Signature=HL-QWC4tc~5eNaXwtzapYST71CpJ4pWLSvbmvNfGJRvYcxOmdLn1pzFImWPnKpaWq~JUSBk2cYgdieY99fjWQoLbMk41B6N5ne18o63Ij3~9EAj0aCOir0oYiP4Zo~hE3ccac9WnrEe-VOHz66uhN7GVB1PsOIz4-hfB7jVWZJSPtvxi~fPk6qlsFzCuQA5Dw4m0IEhXMwCfSeIfN9NMyFyDh8xKwklewOmzNUmuzkF8dB6w3JHSKxmO1qK7pcKMqF-anD5W8aJM8jw-QYjgDR43uN5UTqk5~6l5InA8SNBWdpFZNHmBjLaYPb~j9XOB5kN2NW4-Bit-IIRiWx6zqw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40611,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Pearl Grey",
    code: "8114",
    render_id: 609458,
    scenetexturerender_id: "10650",
    colorCode: "#CBD0D0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10668/04397c3f_10668.jpg?Expires=1711703024&Signature=FeLt0OuPMSP4ZoCuBwMYWVymKlTCsOnG5PIx7k8aIWqAOsJq~w~dzUKjPGG6givW1IlWJJCEya2t8VuLHx~6P~uac-DQHbbfH4Mxz0iZRS1404Sh1PlLeYKnt9rWXWjEByN7jasZBntt8rHQS6RVTVNuAbSPHkMYNDI85rQ5bB5Q-Ul4tO8pKtX39bpwwRZfu883bG4UUPqra15~wQ~veHHRruVmNJrYCdMg3Psp1meZeQn-zbZJLuRLQxG0-s4OCw8mTN5Buf5KAXvuFvxFjR9RSH0tH~TlU-OscdNigQm0ET~qim8EjEwveRRT2Of62e7shxk~OFRfgSSrysIf8A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40611,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Pearl Grey",
    code: "8114",
    render_id: 609503,
    scenetexturerender_id: "10708",
    colorCode: "#CBD0D0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10708/f5d696ba_10708.jpg?Expires=1711702932&Signature=se3USBzgDguPWRB2LQ39VuOm0uy0n3f8RVPh8f5Uq9rairG2ioj1nBurd9UT56Iz9F0CVCheSx3aWo3njQUmLwU8UBR7jaliT3FdXsy1IyNxqvJP90Qh4MV84pycJ8s6-YjCzHx5I0jTKINNWepU4wptjANR-UnFTXky-gQCbmIVvL59Ml1c7OGJnHHTsru8nmkhxxzQNWduNbg2Pde4a0JJk-wioFER6BWzcCpczB3l4jGoQxk3V2zcTi2CRrL6jXAKLZitfYqiMTakv4olYxdKwAE3KMXd8epuV98d4d0R-cIaF8FWK4GrvL5qHay0twHhWVgQG6JWLQsPcmcIrw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40550,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Pearl Grey",
    code: "8114",
    render_id: 609605,
    scenetexturerender_id: "10810",
    colorCode: "#CBD0D0",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10810/26da3964_10810.jpg?Expires=1711702475&Signature=ZApCZa-7644UDkCL1JbMqRFnMiy-hPCU1aobkWRCbdAIv2RFsXVw0F2y29CtooWZTlYuf65-GgjMsoFn4vqayRk3yRXh0lNmGXf5jaMnVFmKTf2YzN0UXiDzREywx8kDdcWW2u~2XnhqzUeetAhNwwx1U~VEV1~ZeWfle4-T84lBU849-jcBeTF5iCbrm9NO0uq79b~Nsp8ur5Xs1E8TPZFWunHSOdwSysSUikI-3VSQ5D8vt75YW9PeVAqWpF55Y4OEhBTk6cCuljiZmoIsJaBLrpx0YbfpdEpIFxuULWnEvIDO5o3dbi4MsijM9asTsG1s1IZOqk-m87w3S6qI~w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40673,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Pink",
    code: "5023",
    render_id: 609596,
    scenetexturerender_id: "10801",
    colorCode: "#F8D8CA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10801/822b0d48_10801.jpg?Expires=1711702375&Signature=0FhVZdAo-oKOINRfkCVrLW08Be582blLQk~CYb8vyrs70jFIyr7g2T0lho~qUrlxD7gtVQMdoptEcsU-r2~F9A8d4kEXHeLgKv78dqEp-tSsayeksujTW5D~2s5TIjudKm7kzLDXWefG2mkufsnAQotf75mSF~bSVqarqcSFtbWNG8-PQQqi-Ae-pjHMV6oWxKio~vokXQ6yjh4-9qK-6P5~oKPxG6ojoAHQD~NIYcB~fQ20CncHwuHRg9dsFd-a4zz8MBGACBaqsP00IdxuvBLxBluQBNrXUrPPG4UXDxDMqLXsz~TWQgHE8SyID-c0Jig0gfCnW92z~xIrtSAsBw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40664,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Pink",
    code: "5023",
    render_id: 609596,
    scenetexturerender_id: "10659",
    colorCode: "#F8D8CA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10801/822b0d48_10801.jpg?Expires=1711703024&Signature=Gh5UGQ-9ex8bRjf3JkHPDsZC3cf4rTO3fIjWpPmUjZfZvokgEyRXX3POKvn4MN8Ar1X7WjMM6R7XLXwqYCONOK1WI2QNsw7B25KFn9iFksquHOol6tiJ7bNRvPW7jvZA6DT9fv3FhKfU-Yau39Cx4A77sVkvSL1O84B092d4Lm2QjLVDVPHOdJGUVUCtrflgdMbVsE6PUbJ~dfYfqOnisOTevQzcEUOAvc~LiOS8gW~B~2-rrDHMOrLZO-t~hzcaJ9oQCmZZT-umO9b77SvFkGCM~nNLneJuAIIkSPy~tkTJBVGZEFMpb-sAVS1JC9njISxVJcTWI--IgaDRxMhf6A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40664,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Pink",
    code: "5023",
    render_id: 609580,
    scenetexturerender_id: "10785",
    colorCode: "#F8D8CA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10785/a4ccb88b_10785.jpg?Expires=1711702375&Signature=S6IBS8PDxpV0ciwDgCX~yyJRk6Q5USmOX6qm8j~pR7tIRt1~E39gUtXZILmAvQmdIPERTtgiIS~gXvPAmv6WnmZtjL18vj4PaXSTBTxLNdkB~YIAylR6BPtUzwMOG~JA19-1IEpxP0nw3yDXcZ3uewSBxT1nDzA2xdftXbK-9~cxKhQuB8vSfDqO6mifdel-PvckY9p2dxJm01Npgthljvl0lp8UlrNcD~DGhXcQdOjwY6p4bfZXZZSiB4L3hrhkIsHIIs2tMzApXXkm5hAcjP7ZL1p~JcYuEQKHA6rfSBXb0viMZBq1-S1Qh2WDaINHL5Mqs8vSV4k6MxEnNMNpNg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40648,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Pink",
    code: "5023",
    render_id: 609580,
    scenetexturerender_id: "10652",
    colorCode: "#F8D8CA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10785/a4ccb88b_10785.jpg?Expires=1711703024&Signature=jSm-e1imHXdQuaBI5GddEJPQ2qiX2HmSKzStigo~nMe3Dj~tsnjjQq5LjS2Ys9pjz9rQf2LcHzXL4nfmWe7VHYdPCIUI1-qp78Aq70twFdagtg5q7sSltRRfKmNJg5MV8eg3nsJhTXxcBNSTml2GHrup~1KjplrLniqwTfiIKU~XL5wnSe--wxCtVksqA01sNcfvSb1pgC3jFrMhNsatU1frtIvSVp7RiVjtuu7kNS1dMlUMBBsgEDjgtrsz~-V0SsL-4HMVdzwo-tfjoW4X2aztUxk6mXBjfsO4UmA~elK7OxQLjtWnTfZWIJJkovBr6NSFHSO7QXnPydoYxwSQdw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40648,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Polar Green",
    code: "5090",
    render_id: 609510,
    scenetexturerender_id: "10715",
    colorCode: "#9DD6C7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10715/28fe8fe3_10715.jpg?Expires=1711702931&Signature=NvLn5JrYvz9BmpY-mITTE4FlmZmrU70y8hB6gZt3GRKgCqwgpTW3-Rcv1q6UflkHbYKAgc5ES~rja4kCIOoJuEMpQsGIktKE0Bz3hwbgIVDvjvV8Rl7x1wiB5QxeqGv6MvqXQo7omXP0~wbxChWyVgGoXgrJLNyUMJnHamB8d7IwhyeTZX8SFww5OJgU8oN5sVYg-W0-9ltxruSbzm0pVpYWDMQ9eMqORbF1AgHLNIWwdp2vmOAbR2~e91C-bkX4pf9Ntb13ntrdPWHm90IDyqTfjWp9tpgLPDDqeY2dWG0sjEgUrsyWBxxjXnosffnSCwOZCz~hzPXUhnG4U2Hp5Q__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40557,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Polar Green",
    code: "5090",
    render_id: 609597,
    scenetexturerender_id: "10802",
    colorCode: "#9DD6C7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10802/545ddc24_10802.jpg?Expires=1711702474&Signature=19o7n8zblVVRCQzJizyke3GoZx4GFpZmLT4KlB5KexZoyGqOZltv25CiXaeob3IoFiPOLN3yKg5lTME8jHFMDjZWgV4qYMRgGQE32GXma4ukYjuwvQ8uhii9kYShwVjlVpXrzyUJ1d26eNAX0RexEgsz~Jom~BcJdlV9EeUK3Wrz2NIql-zBBIUBoJwyZVmFTwSk-LLOYp2xOzJgc3SjiT0e~NbZi9LMfM-KmX92H~-IkshycDXrr5X0xGeYYFDt1tO1v4YmMvF7pBeN1NqWi3YV2zR6qyJfzxF18nYc2B7kHaEicTVnZ8fNJzFKpRiWdB4JCxjCZhMzz3oUPXJ3AQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40665,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Polar Green",
    code: "5090",
    render_id: 609546,
    scenetexturerender_id: "10751",
    colorCode: "#9DD6C7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10751/08936ca2_10751.jpg?Expires=1711702676&Signature=XN2VB59MMGoohDuLrRiTGNh7mcc9a1HBnabtqfRmRhAPcIE-EMuExsHLtmWrB~CCTA1Uq5J59Qr-8ffPm-fXrweUXBvIHoJzOL7mOnoalSAg-BldWLOWtw3IeCXC7lmuWOyh1MOyE9pOgFsmi2QpyuO2O9akYxTyLFf32TpzIWDvjfprTYRrXcKQauUBh6Skp3akex-WCRvz0iaF1s1ZlNo9EK1vsqeYhr9axFU99sh8su6512kNAhsyQAMd8QI4lTRWmtPL3t-QJYUZGMGa-SeI51MlxSdi~elgDdi~BfxcCbqshoy~qFAjZMxbEHpIi1JCRCjBXPnu650~fpAQrw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40594,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Polar Green",
    code: "5090",
    render_id: 609628,
    scenetexturerender_id: "10833",
    colorCode: "#9DD6C7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10833/532519f0_10833.jpg?Expires=1711695574&Signature=zz09XVVxBRX2bk9ozO1AqZ77i1wLMhTyzuRezBmqCh8XgeYKxBO-JAeK9eb-8xMnb59Q8hmO5gh9krZwzaPO3X5igBI7JMbxw8Cq4~832lcadsH~Fm5awNpyE~Mxaq~uo5LHF-quL1~fpxDqfiDlNtRgM-ZPowZi-gRBZmkkFeQ-F14l4q5l6iTLX4KNcSb09VECPdehGUjVH~j1ILYyZvdVASIG9-GhZMPs6pOwFgaJTZX5gwdno6MFGycGepzTjVS88ocWgue2wyRns81bH~Dwrgwd7D~1IuD3mFpqE3V5KC6Yi-knLzxMC7eyDfDzqcAY5t~dho6lr8CB0oL5UQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40696,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Powder Sky",
    code: "8045",
    render_id: 609549,
    scenetexturerender_id: "10754",
    colorCode: "#AACDE5",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10754/1d3f5c07_10754.jpg?Expires=1711702788&Signature=etumCtuvNZXHxSqHKOhyVHRcJke4qLTWvP8YozVj6mburXgr5MWbHuEULoFrxQanNuNrAhgeHPF0twnwS9q9AlDrwqkZ3ik~LPNZ-VvGrORyKjUsGS-hgAqztUAex4~qVedR9DbTNSnr9HBq~MYfobpzf--OAdm1EMU7J6sniT3NpTRLbgFF4c-9ny4iFfN7m1~AoqREPP0czcaEOkGrdnohZJ-re8ofWOLZm~ZGy90ML2m~cqMfqBH50tdHh7R6Q4CPGBfQig6FqQsp~vJ5Caq02h3-WnJlQ4P7nbInACKIf1CTfleIuBL69V2JLXiXGI~lAySVw8s79vZfn~9~tw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40597,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Powder Sky",
    code: "8045",
    render_id: 609632,
    scenetexturerender_id: "10837",
    colorCode: "#AACDE5",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10837/e3df794b_10837.jpg?Expires=1711702128&Signature=pIBA-Z0aWcQpufhwsni-gCtJEV6gxxurYk-acfF2vC1TpGLbgaYqh~5Tk5ghZt6pAgWHrglTi99moxb3U0tFBSsq5agp~bNfJPgMnwQCfYFILMgzd~QvAZx-IlURvBv2eyfaq8gITSu8I8eRW0x2zLOp26knlYKVahuSD5rbRpGcbGRADEzBTJeq1~TUOpz1k~j0A0PHDy5t2~nARiEUOTBxhQ8b3rP-TSa~8OoZYL2HN0ht3nO-L~gwh3RHuXCvyijT5o72LYLWiQAifGfNY524TF-5BWIyScSJJY4uZuTrkHJ2gDMGS7PE2tD3MFZzqsKrIy-gyZtYpUeM7PmLXw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40700,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Powder Sky",
    code: "8045",
    render_id: 609524,
    scenetexturerender_id: "10729",
    colorCode: "#AACDE5",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10729/9647bbb7_10729.jpg?Expires=1711702789&Signature=g8n8F8sYFaUXcrWxTxgVbmRfbFQJ3LgsPWRE3JB6~vDdNJsw3WPESgcaXHWdTUXqgDT90PLmhQvNkg~2VR5k2EwSkOoeg5WSmk7fTRJYvEtxVTfIi4D5zTAtVQKqbSeofORY9wYWn6-e~ARAHbT6Ti7bzuUBTj9NeNfXWwLBxU3uQqR1x8LIZkNU1PvOghjLG6w5YtO0Z8mAWsK5hSRU0KjFRwOQMF0qwEvmBNq2VAjY3JStwx8sAUFX~-XATmxWx6UAIyx~iWha0phQU9UsgnbX~rzWoR2~Ia8uD1rXCbjTmrQz3y70DB7ZBSxauwb9M55F5Q14z94I7JVOUptn1g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40572,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Powder Sky",
    code: "8045",
    render_id: 609633,
    scenetexturerender_id: "10838",
    colorCode: "#AACDE5",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10838/5cefe12f_10838.jpg?Expires=1711702128&Signature=pyHNCaJNRNkYQdJHeBVy8TlYYo-9rXTpON6qlL~8q0XGqsDhF0q7eKRRYGEV7KsHQJA1JNCSLI-2i6WRZVYLXKjUXgbUKs5Z9m51OMzH0ZtFP0spOzJOA8X0SLXwDTd9LKlgqXNAkWDfv~fohD1x5WUonoVrpPMTiThZ6UgitmqQPpHr88tAODelQahXEToxyln8tRmUVLfW5XLgAN~j7RI5CvJgHJ81MWtM2qjpehV~x7r~Brv8WPa-PkHs5vW4ZXrYC9czTlqIBuptRXvaUhcQXkhcylRd55T6kciLgZ785WLA88tbeeD83ph-1JtbFE~Q5C-~a7E5EGm7JUrfgg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40701,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Pure Cyan",
    code: "5079",
    render_id: 609488,
    scenetexturerender_id: "10693",
    colorCode: "#8AC4E5",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10693/9c953cbf_10693.jpg?Expires=1711702843&Signature=fop-tHkRZZm~G0wEWoX1C6qGDzPX-dwH4hJO4P6wB~YJ~w3FrNI16MS2FhfRzXrd8FP7aEoNHuTK22rSD1GZDAZe21dQgYy7guSDtpZJXHJDMgwjN8zXAjP8fj47ZntzXOcXHvuiA70oJSzZsffUqu4sF-zno8A70vg7Ql5BoCq-oWNeI21caw5mBoGQK~pFB7R5l4y3ILsLdvDm6~V6payYbRqxyXHNAlWZj7SqiulLm73QAg9Gk6v7~8jq17XkBDoZ2nfTrePQ5gl9EtcFrp5FAr0ZxbacBZ~bCp6nDTfaqTp9h4dCiQbs4VXcIwWLYXbaPRUfBc3tHa8ygykg1A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40535,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Pure Cyan",
    code: "5079",
    render_id: 609634,
    scenetexturerender_id: "10839",
    colorCode: "#8AC4E5",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10839/63c842b9_10839.jpg?Expires=1711702271&Signature=A5baLfCVxwDpm04VUZib~7R96S6IeD4uis2ibjeYQl-LkkCEDc1WG4XWPSI2D1HkbogYsuwvM5EllRs9Pf6ZEnvfzu0ClUJrxKKSpVgcQA9Ms0PMl4usdLcH4SZGF~SMvKgbtz1QdzOCXw1GNNf4hrlYI2zW2-D89Bl-vfeiFIcSMdBArX-1MhCa3wMckLKq3qCsQjeBUv3vrKrHzVbilgU5gp5SDPqvIDjf9wDxS-LtgXl5CI1tBJGhvlUg2I9fnLUborCFiI7yZIE0VxM5zAZ8Sm2DktW7d-kk4JUqCVn78kMvmHsJ2P7uGwc-P5v22QkEWoVexHwrCX-9adEsyA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40702,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Pure Cyan",
    code: "5079",
    render_id: 609461,
    scenetexturerender_id: "10671",
    colorCode: "#8AC4E5",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10671/39ac92b8_10671.jpg?Expires=1711695574&Signature=FQj3Q4MuzPRByppxXbAA8QXJbnc8~mfv9C-BFi4tLUnqcY6j8vR5lQhehG-5fvg4XxiF021HbcNiz824j3lyfeIr6ZK3MgVmEf4n1qP-NeeW1PUDyR5FW8BybEBfCsSOtlENgfAy8FZwwRDcnbe~Ccza3JCsrxIsQjWSKQBiKmjVKgGB4psnq~rjeJ990Boc~a3EycM8H9-SS24eHIMoOvEM2ddIHvA2OxmlsKw1rAXqwt1w0NO~cV8mQtO5VL5dau~u5J-aBiXFit27HaUvphXSL8QZQtU8qGFPUpgzGZNA3gehd9MLWDSK4MvzKbZmkXuEbKtAKrAgpOjBcWsz7w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40614,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Pure Cyan",
    code: "5079",
    render_id: 609498,
    scenetexturerender_id: "10703",
    colorCode: "#8AC4E5",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10703/885fb872_10703.jpg?Expires=1711702676&Signature=DO9NqnXsqSIaNFtyPbeU7lxevjAi9hjdiDwrRQk08opYsbfXbeJWo3j1lXDNvR4nmgRt5b0rjgiETqycgPG1nGyZM3p9SxLiXs~fbE9d80ht8sKak8vgkrHboPOSheH5qQbDWLSBcQVLkASrROmMuYJJe-KqqL2uxAAARofk3wwWaRQ0aiMdzo8YJUcN~4qX2nzl~FpfgJmH77WkJy3NcGKaN3RTPw1BHuJqadZSbclcqEwa43-N6kdNLO8Tk~N3oIAd8W4-1dI~OlhWWFrXGaHZ0TRUGUqcJT6cLxY9sklxHDLHiqUZPbefaZ-S~21yllVUJHjBKRIftNKk4sxY-w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40545,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Pure White",
    code: "RAL 9010",
    render_id: 609493,
    scenetexturerender_id: "10698",
    colorCode: "#F0EEE1",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10698/01dc76ba_10698.jpg?Expires=1711702676&Signature=LAbcdBoezvE5897~XLycsIYq1-3vV8eW~91Vcen0ouJtbMBnkeEnOifIEopfhNmTW-YTNRA4njRQroqZ89nQBVc5aeDGxdGoO2bhhXY29hhw6z-v-nHcoyQXEP9--4lAyI-DYQyKQUOnuXTtUftuqJdw272662pBnbtA17vubwVrjrj-nLZSOXByfX0Ix0FusHMH-wWOOOFvXsXlO5E6Cicyk9yEl-Z5J7DRqlHJeuOrp~lHHzJxnJQMReNxZJr3L1~bJJj2E3jAYhPj1Wk7fkGxacnu8CLeWVzHHRPtOkGFILJK6MWBwQNQVdkWX1op1yqveewGWR6M~v3zaYza6A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40540,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Pure White",
    code: "RAL 9010",
    render_id: 609565,
    scenetexturerender_id: "10770",
    colorCode: "#F0EEE1",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10770/f4081261_10770.jpg?Expires=1711695574&Signature=K6NZAWc6ue0jAfo0Ct8Y69cLMf4st-JuAdVr4qKJPVCcVKmHNZKPKkHyiUHg3al8GiAbEFW4OGuzYInROYA6fD~klMLAby1mBadm5kWLd-RnF25Cjs8pUy6GNx7LJwbCOdzZMC7diq69U1uvtNvz5tFsNgMKHfhdCt7ljmftbs1Sqg3AqQ6DNg6a999H0lR0xOAXgJdH1v~p2e5IJFVp18qhviBTQn8BlnJ7HAwPCSlpF7QusG31~ka~u1i5tGQ~ZPV~Quh0r27tP7HmLayT6gn-8V1mG20qfxbDQs7GB2FOPo9eKBLAfkzfGbQjgHmA8YeF7ttEeDxdgpmwwJTlKw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40633,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Pure White",
    code: "RAL 9010",
    render_id: 609467,
    scenetexturerender_id: "10677",
    colorCode: "#F0EEE1",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10677/010d3ff1_10677.jpg?Expires=1711695574&Signature=h75gkX8jXyNWafepf1fbY0HuwsHhHzOFMp4lAgAMEVTk~M4xpfI-o68YJg-ZmkeXFse-0HdINAQfu3xFSf1mlvgz6pVUfk4P9sIqWKizl0BDSFltiJyrMoaZzYaeKdTuLqK5PPY8dyy1K5KxDtdga6BvfOuNL7YD-gDjBUBhAs-D~rNPdpM6AxlMDARZf6JSsRTC6mmeYYKbtPZ7Vay5ydndOsGL7dL4VYZEgVlwlm-IxYQUqfef-tCA4zzbeWZRTwsXokB2TQq8gnxcXfdGWaVk8HLUvVpRYt9QiRb1oy4G3A6xhkj9yiettLoqiqFTmrMzBadvA1oNa~jpXnqF7Q__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40620,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Pure White",
    code: "RAL 9010",
    render_id: 609532,
    scenetexturerender_id: "10737",
    colorCode: "#F0EEE1",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10737/6946abcf_10737.jpg?Expires=1711702676&Signature=K676gaI0VJYyg5W3b8DEzkxqidCag3Guwgsq5mB8~sBZDMbdR5J1rYKeIDvKnyzVYG7509VzmSS7KJpfvBZaJryrWmb9P5ZeLwRN1CMWEQc~LTHnez-VcSWfEYPKShjBc284h9XFxwo4Tjj7Ff3KnCiQDE57U069dP-K-4MD5rUW5paMd8YQmirYYaJo68BLbP42Eq7pFLaZNaj82ztq20-g1OeEfO3RAteKqQ8fUXMpmgRqmwb4RTeWT53tADEyksHf3Qoz6Hd5EUhkSGNRm~KVTPOnlPusLwTkpdmFsaJgqtrznxU44aDdAbaaXg2zbEmtfUTAfOGUQEp7yM86vw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40580,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Sand Yellow",
    code: "RAL 1002",
    render_id: 609469,
    scenetexturerender_id: "10679",
    colorCode: "#D2B377",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10679/984251b7_10679.jpg?Expires=1711702375&Signature=J0-H4ibUummzk8K9hLq12DkMeLNKPTD1GRmYzLK1kgweWwYBvlOQn2CZTh1iw20QGQvwF4DstYFJyY70tMAewknP9DBKQiqQDujlWLcKSd2mY~yXuhiY8X5MB6SiSkJAjyhLM3eyMPT7wt2aqaTZvOopQ2-Qv25XaFA-iy0lGC2RvwcWbmpus~WYzLT8soMFbvf98-SrusPCX~RJiHbh4gs76N8wRB3BEr0YQwwU7DfyeRe9LNZZC0urMmNWlTVp3LE5ZC6pOcM6DmZfAZ8AZs7Xn3mSS8xh9~X9KzRwGlS8TchIF9kdEj3h0SYJ-3YohjPs4dOdsdPruLfJlc9hKA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40622,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Sand Yellow",
    code: "RAL 1002",
    render_id: 609469,
    scenetexturerender_id: "10651",
    colorCode: "#D2B377",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10679/984251b7_10679.jpg?Expires=1711703024&Signature=VHFwS3kzkiJAO-YCbcW9jttkuEYU2TZh2sEhjNGpmoYTtbZKXR~VwYwnNSRTX6tPeOzrm0MJAQDmtAk6J0~0Jdcazb6dIiCHh0ayBRQmXBAC0Ah24BOwYnL1eR5vGPerZDRhskYI0vBPWcRilV~tDJgFBnIJK83moAJ-OrVkULGOd-8dOd8nYzVejTlOL1HGMiTvBFFJ50hJE1QqiYzLUVY~p6KfS~PT3Tr5ypv2h7Db0ex5R9AiNxnUjvXLtSykPGWdaVJdoNImN4gvrHux6YoAlLAXm-iEBA6H9i8gp908o8OwdeO0LvNOUlmhI4ESuH0TUBhC3~DhlIxrgYuYnQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40622,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Sand Yellow",
    code: "RAL 1002",
    render_id: 609534,
    scenetexturerender_id: "10739",
    colorCode: "#D2B377",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10739/cadf8d74_10739.jpg?Expires=1711702843&Signature=YWehia-LtuFqu0ykjwtVswtQ8eWPA9Cx1oWfbE-uBbBbg4ykf8Bty-tLcVzxXYHhi8iDUPHrkMoUjUBFHXtfPRdZ836pCgnxYXzJ-QljtGZ7mdp69uSeDxkN3pJO5AcMIZHncDKoh4-UeHGSVN6eqUBKTtjim3hdAvm6HkO-btIEFVSfpG0--RV33-MODKZFup~lmprYJyfYcmGplmqt-jy2yuJj7tHw2xyG5SCHhkLQ1EcU7IwiNw8GWu72OSjvBks3aNYs8AaoayCoxlnUuSZg0EDKAB-nZwFfsswUs9jvFG1QP3KqI23-uwJksrS~~x~4weG6A2MbRY9JX6oPkQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40582,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Sand Yellow",
    code: "RAL 1002",
    render_id: 609610,
    scenetexturerender_id: "10815",
    colorCode: "#D2B377",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10815/d48e4944_10815.jpg?Expires=1711702271&Signature=N9qfQ-Vsrl4zJ6d7It8GT2m0uAzcS0O8fb05rq1FIYjjRxdcdFIdRxG~75PU~AE0MweYO5wTjK0l1TyLWgotA7SKiElrUP6IEEOTYf74Q1pu0Yol3uZag9HzL~cUUxzksI36CJzj4U2FcYmMthQ2ObjG08QS-nSab4XS~H~A0hrN7zZSAgnk6ABDX4gmp3C9-rE~AlRxGxDUXx5VTKGJRP2Dii5u-cqeGwVyKXXsQ2I6qlJVo8CPAmFB0gSy~ZmhWHxO12Xp2r1mm~XVLhhnIckZ7oNhoJhACOO9kZk5Ye1r57pKJKx7y3zLKufJfDbeMRNg8L60RuQYaw9n9MySGA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40678,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: WARM,
  },
  {
    name: "Satin Blue",
    code: "0328",
    render_id: 609454,
    scenetexturerender_id: "10664",
    colorCode: "#95C8D9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10664/d654d305_10664.jpg?Expires=1711702932&Signature=w8uW2nVf~2kN0Ddkylgtbu5H7I0H0xWgANhur44i66ho1aFZxqS03dxXnYQNqV2qlJXIHtc1hwFhM0ZUzGp~Iv07xQKSIYpYiuLrJlOqlL-Vy~-AzSDuuYewywsEOf3OgsOc6c1bBnNMK81vhFOVAMFGxHfCJNFVJiygs6e32IBnG3yMfCA73jMQBDUB6tDMoHArMa7tECPeRbo~6NCYgnkDps~hjbhS35LZE6Ct1ROqBh9IDZ~oCtgXKMcHD2Q0szTWFh-B-grKx81-8nM5XtwOzHfEGcIh-b8bm~p1sC3Em6wmTZhCHlAhehtTMT5JuWnhjQ-MSITl8GhP2w8SYQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40526,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Satin Blue",
    code: "0328",
    render_id: 609606,
    scenetexturerender_id: "10811",
    colorCode: "#95C8D9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10811/e90e1508_10811.jpg?Expires=1711702474&Signature=q79JvEx8lAGSOaukg8HYpyqyuctexHwy6orw-4mgmjIFkCohF1k2HTsbtXX9MT0rQ4OdiwwnYG-VLd1l4cOFpQE-TeM8iz-n9Egbzr3C6Kx9f78bPPNIS0V4ZJLDlOOICEst~xaghlvl5K1VWQMtR42pDZLigglOAYdsJCynDx0Pauha7dOFKZoRnqhcI1VfSLH2a8oqpRNjaTqG~8~YKPLt3QGPBV3M~YLxpzD-e8nTNGT7xtrlG2pTnJBsuM0ylVRxDkPJuOVYzq9csvMx3XNh5rvrG30-uDATqU8~v0A0E6DXWbcGbdh-R~T9VQMbJPt2QflTXZzBkh9~dZmo8A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40674,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Satin Blue",
    code: "0328",
    render_id: 609450,
    scenetexturerender_id: "10660",
    colorCode: "#95C8D9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10660/a5790447_10660.jpg?Expires=1711702932&Signature=O-v3lK01mnMBKrrAA11VvKPQ6eU6Uf5M6OzWAmhhrFv6zU1xU4g-f5SRAijGHpKQ7NDQ77FQ9NkJdJKERAwhXrDv8b8HK~Duf~unRk5D0gVPOExEnKb55CbhLJxevnjsBUu8YpN7TY67pBcrxcqpa-b6kkGHspaYX-UsxZh83bE7X1gjzyMmuVseebwy-vsJPf~uxns70D2sbFoAx~1CNa--UE273VN06n4Foo-YQ2kv7Z~epv6jTtIWEeQNC1JAlWf8zTmWyqvJ~7pK4kE5HLKBB-59t1OpGU48hzU3XYbY-IoW13Q2Yjvtc6g5GoWK51pVpwVjjjs4CM9IAnWT~Q__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40522,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Satin Blue",
    code: "0328",
    render_id: 609464,
    scenetexturerender_id: "10674",
    colorCode: "#95C8D9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10674/78335607_10674.jpg?Expires=1711702474&Signature=G4LO7xLZ232Ni45sx4pQlv2HJv77H98sHfgaJfjLHNGK7Wiqvk2aj2nc6SqxTstqdZkn4do6F771tbGAFciQB0G3ZqJ59eMUmu2teFYxmq7gPE22U7Ox8o1PPe2JxwGElZbfOEgoaZx7oiRbzVZ7C601DH-sEt3ougghJX~uFEzV623UUznBIEV5pPQqUG0rcn3KarKA3YqmiZFL2c9OoIJQbVBVEDKfH7Ea-eJee7v8l9SNSiIR1fAmyOsyfQNFqM0sg6RzK-Ox-0nx1zgMCr5HF-QxP~CZ8TpwhqL5MN4sZYetOEJEvSFdtYsb-xpQgwm8cfTw9pgLgG4d02j3hQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40617,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Silk Grey",
    code: "RAL 7044",
    render_id: 609555,
    scenetexturerender_id: "10760",
    colorCode: "#BCB8AD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10760/18b51330_10760.jpg?Expires=1711702844&Signature=GiMhWiCDJtqvVxcn8KSG1VlBPeomHURj4~5HBb-UK~V~vyeUUEwTa~97AN9UO9l2-XzPTY0R3R3gGv2zqj3ApnwuT50terCve8ifiLhp~xYtiC6j9VH67nSwhW5AMxgbqSRFwKIAtqlUdiKdAuYT5V7pGaIQDEYK2VFxK1YezgU3yGBzi2ZtQfdtTVUQS8ABDjZ7lAmXaECcZqZxiyNIjXNxUVYZLADL2ijwI1FBaaqP9y8drtD3gtiQRtuCcuxnpv3r03RyLkEwDeJ~oVXMJkMBaCddXTAjsFqJcANezH16tS1mfcy6ZYfq2oAMXyULGvLZOiZvnVUS1wTYkwzqFQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40603,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Silk Grey",
    code: "RAL 7044",
    render_id: 609582,
    scenetexturerender_id: "10787",
    colorCode: "#BCB8AD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10787/83aabb83_10787.jpg?Expires=1711702271&Signature=wgwYWf~ljqbJzuMdc-hffNKD86tUPQdWhJL~6B3FMS4nFFaum6o8qhAY2~hOWjr8QJ2WmfoWhQf51xbAGvB-nOyVq5VgZ3OBX0XvQ~3gzlyz~Q9AwTjlpqhpkmyJM1A0m2VE2HQ6kYmBJyva2XfNiafqJYTQUQbOMUv6O5nAa2uIew56U7lh3IFni8V~z0Uhk~f1vgJ-WB-wHHXD0jcJwkU6kt3VDBaM6lGlCxf2~zSH4deTc8MVb6gJlAQHaf0b9f2vGJ~ePp6lS8cBkx~6grShvglxLI4V2tDQkQrxhpqShxV0ch6n8RM5ddqMrioGzglWw~sugb~xE3~cKBuEPw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40650,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Silk Grey",
    code: "RAL 7044",
    render_id: 609508,
    scenetexturerender_id: "10713",
    colorCode: "#BCB8AD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10713/363fceb0_10713.jpg?Expires=1711702676&Signature=CH4n2W9NWsIpwHWbQ~dcTXlEfzwmnaTKfFBHJAWf4FbQ4gOgyGUusQtRoM0BIxsU0YQi2v5yEhvDZKefZD2dP8vN2GiExfN6nnHDG1r7S3bxlI2h3gijIGO9t3hTKr5fF3mcFTCR15OfJL-3LMwREm6QtZaLEtfBepnj7DZSWdrMRmdWQXHnS2yp9ir72TA0H~ooB-xQo7vpZyz3Mq2X~JAgFRuVVawbrs71906EvvnSRRy-WlF0e53-e1SjlfdrCnu7dG~KSga3oyWf9fwLTCu~Hi1cYZB~C-M~15Y0-X6GfAMMJU8q0-BrCSQnafBqViUSU~ZV2lbv30O~8hTnHA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40555,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Silk Grey",
    code: "RAL 7044",
    render_id: 609566,
    scenetexturerender_id: "10771",
    colorCode: "#BCB8AD",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10771/368b4cfc_10771.jpg?Expires=1711695574&Signature=QsWJmfCWZmBY2XEYpT3AtwxgxcPSdRMMHnPDZnpIojwfdWBhfWFFjOsW4vyz4aTysRBDmCAuH1qVvmEipOIBFXUx4AKXcUmaQX~9qqQ2KiMO5mMgFg9NdgJ6lDR6UIYDZGndgCw1EY9Yw9DLgxLZfRgLtaFNQoqQn3AyIxJrf4W0C6eP0OaS54iTPZlOLtkLlFpxZJKj0Qw6UAfuBX2Mng2zQmaWXTcYGEtBQ0yjhdtwfbrXkIAM3CLEpyqPCuXDRTARsEOYtbneeUK2osoYgcQIuaiN1-LcIVlG1XEzasA4iKW9Jpp5rG0ldRTkAGnbLQkibSFRw83SHKWaYPTvRQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40634,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "Stone Blue",
    code: "0322",
    render_id: 609581,
    scenetexturerender_id: "10786",
    colorCode: "#87A3BF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10786/7eeaaac5_10786.jpg?Expires=1711702375&Signature=VcxRNVhYvpVQxZfH3b4h2SGIao1-qE5AQKZ8wvhvZDEiI8czUqxCq2~SBH-tvxhRef9hM0iBUb6Id49C8HfnnqXrftaS8xGKhMAKq9RnQ3Jeon6nMD4EdkXhAMFVrY5pVwTWlo1KrKuoEtnVdgxgb6yBylHSus0UMaew53ZmAfnFtd0R0P~dfI2GaFdaWWRAyEz7FKW~OQPY4X1q7~RCpUWpuLw5oiAR4ztHCz-7y-QvW3eryCLjMQgnWudN6Bt9kuMgzV5sCMnzNAEb28sQxfBIL3v7XBndLHP9mRWBLLGiZhFSjlML7TZYw9MJUo11YSlCSGHEzsLbmeJ7uaDyLQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40649,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Stone Blue",
    code: "0322",
    render_id: 609581,
    scenetexturerender_id: "10727",
    colorCode: "#87A3BF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10786/7eeaaac5_10786.jpg?Expires=1711703024&Signature=WpqICCEMF9N1qhZhuYv5wUJY--VZZ4kVDCFySONF-6Bd~DsZXEBYgYg~1OVaM8Igmo4DPWQ5JHzXf8p8T0Ap-CrVNzKEztNdzjtHaUcgNsjHkr-elsI6XKi0q87dETE9nVD4JvLCBPknMyOh0Wa8JhmagNmy4MmzBlWUeoOXwgC4-4C-5msB-sUyZoTU1OEd0s3FdCHetI-Lci09i0kKUm4IjMqPddIPWcXpoTUbcctcMOK4069JvWzTErX4rd82YC54HztXaH6rZYl~-nIfPPiV6GtvQeMcJkN4Gx7~9tErx-dLjZ~KTFf39MbkNIjhx8jnQoZpkxxjnwoje~4s2A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40649,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Stone Blue",
    code: "0322",
    render_id: 609585,
    scenetexturerender_id: "10790",
    colorCode: "#87A3BF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10790/93a38b31_10790.jpg?Expires=1711702375&Signature=JIiUkEmBBssyohZ1vVLR1wvoJchELgfKPEVEEZT-htU6t6mhg0YsH7KPAUGMmK4QwM1-0M~W0itnst9mGFMfxauKrbYGafZBVxxL6Q~Uy6CeVFWRuiTE7drddUXp70RK3fVakUJjosU6dVZ2kZzjRbMlnC4ZlCINzOX3OrkzCNcaEOzeq3S2aTC-jW0Rqoo7MtbSx3ab9x2Uz2j6ljG6MaZy3vuPdIaePKeBTGwYBznTGMctTr-eQhRfqAgZRjJuoX718AdatFQ326U43mk1A~anTqt14GKnKP0T7x4V5JyQpXGcB77L7o6WfghSTI-W~L5nvrWAyiNvHwKMKM3K9A__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40653,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Stone Blue",
    code: "0322",
    render_id: 609585,
    scenetexturerender_id: "10653",
    colorCode: "#87A3BF",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10790/93a38b31_10790.jpg?Expires=1711703024&Signature=J6OJS163pTPMB0iiPkLoj~~CWUeEAuVkQum3jMaUMfp9km0XZqNG3Li5irB7Mixl3oqeoGR133r71in8Rt4WSTTEVUOwJXRAJ6eZUdkE3sknZsOdhv5ZMdWmLWRO4z~fMJonZyfXeqn64Ky15FmR40nNa6vTdb5aYyvw8Em68mcDLVIyBxic-9Tjo5FLPEV4mVluQIQStbeHv5u0gCFm5nqDWj6VXcJ0pLBO4HkobQLPOnfWVw2gsIsWpMIkl2fkbvpw0NJAuYlBVyVb~JYOqV-te8GdpZVRpSHuLnzPi5QnSCFtcFnSKTgUoTBpsWadH4CYiMFWtyMM-SziqLc0-w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40653,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: COOL,
  },
  {
    name: "Summer Tan",
    code: "0354",
    render_id: 609466,
    scenetexturerender_id: "10676",
    colorCode: "#B4A787",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10676/03c7c1c9_10676.jpg?Expires=1711702475&Signature=MAdTsu0Zpv3PCz0Nuw5fHM19OcNVcb2LvFkerxGC5gs7u-mIS4WaslrY8ONxStG-BPneZavRWyzVyXH~Bv7C2xVzYf2zEJfJEClSg~RYwQ5FuDtRs3Au-Dd30Hg26BLm4wGa~EBeLlmQ01N1cJdmo-AyU8Je2Wq9USVpdlvXGMfuPYHTa6ChVejiAbYZLnEXoqsDH6ak2nrjv3HBOpamQVpnt7qAfBZ5zr1MaieoCR0yh5SSMLP7uZ8dp0YdGnGdJo6RfYYuKePv-qDauH4jRCihKydNb0olR8QVzQYUOq64hg3D6nLPKOQ6cjYMaLFxQ0FPp4uSlD20EuEzB2iBzQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40619,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Summer Tan",
    code: "0354",
    render_id: 609530,
    scenetexturerender_id: "10735",
    colorCode: "#B4A787",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10735/9ff8f451_10735.jpg?Expires=1711702932&Signature=2T8i~gTbXUroKnR2OzXOVWVHsOZYZ5ON6G9IoaXZFiyprV~jnBsF8LkBjVUIc6y-fgaMRJB7fvQe1a0Sfh6Coqm~VTHdzgCMQu01GfkG0Zcz~D-WxJVQNFctFQ7BLYXriLu~GjYO9FDqbOCyLlg0oQffzjM3fzDkfVhx1ZVpSA3C3WziuWzmIVZAuP2mnany501UY4Q2~u6p0a29Hkm0rWxGOvscnSv-BQ1p9XOq2wh9db~1GWuNsmBv13k5OM3GWT59GoJafbhRkLl8fQlQuXECw7ayWmdUj~plAZ4V6trj~2z2fkPzFea2P8FYOFcW~WF0npG~jUA~02bLEvAvPQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40578,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Summer Tan",
    code: "0354",
    render_id: 609444,
    scenetexturerender_id: "10654",
    colorCode: "#B4A787",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10654/7d5e1602_10654.jpg?Expires=1711702932&Signature=dTv4G~7m0jUc4PxPtnVIkSfu0sYlAAQPVj3KaUCcWeCyT8uHnCYQih8hX6f--gDt8y6STxevYV1uPhv6qtRs5RZeXln7flb6VkAxDTMr1QUJqTtokYqmAbQQlCP8SxV0RrE~7a0jkX5cu0dK5rYQ7inp6kF9EVGFwF2jIzv3CvIFDqSYNROFppVO7Pt8HToPA~ztGLWTKEzrR9AbwCWTiY3U3rU4BX-1WYmayDviLQcCIqP0mR3J1Wwx7ppAtMIIs~txdKEQnsPbyofLvpttA~IZ91jxejz-z~Yaq22BqcRtLemH-nK9A6MTpmBghFbT8I8fcOMJ~2HocDhswc7WgQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40516,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Summer Tan",
    code: "0354",
    render_id: 609586,
    scenetexturerender_id: "10791",
    colorCode: "#B4A787",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10791/575680fe_10791.jpg?Expires=1711702475&Signature=2HCz9fnOPkd07oXlN5Talh4GW6TA3WOorE0~8LZwvdI7lzU0zocZm8-HGI9DF8T2atZe6V-h7xlH7T1TzzXfd0K49oqSm64onwDx7ugYkeu8EKSQzhOg4KujvXnWvLYN45pILixNIhGb6wyFSrul9kp4cqlKXVxz1frnaDjSIRHaepylv6aRlaNww3sJ3h7bEhKksUlEH70Ud26RwGs~CuuEN31RxKF0TtOQABlAzGm6jJ~rDoGoPmRwABAWKy7XIri47OPcVBxz4BDp6tGdR~BqI1jnNbcVyXXtEm0a3M0ewb907o9kbjnKEEslTfBmTTVfMgMlII-zj3a1hX0JKg__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40654,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Traffic White",
    code: "RAL 9016",
    render_id: 609438,
    scenetexturerender_id: "10648",
    colorCode: "#EDEDE7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10648/4726ee71_10648.jpg?Expires=1711702843&Signature=qz5djR2QLvWedmvEl-aOdhPg1J8ebZVh2pNZU4M~c~i1atc5WQmMSXm51B0LMR~OvY5qb14yN5lFc9Vtj4fpMeT3JYnAgZWpSgEfPsAU66e58ZSJXoM6Nb3f42xzc-QJiQf3PK28qL7l51rowgSpZTiIATxFuSysZoUy~ahn33YcH6gED3mDr6u2y3DMiIzGyTgo03dDigeBMzEx20jAft1Redyf4LrHycodyYS0O60GeQuBN5cNRnsFxG4ea-7wVkcA4pEGJPN-hZJuoEH~3zG32JWq4KgF5xf-kZGgxDMWJZFVptEUxiag4MWCO4l7P2W6WmrzrYtom0B1R3nHVw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40510,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Traffic White",
    code: "RAL 9016",
    render_id: 609576,
    scenetexturerender_id: "10781",
    colorCode: "#EDEDE7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10781/705b63cc_10781.jpg?Expires=1711702271&Signature=vcX4FBDo7Mt8wdy6kojO1ANOYTdYWVC~NVyWzzW2PXgT5xytgKQHpeartnlFJHk4r2bsGFy4UKxmVBgGdo7r6W9mp3SR2rzKR7r9~~waOTYzdTFbg2bHGwdWqIYfVXGZI-w9nuz3Aawp7k3tDdm-vMsexVBgfHfDxY-RADRlU8b7zB2fZdV~BKF7Ms22SLZa4wsOlqB7ScMyneY~vO6uF-Wrbrp7Pc-wmDzJ~36mTo-MOGaPlByDPpKusdsknK4FWZwpLVoW4tck1ELYgdNejvWQO-cmIBSiLCY5uK61DdC3y6N4b15CqDc0sDlEuOX1uCrM~YyHn-Er62kUxrXeNw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40644,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Traffic White",
    code: "RAL 9016",
    render_id: 609504,
    scenetexturerender_id: "10709",
    colorCode: "#EDEDE7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10709/878d558e_10709.jpg?Expires=1711702843&Signature=z56rb79SlcnyeZ9IBRngW9yD1LmkeJfwiKS9SSp4TfMW-NjbkG7V9GF3t-pnbpEpk0nfTzR6LwodGl80BtZpb7J7Xii94kFOzviLdnNPSa~5r~pxVZ-ZRmoKgltFg1Y0ebkFWqx6Me3GrXjyGsIqqJkZrPvuDN4QjtrEVEecdFzDx6lw3B-WiKQsar1RQVhP51XUAN0QlsI0WjswJEPr~wDqpWGyXCDntm21B~k8wWIMqCec~Yws~SpBeuHEg5jVYSTILxWoiB-th~FRzVG7nBpFZ0VeHewC4ME75hJ-dn4dF2QE~CxbXRpINdD7g6O7s0esE81geFi9O2JiRblx4g__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40551,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Traffic White",
    code: "RAL 9016",
    render_id: 609608,
    scenetexturerender_id: "10813",
    colorCode: "#EDEDE7",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10813/18e68216_10813.jpg?Expires=1711702271&Signature=cFw~BwVQCusE9SB1tS0Z0y3GwPdpwH7oHVojT2Mx21zBhdixc4u5WxexBAizg2egogd3r5ZfjBSRjM4CvRaLIaEj~rsqQqjYpIRpugu9dbwg3c~IdxMpflhIKMMZcVqfKzu8BEZWCLfJFqWOR7mmEwG22BcyuKun3N-GjQQe4yu0tIqUsg5VI2MaENvkgGv0e~MdEM01tI5Ml30ww6eoJI6aP4ivgRasCQTNzEL1U~79-5wIIM16IF2UHqIYwkFRaPtav4nIDCmmSyXG-YSkM6mk9TeWD6QDeUvGlh1eWe3M9SXdW6TGU6tknG37lOsZklIkqubO1GS9PEyIpi9v4w__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40676,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Vanilla",
    code: "0446",
    render_id: 609579,
    scenetexturerender_id: "10784",
    colorCode: "#E3CCAA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10784/115e67fb_10784.jpg?Expires=1711702375&Signature=HtOm7brKXeEJWMYPkuBm2NwOTnnI8eLERE67tls43jzy7D4tUk~~4hzFe417xw6iRdwqCggkVRIK0PqnoQcfe~zIbqKPO7dx1-MciNT5jl1Fg5btC7YZ8CWWhyOqlY5tQAXRwRldXfmxR7mxPNLFoEaP09xApTt~7pm0eBm-z7w8PDZTdbB7HS-lGZoV6y9Q5XLFlwjA7V4pOUAgPMIipBWOvqXK5UG1-VOWmE4raGYjWL6MlUiBQzIYahtp7G61WAjJGEzmSm5aqpUNEap8A~bwjQEyKVH25Ad8I7Zp5zRgYEvKd0vYQniMmvXmKnqLWle~IKIKVKRQfo7m96~0hw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40647,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Vanilla",
    code: "0446",
    render_id: 609579,
    scenetexturerender_id: "10725",
    colorCode: "#E3CCAA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10784/115e67fb_10784.jpg?Expires=1711703024&Signature=Homx9YBzriKuOp8Ts1k-xqUwUboFyNVQIqwBjZ1ylbgvPouLeawkfnR6nxrXy4hufyAqjQlQIGmtbunJvlRs28t1XWau5cv7LYoKoueA29Ub4KHOlAmfyTtzwXkbXu-mAsbZ1b6TnALKJ1PxQvQ1ViQwpFwNBdMVnAEHDhlCFJzHKV6EOOynfyPU17EXrOGwe0oAnZOf7XolbfjE9yO5jHy9nTP5RFlQITPz8vnvZ2UPWJrF01w1p5NybF4uTPiS4ICJYUE7LzkQV~k7cTLwASvmO3Z3LX6aN8WFWr3MJ1ik-Y70Sgu5S9jN3qS9QXf3lGsum3UQYem8ZWsIKQ5iYw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40647,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Vanilla",
    code: "0446",
    render_id: 609437,
    scenetexturerender_id: "10647",
    colorCode: "#E3CCAA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10647/fae140b6_10647.jpg?Expires=1711702788&Signature=XiLR-zDaqac9NoNVcJ-12d8Msmgt-wuEG8FabbhEN1dkqe1vVd-uCIEsiSCMtIxXcBwehW1nS57CLGQJpUmDWQruPfwcicr1Z3PCBVuCnI2BHw~tslLgzlwZfx578F8658TCuslQkqa7OFldQCR8i46LPiMyfn9enuL9S0uleRnga7JYvFejuseYEI9K8k-umNURstlN3GvXcrCm49u8hc4c~K6fPQ2ETzMmHsqgetzh4XLc2ZcDBI5vL95bJmmgtxPd4UIIuUmm5NMxMzH3KaaUEJS4Hi4p5aufgZP2ud14TMcrzcizEk-1P5quNhdyGrQsgaHws7~3KcM5jSoKuQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40509,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "Vanilla",
    code: "0446",
    render_id: 609571,
    scenetexturerender_id: "10776",
    colorCode: "#E3CCAA",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10776/e78de122_10776.jpg?Expires=1711702128&Signature=uwNpXqfhqXky~UZ4PadPXuV0P9d9oRKH5cgDJYm63X8Rj3VwR6pd68XHyeMtNNgg7dM2eQyEwfZjQUP2Z505QHkTErVTWI04tX4mRPzGbBE7YW~HwR2XDrF-RnAKeDmeiB-bDR-c3wYxcfugmJ2jXtj99c6gqc6~Icd0yTQvllxdXfFBLnownancyu6lyppjaXIhEJ6wVTEGt0LqxCV5AMYynufIkG7RlvPwtgAdfMjCLqsFD2Lb6dGVicADyfxOpgmqDjPDJORbmcphZi-BMuixw2D8UzvWesv6BBsg5QwRP4iJ9DzLel6e9iP-thbo~73TBbL-BfmHnnzCIWwOUw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40639,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: NEUTRAL,
  },
  {
    name: "White Stone Grey",
    code: "8115",
    render_id: 609531,
    scenetexturerender_id: "10736",
    colorCode: "#B3B8B9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10736/cd7ae591_10736.jpg?Expires=1711702932&Signature=laYmQrOu5qoGFRj15lHGKAAh53TJKOGU4swnSk~PXmRqWvco4hi3ENEUSgxBYeH9J2WrZq1f17jZsV4z~GL0iA6fOkEnfQnvvPOB8HmJ5rzUmuk0D~uv7rnSlyEblsaXerYtIb2FmOiMaxoY0pzvhkTyf8ABRZEs8y~v4Ns9ZFpiR~7znxnpSMiaI1KUJNdxFEnak9m28eQRYaha7D1Ke8PUl-k96kb5P6ObrEHDDdGTKRvdHyjlbysq2~I5FS4rXUupJbzwq1ZXVH~OGbCrqo2a~vOxSzhKo-h5KOxYxJ5GlJ4Khf7PWkPf7jW5fvFim69xxqV~Mv8Hdtma~Qv0CA__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40579,
    hubspotLabelId: "4113",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "White Stone Grey",
    code: "8115",
    render_id: 609602,
    scenetexturerender_id: "10807",
    colorCode: "#B3B8B9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10807/a8a91057_10807.jpg?Expires=1711702475&Signature=Ibm1B7qNLmLryes-Sork9k7YaZzRrmpseNBISB5JhrjxubsM3nDRae2oILSrOlDoj9Ksoa~v-eQ4bszTcmFoOIWYpNGeSuHRrNptPIchtGuB8NyEttZtaCDvnTEgIWiPqtMemZWjwcVAu62pFuj6ht5KNMPaPn44Wpb8tx3HgiSN3wDLk~p349JWoZLno2P1KrdqbWD4iRnKB4Ql6ssuUuJWsPJV5uIHsmdjt1TV~num9cxWi8vTwS~SAHvQYhULyC7uFPDBDIXMYBWGYQ-IZWj2ZuiC2-7~Ug~NLNa0Jr7RmA-o-l5xRKS04SgEUg5RWBj8ZzXfnKi9Qncy-hrcjQ__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40670,
    hubspotLabelId: "4114",
    finishType: GLOSS_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "White Stone Grey",
    code: "8115",
    render_id: 609460,
    scenetexturerender_id: "10670",
    colorCode: "#B3B8B9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4114/10670/22480c3e_10670.jpg?Expires=1711702475&Signature=UcKAqquvq~5gZkWFqneG-ZiIAirqCBkkMb138jUEU2jDcgOQLyC-ITP20i43lERx~jh1mK79RJme3KfcRKPEdtS7luBz344sUdpLQdnPBLwI4iri1RGkR8QpFotse0a6vamCmflAF-tZRTmVPFyi-9~~VKPTBW7Gwar-pfEm7SEoCaOEdMMRHvF2PwcyHfJdFWXXCokxR2xIPhhyKkFz79F4nJkba1YsFqHwP2fhK03VxPo7luOQ0mNM4~80zqksjC~OncCd6Bsw7SkbM40AaS8G4RxE-1VuaC2xFhJMYsStuWrzNsnyJ6b~kiOaqqaZtw4CAzH5rnStWi87AZBuIw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40613,
    hubspotLabelId: "4114",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
  {
    name: "White Stone Grey",
    code: "8115",
    render_id: 609497,
    scenetexturerender_id: "10702",
    colorCode: "#B3B8B9",
    thumb:
      "https://media.imagine.io/media/public/cfg/render_texture_thumbnail/4327/6863/1069/4113/10702/041aee9a_10702.jpg?Expires=1711702932&Signature=ufWEY68Go0HJqo2dPIpiGrvV4olftJ~~eApSkhtqemuZnDdBvD8jKW5okxMLKPr7NwdIEJ9j8sFv0YWqwcMzOQn2RQwI1LwDcR9i~Hej~yJ6WDNXfCBINXaN1gnOWCrP1FNPIYIZBYMQqjOBvq2QI8cPZkIXsMbe-IRR5Pv87jI5~Fs3b7uiblAKGvGVHh3Ymg7NaX6XjQBbKAu6i2nyKZuFygQeQQkKNeCI118QSG7nL0A-MsnErwWHnRHIJaryDN8wb10~s2bZppw5mC0nqvHcjNxQVqK0vn9opchlIL5HuFnmQp85tpxlhY9ERvWu48eaE3Ki6~Bf331~84HDBw__&Key-Pair-Id=K3MIEF79PIHRTH",
    id: 40544,
    hubspotLabelId: "4113",
    finishType: MATT_FINISH,
    finishColorType: COLOURED_FINISH,
    shadeType: GREY,
  },
];
